import moment from 'moment';

import '@advise/genese-initials';

import application from 'application/application';

const controller = 'DefaultController';

import templateMenuBarInbox from '../default/partials/templates/menu-bar-inbox.template.html';
import templateMenuBarStart from '../default/partials/templates/menu-bar-start.template.html';
import templateMenuBarHub from '../default/partials/templates/menu-bar-hub.template.html';

import Quill from 'quill';

import Delta from 'quill-delta';

import angular from 'angular';
import { isNull } from '@uirouter/angularjs';

application.controller(controller, [
	'$rootScope',
	'$scope',
	'$http',
	'$state',
	'$timeout',
	'helper',
	'API',
	'authentication',
	'permissions',
	'integracaoGoogleCalendar',
	'notification',
	'transformDate',
	'$stateParams',
	'$location',
	'$sce',
	(
		$rootScope,
		$scope,
		$http,
		$state,
		$timeout,
		helper,
		API,
		authentication,
		permissions,
		integracaoGoogleCalendar,
		notification,
		transformDate,
		$stateParams,
		$location,
		$sce
	) => {
		$scope.user = authentication;

		$scope.termsUse = [];

		$scope.newCatch = [];

		$scope.systemsDropdownItems = [];

		$scope.searchUserGroupQuery;

		$rootScope.checkIfcontractCourtesy = {};

		$scope.showMoreOptions = false;

		$scope.numeroAtualizadoCliente;

		$scope.userGroups = helper.responseStore();

		$scope.judicialOrgansModal = helper.responseStore();

		$scope.systemJudicialModal = helper.responseStore();

		$scope.allowedGroup = localStorage.getItem('_allowedGroup_');

		$scope.statusUserOab = JSON.parse(localStorage.getItem('__dataOabUser__'));

		$scope.userData = JSON.parse(
			localStorage.getItem('__authenticationUserData__')
		);

		$scope.messageCertificadoDigital =
			'<div class="font-weight-normal" style="width: 160px;"> <br/> Esta plataforma exige um <br/> Certificado Digital do tipo A1 <br/> para autenticar transações. <br/> Utilize o campo abaixo para <br/> realizar o upload do arquivo.</div>';

		$scope.tipoAcessoFonte = [];

		$scope.stageCertificate = 0;

		$scope.inputType1 = 'password';
		$scope.hasProcessPermissions = false;

		// list of agendas
		$scope.agendas = helper.responseStore();

		// list of event types
		$scope.eventsTypes = helper.responseStore();
		$scope.eventCategories = helper.responseStore();
		$scope.eventsNotifications = helper.responseStore();
		$scope.eventsPeoples = helper.responseStore();
		$scope.eventCategoriesLoaded = false;
		$scope.eventCategoriesLoading = false;
		$scope.eventCategoriesLoadFailed = false;
		$scope.eventCategoriesOpen = false;
		$scope.eventCategorySearch = { term: '' };
		$scope.filteredEventCategories = [];
		$scope.eventCategoryTarget = 'create';
		$scope.categoryPendingDeletionId = null;
		$scope.deletingEventCategoryId = null;
		$scope.newEventCategory = {
			nome: '',
			corCategoria: '#2d2d2d'
		};
		$scope.eventCategoryColorPalette = [
			'#EF9A9A',
			'#F48FB1',
			'#CE93D8',
			'#B39DDB',
			'#9FA8DA',
			'#90CAF9',
			'#81D4FA',
			'#80DEEA',
			'#80CBC4',
			'#A5D6A7',
			'#C5E1A5',
			'#E6EE9C',
			'#FFF59D',
			'#FFE082',
			'#FFCC80',
			'#FFAB91',
			'#BCAAA4',
			'#EEEEEE',
			'#B0BEC5',
			'#2d2d2d'
		];
		$scope.eventCategoryColorPickerOpen = false;

		$scope.showAgain = integracaoGoogleCalendar.notAgainSincGoogleAgenda()
			? false
			: true;

		$rootScope.formCreatePrazo = {
			eventsTypes: [],
			eventCategories: $scope.eventCategories,
			eventsNotifications: [],
			eventsPeoples: [],
			idsMovProcessosVinculados: [],
			idPessoaCliente: '',
			getEventComponent: () => {},
			reloadRecordEvents: () => {},
			taskToEdit: {
				_hora: '',
				diaInteiro: '',
				processo: {},
				idPessoaCliente: ''
			},
			editingAgendaEvent: {
				processo: {}
			},
			modalOpen: undefined,
			importante: false,
			idNotificacaoCompromisso: -1
		};

		$scope.groupUserSelected = localStorage.getItem('__groupSelected__');
		$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));
		if ($scope.groupUserSelected == null || $scope.groupUserSelected == 'false')
			$scope.groupUserSelected = false;

		$scope.notificationList = [];

		$scope.announcementTagColors = {
			manutencao: '#b0bec5',
			publicidade: '#e6ee9c',
			melhoria: '#90caf9',
			outros: '#bcaaa4'
		};

		$scope.announcementList = [];

		$scope.notificationLoading = false;
		$scope.announcementLoading = false;

		$rootScope.canRequestNotification = true;
		$rootScope.canRequestAnnouncement = true;

		$scope.hasNotificationRequest = false;
		$scope.hasAnnouncementRequest = false;
		$scope.scrollTopValue = 0;

		$scope.notificationNotes = {
			numberOfUnreadedNotifications: 0,
			unreadedNotificationsText: '0',
			hasUnreadedNotifications: false,
			hasUnreadedAnnouncements: false
		};

		$scope.notificationSelected = true;

		$scope.contactPhone = '';
		$scope.contactPhoneSaving = false;

		$scope.showTooltipHelper = false;
		$scope.tooltipHelperStyle = {};
		$scope.tooltipHelperNotification = {};

		$scope.blockPaginationGroupSelect = false;

		$scope.modalRegisterOABStep = 'oab-busca'; // oab-busca, oab-sucesso, oab-sucesso-multiplos, oab-nao-encontrado, oab-nao-validado, oab-limite-de-consulta, oab-buscando-processos, oab-falha-ao-concluir
		$scope.modalRegisterOABSubStepData = {
			title: 'Titulo',
			description: 'Descrição',
			confirmButtonText: '',
			cancelButtonText: '',
			confirmButtonClass: 'btn-primary',
			cancelButtonClass: 'btn-secondary',
			confirmFunction: () => {},
			cancelFunction: () => {}
		};

		$scope.oabUserData = {
			numeroOab: '',
			ufOab: ''
		};
		$scope.registerOab = {
			numeroOab: '',
			ufOab: '',
			idUfOab: ''
		};
		$scope.registerOabTopBarInfo = {
			numeroOab: '',
			ufOab: ''
		};

		$scope.registerOabLoading = false;

		$scope.ufOab = [];
		$scope.consultaOabCnaData = {};
		$scope.consultaOabCnaDataItens = [];

		$scope.intervalo = null;
		$scope.mostrarMensagemCalculosNovo = false;
		$scope.mostrarMensagemGeradorIaNovo = false;
		$scope.ocultarMensagemGeradorIaNestaSessao = false;

		$scope.paymentRememberType = 'deadline-soon'; // 'deadline-soon' / 'deadline-expired'

		$rootScope.selectedPaymentRemember = 0;
		$rootScope.paymentRememberData = [];

		$scope.templates = {
			'-1': templateMenuBarInbox,
			'-2': templateMenuBarStart,
			'-3': templateMenuBarHub
		};

		$scope.onInit = () => {
			setTimeout(() => {
				$scope.handleMessagesButtonNext('null');
			}, 500);
			setTimeout(() => {
				$rootScope.initVerifyModalSearch();
			}, 2000);
			setTimeout(() => {
				$scope.timeTarja();
			}, 10000);
			setTimeout(() => {
				$scope.callFetchNotReadNotifications();
			}, 300000);

			$('.modal-backdrop').hide();

			if ($stateParams.orgaoJudicial) {
				$scope.recordJudicialBranches(
					$scope.clientUserJudicialOrgansList,
					'total'
				);
			}

			$scope.findProcess();

			$scope.checkNewModuleWarningGeradorIa();
			$scope.updateNotificationNumber();
			$scope.eventSeasonCampaignPeriod();
			$scope.handleMessagesButtonNext('null');
			$scope.fetchOabRequirements();

			$rootScope.fetchDeadlineNotificationId();
			$rootScope.verifyTerms();
		};

		$rootScope.checkPopupNotification = () => {
			const showPaymentReminder = sessionStorage.getItem(
				'__show_payment_reminder__'
			);

			if (showPaymentReminder && showPaymentReminder == 'true') {
				const paramsSearch = {
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null,
					idUsuarioCliente:
						!$scope.groupUserSelected && $scope.userData
							? $scope.userData.idUsuarioCliente
							: null,
					idSituacaoNotificacao: 'Ativo',
					idTipoNotificacao: 'Notificacao',
					paginaAtual: 1,
					registrosPorPagina: 50,
					exibirPopUp: true
				};

				$http({
					...helper.http(API.defaultNotification, 'GET'),
					method: 'GET',
					params: paramsSearch
				})
					.then(response => {
						let responseItens = [];

						if (response && response.data && response.data.itens)
							responseItens = response.data.itens;

						let hoje = new Date();
						let ano = hoje.getFullYear();
						let mes = ('0' + (hoje.getMonth() + 1)).slice(-2);
						let dia = ('0' + hoje.getDate()).slice(-2);
						let dataAtual = ano + '-' + mes + '-' + dia;

						responseItens = responseItens.filter(item => {
							if (!item.dataHoraInclusao) return false;

							var dataItem = item.dataHoraInclusao.substring(0, 10);

							return dataItem === dataAtual;
						});

						let textoLembrete =
							'(Se você já pagou, desconsidere esse lembrete)';
						let defaultUrl = $rootScope.getUrlCentralPagamentos();

						if (responseItens && responseItens.length > 0) {
							for (var i = 0; i < responseItens.length; i++) {
								var item = responseItens[i];

								if (
									item.descricao &&
									item.descricao.indexOf(textoLembrete) !== -1
								) {
									item.descricao = item.descricao
										.replace(textoLembrete, '')
										.trim();
									item.lembreteBoleto = true;
								}

								if (!item.linkRedirecionamento) {
									item.linkRedirecionamento = defaultUrl;
								}
							}
						}

						$rootScope.paymentRememberData = responseItens;
					})
					.finally(() => {
						setTimeout(() => {
							if (
								$rootScope.paymentRememberData &&
								$rootScope.paymentRememberData.length > 0
							) {
								$rootScope.openModalPaymentRemember();
							} else {
								sessionStorage.setItem('__hide_payment_reminder__', 'true');
								sessionStorage.setItem('__show_payment_reminder__', 'false');

								$rootScope.initVerifyModalSearch();
							}
						}, 5000);
					});
			} else {
				sessionStorage.setItem('__hide_payment_reminder__', 'true');
				sessionStorage.setItem('__show_payment_reminder__', 'false');

				$rootScope.initVerifyModalSearch();
			}
		};

		$scope.setTooltipHelper = notification => {
			let element = $('#not-read-icon-' + notification.id)[0];

			let offsetFix = 63;

			if ($rootScope.attentionMsg) {
				offsetFix = 111;
			}

			let elementOffsetTop = element.getBoundingClientRect().top - offsetFix;

			$scope.tooltipHelperNotification = notification;

			$scope.showTooltipHelper = true;
			$scope.tooltipHelperStyle = {
				position: 'absolute',
				top: elementOffsetTop + 'px',
				left: element.offsetLeft + 'px',
				backgroundColor: '#1e88e5',
				height: '8px',
				width: '8px',
				zIndex: 2000,
				borderRadius: '4px',
				cursor: 'pointer'
			};
		};

		$scope.hideTooltipHelper = () => {
			$scope.showTooltipHelper = false;
			$scope.tooltipHelperStyle = {};
			$scope.tooltipHelperNotification = {};
		};

		$scope.fetchNotification = (idTipoNotificacao = 'Notificacao') => {
			$scope.scrollTopValue = 0;
			$scope.updateScrollHeight();

			if (idTipoNotificacao == 'Aviso' && $scope.groupUserSelected) {
				$scope.notificationSelected = true;

				return;
			}

			if (idTipoNotificacao == 'Notificacao') {
				if ($scope.notificationLoading) {
					return;
				}
				$scope.notificationLoading = true;
			}

			if (idTipoNotificacao == 'Aviso') {
				if ($scope.announcementLoading) {
					return;
				}
				$scope.announcementLoading = true;
			}

			let unreadedNotifications = 0;

			for (let item in $scope.notificationList) {
				if (!$scope.notificationList[item].flLido) {
					unreadedNotifications += 1;
				}
			}
			for (let item in $scope.announcementList) {
				if (!$scope.announcementList[item].flLido) {
					unreadedNotifications += 1;
				}
			}

			if (
				$scope.notificationNotes.numberOfUnreadedNotifications >
					unreadedNotifications &&
				!$scope.notificationLoading &&
				!$scope.announcementLoading
			) {
				$rootScope.canRequestNotification = true;
				$rootScope.canRequestAnnouncement = true;
			}

			if (
				idTipoNotificacao == 'Notificacao' &&
				!$rootScope.canRequestNotification
			) {
				$scope.notificationLoading = false;

				return;
			}

			if (idTipoNotificacao == 'Aviso' && !$rootScope.canRequestAnnouncement) {
				$scope.announcementLoading = false;

				return;
			}

			const paramsSearch = {
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null,
				idUsuarioCliente: !$scope.groupUserSelected
					? $scope.userData.idUsuarioCliente
					: null,
				idSituacaoNotificacao: 'Ativo',
				idTipoNotificacao: idTipoNotificacao,
				paginaAtual: 1,
				registrosPorPagina: 10
			};

			$http({
				...helper.http(API.defaultNotification, 'GET'),
				method: 'GET',
				params: paramsSearch
			})
				.then(response => {
					if (idTipoNotificacao == 'Notificacao') {
						$scope.notificationPage = response.data.paginacao;
						let notificationItems = [];

						$scope.notificationNotes.hasUnreadedNotifications = false;

						for (let item in response.data.itens) {
							let notification = response.data.itens[item];

							const index = notificationItems.findIndex(
								item => item.id === notification.id
							);

							if (index === -1) {
								notification.dataHoraInclusao = new Date(
									notification.dataHoraInclusao
								);
								notificationItems.push(notification);
							}
						}
						$scope.notificationList = notificationItems;
						$rootScope.canRequestNotification = false;
					}

					if (idTipoNotificacao == 'Aviso') {
						$scope.announcementPage = response.data.paginacao;
						let announcementItems = [];

						for (let item in response.data.itens) {
							let announcement = response.data.itens[item];

							const index = announcementItems.findIndex(
								item => item.id === announcement.id
							);

							if (index === -1) {
								$scope.notificationNotes.hasUnreadedAnnouncements = false;

								announcement.dataHoraInclusao = new Date(
									announcement.dataHoraInclusao
								);
								switch (announcement.nomeCategoriaNotificacao) {
									case 'Manutenção':
										announcement.tagColor =
											$scope.announcementTagColors.manutencao;
										break;
									case 'Publicidade':
										announcement.tagColor =
											$scope.announcementTagColors.publicidade;
										break;
									case 'Melhoria':
										announcement.tagColor =
											$scope.announcementTagColors.melhoria;
										break;
									default:
										announcement.tagColor = $scope.announcementTagColors.outros;
										break;
								}

								if (announcement.corHexadecimal) {
									announcement.tagColor = announcement.corHexadecimal;
								}

								announcementItems.push(announcement);
							}
						}
						$scope.announcementList = announcementItems;
						$rootScope.canRequestAnnouncement = false;
					}

					$scope.checkSubmenuNotification();
				})
				.finally(() => {
					if (idTipoNotificacao == 'Notificacao') {
						$scope.notificationLoading = false;
					}
					if (idTipoNotificacao == 'Aviso') {
						$scope.announcementLoading = false;
					}

					setTimeout(() => {
						$scope.addListenerToScroll();
					}, 100);

					setTimeout(() => {
						$rootScope.canRequestNotification = true;
						$rootScope.canRequestAnnouncement = true;
					}, 60000);
				});
		};

		$scope.addListenerToScroll = () => {
			const notificationScroll = document.getElementById('notification-scroll');
			const announcementScroll = document.getElementById('announcement-scroll');

			if (notificationScroll && $scope.notificationList.length > 0) {
				if (
					notificationScroll.scrollHeight -
						(notificationScroll.scrollTop + 2) <=
					notificationScroll.clientHeight
				) {
					if (
						$scope.notificationSelected &&
						$scope.notificationPage.paginaAtual <
							$scope.notificationPage.paginaTotal &&
						!$scope.hasNotificationRequest
					) {
						$scope.scrollTopValue = notificationScroll.scrollTop;
						$scope.hasNotificationRequest = true;
						$scope.fetchNotificationNextPage('Notificacao');
					}
				}

				notificationScroll.addEventListener('scroll', () => {
					if (
						notificationScroll.scrollHeight -
							(notificationScroll.scrollTop + 2) <=
						notificationScroll.clientHeight
					) {
						if (
							$scope.notificationSelected &&
							$scope.notificationPage.paginaAtual <
								$scope.notificationPage.paginaTotal &&
							!$scope.hasNotificationRequest
						) {
							$scope.scrollTopValue = notificationScroll.scrollTop;
							$scope.hasNotificationRequest = true;
							$scope.fetchNotificationNextPage('Notificacao');
						}
					}
				});
			}

			if (announcementScroll && $scope.announcementList.length > 0) {
				if (
					announcementScroll.scrollHeight -
						(announcementScroll.scrollTop + 2) <=
					announcementScroll.clientHeight
				) {
					if (
						!$scope.notificationSelected &&
						$scope.announcementPage.paginaAtual <
							$scope.announcementPage.paginaTotal &&
						!$scope.hasAnnouncementRequest
					) {
						$scope.scrollTopValue = announcementScroll.scrollTop;
						$scope.hasAnnouncementRequest = true;
						$scope.fetchNotificationNextPage('Aviso');
					}
				}

				announcementScroll.addEventListener('scroll', () => {
					if (
						announcementScroll.scrollHeight -
							(announcementScroll.scrollTop + 2) <=
						announcementScroll.clientHeight
					) {
						if (
							!$scope.notificationSelected &&
							$scope.announcementPage.paginaAtual <
								$scope.announcementPage.paginaTotal &&
							!$scope.hasAnnouncementRequest
						) {
							$scope.scrollTopValue = announcementScroll.scrollTop;
							$scope.hasAnnouncementRequest = true;
							$scope.fetchNotificationNextPage('Aviso');
						}
					}
				});
			}
		};

		$scope.updateScrollHeight = (addValue = 0) => {
			const notificationScroll = document.getElementById('notification-scroll');
			const announcementScroll = document.getElementById('announcement-scroll');

			if (notificationScroll && $scope.notificationList.length > 0) {
				notificationScroll.scrollTop = $scope.scrollTopValue + addValue;
			}

			if (announcementScroll && $scope.announcementList.length > 0) {
				announcementScroll.scrollTop = $scope.scrollTopValue + addValue;
			}
		};

		$scope.fetchNotificationNextPage = (idTipoNotificacao = 'Notificacao') => {
			if (idTipoNotificacao == 'Aviso' && $scope.groupUserSelected) {
				$scope.notificationSelected = true;

				return;
			}

			let paginaAtual = 1;

			if (idTipoNotificacao == 'Notificacao') {
				$scope.hasNotificationRequest = true;
				paginaAtual = $scope.notificationPage.paginaAtual + 1;
			}
			if (idTipoNotificacao == 'Aviso') {
				$scope.hasAnnouncementRequest = true;
				paginaAtual = $scope.announcementPage.paginaAtual + 1;
			}

			if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
				$rootScope.$apply();
			}

			$scope.updateScrollHeight(34);

			const paramsSearch = {
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null,
				idUsuarioCliente: !$scope.groupUserSelected
					? $scope.userData.idUsuarioCliente
					: null,
				idSituacaoNotificacao: 'Ativo',
				idTipoNotificacao: idTipoNotificacao,
				paginaAtual,
				registrosPorPagina: 10
			};

			$http({
				...helper.http(API.defaultNotification, 'GET'),
				method: 'GET',
				params: paramsSearch
			})
				.then(response => {
					if (idTipoNotificacao == 'Notificacao') {
						$scope.notificationPage = response.data.paginacao;
						let notificationItems = $scope.notificationList;

						$scope.notificationNotes.hasUnreadedNotifications = false;

						for (let item in response.data.itens) {
							let notification = response.data.itens[item];

							const index = notificationItems.findIndex(
								item => item.id === notification.id
							);

							if (index === -1) {
								notification.dataHoraInclusao = new Date(
									notification.dataHoraInclusao
								);
								notificationItems.push(notification);
							}
						}
						$scope.notificationList = notificationItems;
						$rootScope.canRequestNotification = false;
					}

					if (idTipoNotificacao == 'Aviso') {
						$scope.announcementPage = response.data.paginacao;
						let announcementItems = $scope.announcementList;

						for (let item in response.data.itens) {
							let announcement = response.data.itens[item];

							const index = announcementItems.findIndex(
								item => item.id === announcement.id
							);

							if (index === -1) {
								$scope.notificationNotes.hasUnreadedAnnouncements = false;

								announcement.dataHoraInclusao = new Date(
									announcement.dataHoraInclusao
								);
								switch (announcement.nomeCategoriaNotificacao) {
									case 'Manutenção':
										announcement.tagColor =
											$scope.announcementTagColors.manutencao;
										break;
									case 'Publicidade':
										announcement.tagColor =
											$scope.announcementTagColors.publicidade;
										break;
									case 'Melhoria':
										announcement.tagColor =
											$scope.announcementTagColors.melhoria;
										break;
									default:
										announcement.tagColor = $scope.announcementTagColors.outros;
										break;
								}

								if (announcement.corHexadecimal) {
									announcement.tagColor = announcement.corHexadecimal;
								}
								announcementItems.push(announcement);
							}
						}
						$scope.announcementList = announcementItems;
						$rootScope.canRequestAnnouncement = false;
					}

					$scope.checkSubmenuNotification();
				})
				.finally(() => {
					if (idTipoNotificacao == 'Notificacao') {
						$scope.hasNotificationRequest = false;
					}
					if (idTipoNotificacao == 'Aviso') {
						$scope.hasAnnouncementRequest = false;
					}

					setTimeout(() => {
						$scope.updateScrollHeight();
					}, 100);

					const notificationScroll = document.getElementById(
						'notification-scroll'
					);
					const announcementScroll = document.getElementById(
						'announcement-scroll'
					);

					if (notificationScroll && $scope.notificationList.length > 0) {
						if (
							notificationScroll.scrollHeight -
								(notificationScroll.scrollTop + 2) <=
							notificationScroll.clientHeight
						) {
							if (
								$scope.notificationSelected &&
								$scope.notificationPage.paginaAtual <
									$scope.notificationPage.paginaTotal &&
								!$scope.hasNotificationRequest
							) {
								$scope.scrollTopValue = notificationScroll.scrollTop;
								$scope.hasNotificationRequest = true;
								$scope.fetchNotificationNextPage('Notificacao');
							}
						}
					}

					if (announcementScroll && $scope.announcementList.length > 0) {
						if (
							announcementScroll.scrollHeight -
								(announcementScroll.scrollTop + 2) <=
							announcementScroll.clientHeight
						) {
							if (
								!$scope.notificationSelected &&
								$scope.announcementPage.paginaAtual <
									$scope.announcementPage.paginaTotal &&
								!$scope.hasAnnouncementRequest
							) {
								$scope.scrollTopValue = announcementScroll.scrollTop;
								$scope.hasAnnouncementRequest = true;
								$scope.fetchNotificationNextPage('Aviso');
							}
						}
					}
				});
		};

		$scope.checkSubmenuNotification = () => {
			$scope.notificationNotes.hasUnreadedNotifications = false;

			for (let item in $scope.notificationList) {
				if (!$scope.notificationList[item].flLido) {
					$scope.notificationNotes.hasUnreadedNotifications = true;
				}
			}
			$scope.notificationNotes.hasUnreadedAnnouncements = false;

			for (let item in $scope.announcementList) {
				if (!$scope.announcementList[item].flLido) {
					$scope.notificationNotes.hasUnreadedAnnouncements = true;
				}
			}
		};

		$scope.fetchNotReadNotifications = () => {
			let numberOfUnreadedNotifications = 0;
			let unreadedNotificationsText = '0';

			const paramsSearch = {
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null,
				idUsuarioCliente:
					!$scope.groupUserSelected && $scope.userData
						? $scope.userData.idUsuarioCliente
						: null
			};

			$http({
				...helper.http(API.defaultNotification, 'getNotRead'),
				method: 'GET',
				params: paramsSearch
			})
				.then(response => {
					if (response.data && response.data.itens && response.data.itens[0]) {
						numberOfUnreadedNotifications =
							response.data.itens[0].notificacoesNaoLidas;

						if (numberOfUnreadedNotifications > 9) {
							unreadedNotificationsText = '9+';
						} else {
							unreadedNotificationsText = numberOfUnreadedNotifications;
						}
					}
				})
				.finally(() => {
					$scope.notificationNotes.numberOfUnreadedNotifications = numberOfUnreadedNotifications;
					$scope.notificationNotes.unreadedNotificationsText = unreadedNotificationsText;
				});
		};

		$scope.callFetchNotReadNotifications = () => {
			$scope.fetchNotReadNotifications();

			$rootScope.canRequestNotification = true;
			$rootScope.canRequestAnnouncement = true;

			$scope.fetchNotification('Notificacao');
			$scope.fetchNotification('Aviso');

			setTimeout(() => {
				$scope.callFetchNotReadNotifications();
			}, 300000);
		};

		$scope.changeNotificationSubmenu = submenu => {
			switch (submenu) {
				case 'notification':
					$scope.notificationSelected = true;
					break;
				case 'announcement':
					$scope.notificationSelected = false;
					break;
			}

			setTimeout(() => {
				$scope.addListenerToScroll();
			}, 100);
		};

		$scope.getAnnouncementDescription = announcementText => {
			let newText = '';

			if (
				announcementText.contains('<') &&
				announcementText.contains('/') &&
				announcementText.contains('>')
			) {
				const splittedText = announcementText.trim().split('>');

				splittedText.forEach(item => {
					let tempItem = item;

					if (tempItem.contains('class="')) {
						const splittedClassText = tempItem.split('class="');

						tempItem =
							splittedClassText[0] +
							'class="clickout-notification ' +
							splittedClassText[1];
					}

					if (tempItem != '') {
						if (
							tempItem.contains('<') &&
							!tempItem.contains('/') &&
							!tempItem.contains('class=')
						) {
							newText += tempItem + ' class="clickout-notification">';
						} else {
							newText += tempItem + '>';
						}
					}
				});
			} else {
				newText = announcementText;
			}

			return $sce.trustAsHtml(
				'<span class="clickout-notification">' + newText + '</span>'
			);
		};

		$scope.sanitizeEmojiFlags = html => {
			if (!html) return '';

			return $sce.trustAsHtml(html);
		};

		$scope.markNotificationAsRead = notification => {
			if (notification.flLido) {
				return;
			}

			let data = {
				itens: [
					{
						id: notification.id,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						idUsuarioCliente: !$scope.groupUserSelected
							? $scope.userData.idUsuarioCliente
							: null,
						idTipoNotificacao:
							notification.idTipoNotificacao == -1 ? 'Notificacao' : 'Aviso'
					}
				]
			};

			$http({
				...helper.http(API.defaultNotification, 'putMarkAsRead'),
				method: 'PUT',
				data: data
			}).finally(() => {
				notification.flLido = true;
				$scope.updateNotificationNumber();
				$scope.checkSubmenuNotification();

				$scope.showTooltipHelper = false;
				$scope.tooltipHelperStyle = {};
				$scope.tooltipHelperNotification = {};
			});
		};

		$scope.deleteItemInSubmenu = (submenu, notification) => {
			let data = {
				itens: [
					{
						id: notification.id,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						idUsuarioCliente: !$scope.groupUserSelected
							? $scope.userData.idUsuarioCliente
							: null
					}
				]
			};

			$http({
				...helper.http(API.defaultNotification, 'putDeleteNotification'),
				method: 'PUT',
				data: data
			}).finally(() => {
				notification.flLido = true;

				switch (submenu) {
					case 'notification':
						$('#submenu-card-' + notification.id).addClass(' slide-out-left');
						$('#submenu-card-m-' + notification.id).addClass(' slide-out-left');

						setTimeout(() => {
							const tempNotificationArray = $scope.notificationList.filter(
								item => item.id !== notification.id
							);

							$scope.notificationList = tempNotificationArray;

							if (
								$rootScope.$$phase !== '$apply' &&
								$rootScope.$$phase !== '$digest'
							) {
								$rootScope.$apply();
							}
						}, 500);

						break;
					case 'announcement':
						$('#submenu-card-' + notification.id).addClass(' slide-out-left');
						$('#submenu-card-m-' + notification.id).addClass(' slide-out-left');

						setTimeout(() => {
							const tempAnnouncementArray = $scope.announcementList.filter(
								item => item.id !== notification.id
							);

							$scope.announcementList = tempAnnouncementArray;

							if (
								$rootScope.$$phase !== '$apply' &&
								$rootScope.$$phase !== '$digest'
							) {
								$rootScope.$apply();
							}
						}, 500);

						break;
				}
				$scope.updateNotificationNumber();
				$scope.checkSubmenuNotification();
			});
		};

		$scope.clearAllItemsInSubmenu = () => {
			let submenu = 'notification';

			if (!$scope.notificationSelected) {
				submenu = 'announcement';
			}

			let data = {
				itens: [
					{
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						idUsuarioCliente: !$scope.groupUserSelected
							? $scope.userData.idUsuarioCliente
							: null,
						idTipoNotificacao:
							submenu == 'notification' ? 'Notificacao' : 'Aviso'
					}
				]
			};

			$http({
				...helper.http(API.defaultNotification, 'putDeleteAll'),
				method: 'PUT',
				data: data
			}).finally(() => {
				switch (submenu) {
					case 'notification':
						for (let notification in $scope.notificationList) {
							setTimeout(() => {
								const notificationId = $scope.notificationList[notification].id;

								$('#submenu-card-' + notificationId).addClass(
									' slide-out-left'
								);
								$('#submenu-card-m-' + notificationId).addClass(
									' slide-out-left'
								);

								setTimeout(() => {
									const tempNotificationArray = $scope.notificationList.filter(
										item => item.id !== notificationId
									);

									$scope.notificationList = tempNotificationArray;

									if (
										$rootScope.$$phase !== '$apply' &&
										$rootScope.$$phase !== '$digest'
									) {
										$rootScope.$apply();
									}
								}, 500);
							}, (400 / $scope.notificationList.length) * notification);
						}

						break;
					case 'announcement':
						for (let announcement in $scope.announcementList) {
							setTimeout(() => {
								const announcementId = $scope.announcementList[announcement].id;

								$('#submenu-card-' + announcementId).addClass(
									' slide-out-left'
								);
								$('#submenu-card-m-' + announcementId).addClass(
									' slide-out-left'
								);

								setTimeout(() => {
									const tempAnnouncementArray = $scope.announcementList.filter(
										item => item.id !== announcementId
									);

									$scope.announcementList = tempAnnouncementArray;

									if (
										$rootScope.$$phase !== '$apply' &&
										$rootScope.$$phase !== '$digest'
									) {
										$rootScope.$apply();
									}
								}, 500);
							}, (400 / $scope.announcementList.length) * announcement);
						}
						break;
				}
				$scope.updateNotificationNumber();
				$scope.checkSubmenuNotification();
			});
		};

		$scope.checkOabImport = notification => {
			let allowScreenChange = true;

			if (
				notification &&
				notification.descricao &&
				notification.descricao.contains('nenhum processo ativo foi encontrado')
			) {
				allowScreenChange = false;
			}

			if (
				notification &&
				notification.idPesqProcOABXParamUsCliente &&
				allowScreenChange
			) {
				$state.go('root.default.addProcessesOab', {
					id: notification.idPesqProcOABXParamUsCliente
				});
			}
		};

		$scope.getNameModalEdit = () => {
			let id = $rootScope.formCreatePrazo.editingAgendaEvent.idTipoCompromisso;

			if (!id) return 'Evento';

			const event =
				$rootScope.formCreatePrazo.eventsTypes.items &&
				$rootScope.formCreatePrazo.eventsTypes.items.length &&
				$rootScope.formCreatePrazo.eventsTypes.items.find(
					item => item.id === id
				);

			return event ? event.nome : 'Evento';
		};

		$scope.getNameModal = () => {
			let id = $rootScope.formCreatePrazo.taskToEdit.idTipoCompromisso;

			if (!id) return 'Evento';

			const event =
				$rootScope.formCreatePrazo.eventsTypes.items &&
				$rootScope.formCreatePrazo.eventsTypes.items.length &&
				$rootScope.formCreatePrazo.eventsTypes.items.find(
					item => item.id === id
				);

			return event ? event.nome : 'Evento';
		};

		$scope.openScheduleEventInNewTab = appointment => {
			const eventId =
				appointment && (appointment.idEventoAgenda || appointment.id);

			if (!eventId) return;

			return $http({
				...helper.http(API.deadlineEvents, 'GET'),
				params: {
					ids: eventId,
					ativo: true,
					paginaAtual: 1,
					registrosPorPagina: 10,
					campos: '*',
					ordenacao: '-diaInteiro,+dataHoraInicio'
				}
			}).then(response => {
				const { itens = [] } = response.data;

				if (!itens[0]) return;

				localStorage.setItem(
					'__FORCE_OPEN_DETAILS__',
					JSON.stringify(itens[0])
				);

				const url = $state.href(
					'root.default.module-schedule',
					{},
					{
						absolute: true,
						inherit: false
					}
				);

				window.open(url, '_blank', 'noopener,noreferrer');
			});
		};

		$scope.goToLink = (url, newTab, notificationEvent) => {
			if (notificationEvent && notificationEvent.idEventoAgenda) {
				$http({
					...helper.http(API.deadlineEvents, 'GET'),
					params: {
						ids: notificationEvent.idEventoAgenda,
						idTipoNotificacao: 'Notificacao',
						ativo: true,
						paginaAtual: 1,
						registrosPorPagina: 10,
						campos: '*',
						ordenacao: '-diaInteiro,+dataHoraInicio'
					},
					messageOverride: {
						success() {},
						error() {}
					}
				}).then(response => {
					const { itens = [] } = response.data;

					if (itens && itens[0]) {
						sessionStorage.setItem(
							'__FORCE_OPEN_DETAILS__',
							JSON.stringify(itens[0])
						);

						$state.go(
							'root.default.module-schedule',
							{},
							{
								reload: true,
								inherit: false
							}
						);

						setTimeout(() => {
							$rootScope.handleSubMenuNotification();
						}, 100);
					} else {
						notification.danger('Este evento não está mais disponível.');
					}
				});

				return;
			}

			if (url) {
				if (url.includes('pagamentos')) {
					const token = localStorage.getItem('__authenticationToken__');

					let newUrl = url + 'access_token?=Bearer ' + token;

					if (newUrl) {
						$('<a>')
							.attr({
								target: '_blank',
								href: newUrl
							})[0]
							.click();
					}
				} else {
					// Para abrir em nova guia
					if (newTab) window.open(url, '_blank');
					else window.location.href = url;
				}
			}
		};

		$scope.updateNotificationNumber = () => {
			$scope.fetchNotReadNotifications();

			$(document).on('click', function(e) {
				const modal = document.getElementById('modal-notification');

				if (modal !== null) {
					if (
						window.getComputedStyle(modal).display !== 'none' &&
						window.getComputedStyle(modal).visibility !== 'hidden' &&
						!e.target.className.includes('clickout-notification')
					) {
						$rootScope.handleSubMenuNotification();
					}
				}
			});
		};

		$scope.eventSeasonCampaignPeriod = () => {
			$rootScope.configCampaign = {
				active: false
			};

			// Temporizador de propaganda Black November
			let hoje = moment();
			let inicio = moment('2025-04-28').startOf('day');
			let fim = moment('2025-05-28').endOf('day');

			if (hoje.isBetween(inicio, fim, 'day', '[]')) {
				$rootScope.configCampaign.active = true;
			} else $rootScope.configCampaign.active = false;
		};

		$(window).on('popstate', function() {
			if ($('#modalRegistrationUpdate').hasClass('show')) {
				history.pushState(null, null, null);
			} else if ($('#modalRegistrationUpdate2').hasClass('show')) {
				history.pushState(null, null, null);
			} else if ($('#modalRegistrationUpdate3').hasClass('show')) {
				history.pushState(null, null, null);
			}
		});

		$scope.lembrarMaisTarde = () => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			if (dataParameterUsers) {
				var method = 'PUT';
				var params = {
					id: dataParameterUsers.idParamUsuarioProdAdv,
					atualizarFone: false
				};
			} else {
				var method = 'POST';
				var params = {
					atualizarFone: false
				};
			}

			$http({
				...helper.http(API.parametersUsers, method),
				data: {
					itens: [params]
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Você será lembrado mais tarde!');
					}
				}
			}).finally(() => {
				$('#modalRegistrationUpdate').modal('hide');
				$('#modalRegistrationUpdate2').modal('hide');

				setTimeout(() => {
					$rootScope.initVerifyModalSearch();
				}, 2000);
			});
		};

		$scope.updatePhone = () => {
			$('#modalRegistrationUpdate').modal('hide');
			$('#modalRegistrationUpdate2').modal('show');

			history.pushState(null, null, null);

			$('#modalRegistrationUpdate2').on('shown.bs.modal', function() {
				$('#updatePhoneClient1').focus();
			});

			$http({
				...helper.http(API.usersCustomers, 'GET'),
				params: {
					...helper.httpFields([
						'emailUsuario',
						'pessoa.nome',
						'pessoa.cpfcnpj'
					]),
					IDs: authentication.getUserData('idUsuarioCliente')
				}
			}).then(async ({ data }) => {
				$scope.dadosUserClient = data.itens[0];
			});
		};

		$rootScope.openModalPaymentRemember = () => {
			sessionStorage.setItem('__show_payment_reminder__', 'true');

			$('#modalPaymentRemember').css('display', 'flex');
			$('#modalPaymentRemember').css('bottom', '-600px');

			setTimeout(() => {
				$('#modalPaymentRemember').css('bottom', '40px');
			}, 1000);

			setTimeout(() => {
				$rootScope.exitModalPaymentRemember();
			}, 60000);
		};

		$rootScope.exitModalPaymentRemember = () => {
			sessionStorage.setItem('__hide_payment_reminder__', 'true');
			sessionStorage.setItem('__show_payment_reminder__', 'false');

			$('#modalPaymentRemember').css('bottom', '-480px');
			setTimeout(() => {
				$('#modalPaymentRemember').css('display', 'none');
			}, 1000);

			$rootScope.initVerifyModalSearch();
		};

		$rootScope.paymentRememberChangePage = (direction = 'next') => {
			switch (direction) {
				case 'next':
					if (
						$rootScope.selectedPaymentRemember ==
						$rootScope.paymentRememberData.length - 1
					) {
						$rootScope.selectedPaymentRemember = 0;
					} else {
						$rootScope.selectedPaymentRemember++;
					}
					break;
				case 'previous':
					if ($rootScope.selectedPaymentRemember == 0) {
						$rootScope.selectedPaymentRemember =
							$rootScope.paymentRememberData.length - 1;
					} else {
						$rootScope.selectedPaymentRemember--;
					}
					break;
			}
		};

		$rootScope.openPaymentLink = (link, selected) => {
			const token = localStorage.getItem('__authenticationToken__');
			// let url = $rootScope.getUrlCentralPagamentos();
			// let newUrl = url + 'access_token?=Bearer ' + token;

			let newUrl = link + 'access_token?=Bearer ' + token;

			if (newUrl) {
				$('<a>')
					.attr({
						target: '_blank',
						href: newUrl
					})[0]
					.click();
			}

			if (
				$rootScope.paymentRememberData &&
				$rootScope.paymentRememberData.length > 0 &&
				selected >= 0
			) {
				$rootScope.paymentRememberData.splice(selected, 1);
			}

			if (
				$rootScope.paymentRememberData &&
				$rootScope.paymentRememberData.length > 0
			) {
				$rootScope.selectedPaymentRemember = 0;
			} else {
				$rootScope.exitModalPaymentRemember();
			}
		};

		$scope.updatePhoneUserClient = (number, id) => {
			if (number.length < 16) {
				$('#' + id).removeClass('is-valid');
				$('#' + id).addClass('is-invalid');

				return;
			} else {
				$http({
					...helper.http(API.usersCustomers, 'PUT'),
					data: {
						itens: [
							{
								id: $scope.dadosUserClient.id,
								pessoa: {
									id: $scope.dadosUserClient.pessoa.id,
									cpfcnpj: $scope.dadosUserClient.pessoa.cpfcnpj,
									fone1: number
								}
							}
						]
					},
					messageOverride: {
						success(response, notify) {
							notify.success('Atualizado com sucesso!');
						}
					}
				}).finally(() => {
					$('#modalRegistrationUpdate').modal('hide');
					$('#modalRegistrationUpdate2').modal('hide');
					$('#modalRegistrationUpdate3').modal('hide');

					setTimeout(() => {
						$rootScope.initVerifyModalSearch();
					}, 2000);
				});

				const userParamsSession = sessionStorage.getItem('parametros-usuarios');

				let dataParameterUsers = null;

				if (
					userParamsSession &&
					userParamsSession != undefined &&
					userParamsSession != 'undefined'
				) {
					dataParameterUsers = JSON.parse(userParamsSession);
				}

				if (dataParameterUsers) {
					var method = 'PUT';
					var params = {
						id: dataParameterUsers.idParamUsuarioProdAdv,
						atualizarFone: false
					};
				} else {
					var method = 'POST';
					var params = {
						atualizarFone: false
					};
				}
				$http({
					...helper.http(API.parametersUsers, method),
					data: {
						itens: [params]
					},
					messageOverride: {
						success() {}
					}
				});
			}
		};

		$scope.requiredInputTelefone = (phone, id) => {
			if (phone) {
				if (phone.length < 16) {
					$('#' + id).removeClass('is-valid');
					$('#' + id).addClass('is-invalid');
					$('#' + id).removeClass('focus-updatePhone_input');
					$('#atualizar1').removeClass('focus-updatePhone');
					$('#atualizar2').removeClass('focus-updatePhone');
				} else if (phone.length > 15) {
					$('#' + id).removeClass('is-invalid');
					$('#' + id).addClass('is-valid');
					$('#' + id).addClass('focus-updatePhone_input');
					$('#atualizar1').addClass('focus-updatePhone');
					$('#atualizar2').addClass('focus-updatePhone');
				}
			} else {
				$('#' + id).removeClass('is-valid');
				$('#' + id).addClass('is-invalid');
				$('#' + id).removeClass('focus-updatePhone_input');
				$('#atualizar1').removeClass('focus-updatePhone');
				$('#atualizar2').removeClass('focus-updatePhone');
			}
		};

		$scope.definedPhoneClient = id => {
			$scope.controlId = '#' + id;

			if ($($scope.controlId).val().length == 1) {
				$('#' + id).val('+55 ' + $($scope.controlId).val());
			} else if ($($scope.controlId).val() == '+55') {
				$($scope.controlId).val('+55 ');
			}

			let formatted = $($scope.controlId)
				.val()
				.replace('+55 ', '')
				.replace(/\D/g, '');

			if (formatted.indexOf(' ') > 0) {
				formatted = formatted.replace('+55 ', '').replace(/\D/g, '');
			} else if (formatted.length == 13 && formatted.substr(0, 2) === '55') {
				formatted = formatted.replace('55', '').replace(/\D/g, '');
			}

			if (formatted.length < 11) {
				formatted = formatted.replace(/^(\d{2})(\d)/g, '$1 $2');
				formatted = formatted.replace(/(\d)(\d{4})$/, '$1-$2');
			} else {
				formatted = formatted.replace(
					/^(\d{2})(\d)(\d*)(\d{4})/g,
					'$1 $2 $3-$4'
				);
			}

			$scope.numeroAtualizadoCliente =
				formatted.length > 0 ? '+55 ' + formatted : '+55 ';

			$scope.requiredInputTelefone($scope.numeroAtualizadoCliente, id);
		};

		if ($scope.statusUserOab) {
			$scope.statusUserOab.diasFaltantes = Math.abs(
				$scope.statusUserOab.diasFaltantes
			);
		}

		$scope.validaUserOab = () => {
			if (!$scope.statusUserOab)
				$http({
					...helper.http(API.consultaOabRj, 'GET'),
					messageOverride: {
						error(response, notification) {
							notification.danger($scope.message);
						}
					}
				}).then(async ({ data }) => {
					localStorage.setItem(
						'__dataOabUser__',
						JSON.stringify(data.itens[0])
					);

					$scope.statusUserOab = data.itens[0];

					if ($scope.statusUserOab.diasFaltantes)
						$scope.statusUserOab.diasFaltantes = Math.abs(
							$scope.statusUserOab.diasFaltantes
						);
				});
		};

		//VOLTAR NA PROXIMA SPRINT
		// if ($scope.statusUserOab == null) $scope.validaUserOab();

		permissions.loadPermissions().then(() => {
			$rootScope.userPermissions = permissions;

			// Rejeitar requisição desnecessaria
			// if (!$location.$$url.split('?')[0].includes('processos')) return; // Comentado por motivos referentes a Feature 159169

			if (permissions.has('createMovements')) {
				$scope.recordFoundProcesses();
				$scope.hasProcessPermissions = true;
			}

			if (permissions.has('createContactList')) {
				$scope.hasPersonPermissions = true;
			}

			if (permissions.has('oabQuickRegister')) {
				localStorage.setItem('__mostrarCadastroAgil__', true);

				$http({
					...helper.http(API.cadastroAgil, 'fetchNotifications'),
					params: {
						listaSitPesqProcOABXParamUsCliente: '-1,-2,-7'
					},
					method: 'GET'
				}).then(response => {
					if (
						response &&
						response.data &&
						response.data.itens &&
						response.data.itens[0] &&
						response.data.itens[0].oabs &&
						response.data.itens[0].oabs.length
					) {
						let oabs = response.data.itens[0].oabs;
						let oabsUnicas = [];
						let oabsMap = {};

						for (let oab of oabs) {
							let key = `${oab.numeroOab}/${oab.siglaUfOab}`;

							if (!oabsMap[key]) {
								oabsMap[key] = true;
								oabsUnicas.push(oab);
							}
						}

						let message = '';
						let firstOab = true;

						for (let oabMessage of oabsUnicas) {
							let { numeroOab, siglaUfOab } = oabMessage;

							if (!firstOab) {
								message += ', ';
							}
							message += `${numeroOab}/${siglaUfOab}`;
							firstOab = false;
						}

						if (message.contains(',')) {
							message = 'OABs ' + message;
						} else {
							message = 'OAB ' + message;
						}

						$rootScope.quickRegisterOabMessage = message;

						if (!firstOab) {
							if ($scope.banners && $scope.banners.length) {
								$scope.banners.splice(1, 0, 'sucessoCadastroAgilOab');
							}

							$scope.showBannerNavigation = Boolean(
								$scope.banners && $scope.banners.length > 1
							);

							$scope.handleMessagesButtonNext('null');
						}
					}
				});
			} else {
				localStorage.setItem('__mostrarCadastroAgil__', false);
			}
		});

		$scope.findProcess = () => {
			if (!$stateParams.pasta || $scope.groupUserSelected) return;

			$http({
				...helper.http(API.briefcase, 'GET'),
				method: 'GET',
				params: {
					...helper.httpFields(['id', 'nome', 'idProcesso']),
					ids: $stateParams.pasta,
					registrosPorPagina: 1,
					paginaAtual: 1,
					IdGrupoUsuarios: $scope.groupData && $scope.groupData.idGrupo
				}
			}).then(response => {
				$scope.processSelected = response.data.itens || [];

				const process = $scope.processSelected.length
					? $scope.processSelected[0]
					: null;

				if (
					process &&
					$rootScope.formCreatePrazo &&
					$rootScope.formCreatePrazo.taskToEdit
				) {
					const task = $rootScope.formCreatePrazo.taskToEdit;

					if (!task.processo) {
						task.processo = {};
					}

					task.processo.id =
						$stateParams.processo || process.idProcesso || task.processo.id;
					task.processo.pasta = $stateParams.pasta || process.id;
					task.processo.nome = process.nome;
				}

				if (
					process &&
					$rootScope.formCreatePrazo &&
					$rootScope.formCreatePrazo.editingAgendaEvent
				) {
					const task = $rootScope.formCreatePrazo.editingAgendaEvent;

					if (!task.processo) {
						task.processo = {};
					}

					task.processo.id =
						$stateParams.processo || process.idProcesso || task.processo.id;
					task.processo.pasta = $stateParams.pasta || process.id;
					task.processo.nome = process.nome;
				}
			});
		};

		$rootScope.getMovementsState = () => {
			let url = $location.$$url.split('?')[0];
			let environment = 'root.default.movements.list';
			let number = null;

			switch (url) {
				case '/movimentacoes/publicacoes/pastas':
					number = '3';
					break;
				case '/movimentacoes/publicacoes':
					number = '2';
					break;
				case '/movimentacoes/processos/pastas':
					number = '4';
					break;
				case '/movimentacoes/todas-conta':
					number = '1';
					break;
				case '/movimentacoes/lixeira':
					number = '5';
					break;
				default:
					break;
			}

			if (!number)
				['1', '2', '3', '4'].forEach(item => {
					if (
						$state.includes(
							`root.default.movements.list${item}.movementsDetails`
						)
					)
						environment = environment + item + '.movementsDetails';
					else if (
						$state.includes(`root.default.movements.list${item}.details`)
					)
						environment = environment + item + '.details';
				});
			else environment = environment + number;

			return environment;
		};

		// Função para validar uma string Base64 como imagem
		function isValidBase64Image(base64String) {
			const validPrefixes = [
				'data:image/png;base64,',
				'data:image/jpeg;base64,',
				'data:image/gif;base64,'
			];

			// Verifica se a string começa com um prefixo válido
			const isPrefixValid = validPrefixes.some(prefix =>
				base64String.startsWith(prefix)
			);

			if (!isPrefixValid) {
				return false;
			}

			// Extrai o conteúdo Base64 após o prefixo
			const base64Content = base64String.split(',')[1];

			// Valida o conteúdo Base64 (caracteres válidos + padding)
			const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;

			if (!base64Regex.test(base64Content)) {
				return false;
			}

			// Decodifica e valida a imagem
			try {
				const img = new Image();

				img.src = base64String;

				return new Promise(resolve => {
					img.onload = () => resolve(true);
					img.onerror = () => resolve(false);
				});
			} catch (error) {
				return false;
			}
		}

		// Função para criar uma imagem padrão
		function createDefaultImage(nameArr) {
			if (!nameArr) return null;

			return {
				light: $(document.createElement('img'))
					.initial({
						name:
							nameArr.length === 1
								? nameArr[0]
								: `${nameArr[0]} ${nameArr[nameArr.length - 1]}`,
						height: 40,
						width: 40,
						fontSize: 16,
						seed: 5,
						textColor: '#000000',
						backgroundColor: 'rgba(0, 0, 0, .12)',
						radius: 40
					})
					.attr('src'),
				dark: $(document.createElement('img'))
					.initial({
						name:
							nameArr.length === 1
								? nameArr[0]
								: `${nameArr[0]} ${nameArr[nameArr.length - 1]}`,
						height: 40,
						width: 40,
						fontSize: 16,
						seed: 5,
						textColor: '#ffffff',
						backgroundColor: 'rgba(255, 255, 255, .16)',
						radius: 40
					})
					.attr('src')
			};
		}

		// Recupera a imagem salva no localStorage
		const storedImage = localStorage.getItem('__authenticationUserImage__');

		// Verifica se a imagem salva no localStorage é inválida
		if (!storedImage || storedImage === 'undefined' || storedImage === '') {
			const nameArr =
				($scope.user &&
					$scope.user.getUserData('nome') &&
					$scope.user.getUserData('nome').split(' ')) ||
				null;

			const defaultImage = createDefaultImage(nameArr);

			if (defaultImage) {
				$rootScope.userImage = { default: defaultImage };
				$rootScope.groupImage = $rootScope.userImage;
			}
		} else {
			const base64Image = `data:image/png;base64,${storedImage.trim()}`;

			isValidBase64Image(base64Image).then(isValid => {
				if (isValid) {
					$rootScope.userImage = { avatar: base64Image };
					$rootScope.groupImage = $rootScope.userImage;
				} else {
					const nameArr =
						($scope.user &&
							$scope.user.getUserData('nome') &&
							$scope.user.getUserData('nome').split(' ')) ||
						null;

					const defaultImage = createDefaultImage(nameArr);

					if (defaultImage) {
						$rootScope.userImage = { default: defaultImage };
						$rootScope.groupImage = $rootScope.userImage;
					}
				}
			});
		}

		$scope.groupSelected = localStorage.getItem('__groupSelected__') || 'false';

		$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));

		if ($scope.groupSelected != 'false' && $scope.groupSelected != undefined) {
			let nameArr = $scope.groupData.nomeGrupo.split(' ');

			$rootScope.groupImage = {
				default: {
					light: $(document.createElement('img'))
						.initial({
							name:
								nameArr.length == 1
									? nameArr[0]
									: `${nameArr[0]} ${nameArr[nameArr.length - 1]}`,
							height: 40,
							width: 40,
							fontSize: 16,
							seed: 5,
							textColor: '#000000',
							backgroundColor: 'rgba(0, 0, 0, .12)',
							radius: 40
						})
						.attr('src'),
					dark: $(document.createElement('img'))
						.initial({
							name:
								nameArr.length == 1
									? nameArr[0]
									: `${nameArr[0]} ${nameArr[nameArr.length - 1]}`,
							height: 40,
							width: 40,
							fontSize: 16,
							seed: 5,
							textColor: '#ffffff',
							backgroundColor: 'rgba(255, 255, 255, .16)',
							radius: 40
						})
						.attr('src')
				}
			};
		}

		let checkGroup = localStorage.getItem('__hasGroup__');

		$rootScope.haveGroup = checkGroup && checkGroup == 'true' ? true : false;

		if (checkGroup === null) {
			$http({
				...helper.http(API.customers, 'GET'),
				params: {
					...helper.httpFields(['possuiGrupo']),
					IDs: authentication.getUserData('idCliente')
				}
			}).then(response => {
				$rootScope.haveGroup = response.data.itens[0].possuiGrupo;

				if (response.data.itens[0].possuiGrupo) {
					$http({
						...helper.http(API.groupUsers, 'GET'),
						params: {
							...helper.httpFields([
								'ListaUsuariosGrupo.IdUsuarioXGrupo, ListaUsuariosGrupo.IdUsuarioCliente, ListaUsuariosGrupo.Ativo'
							]),
							IdsSituacaoGrupoUsuario: [-1],
							paginaAtual: 1,
							registrosPorPagina: 100
						}
					}).then(res => {
						const usersList = res.data.itens[0].listaUsuariosGrupo || [];

						let idUserClient = null;

						try {
							const auth = JSON.parse(
								localStorage.getItem('__authenticationUserData__')
							);

							idUserClient = auth.idUsuarioCliente || null;
						} catch (e) {
							// se o JSON estiver inválido, fica null mesmo
						}

						const groupList = usersList.filter(
							user =>
								user.ativo === true && user.idUsuarioCliente == idUserClient
						);

						$rootScope.haveGroup = groupList.length > 0;
						localStorage.setItem(
							'__hasGroup__',
							JSON.stringify($rootScope.haveGroup)
						);
					});
				} else {
					$rootScope.haveGroup = false;

					localStorage.setItem('__hasGroup__', $rootScope.haveGroup);
				}
			});
		}

		/** @TODO: Descrever.*/
		$scope.$state = $state;

		/** Assina para os templates uma instância de `Date` no momento da renderização deste controller. */
		$scope.renderDate = new Date();

		/** @TODO: Descrever.*/
		$scope.signIn = () => {
			let auth = {
				username: document.getElementById('inputLoginEmail').value,
				password: document.getElementById('inputLoginPassword').value
			};

			auth['access_type'] = '94be650011cf412ca906fc335f615cdc';
			auth['grant_type'] = 'password';

			$http({
				...helper.http(API.login, 'POST'),
				data: auth
			}).then(response => {
				if (response.config.data.username !== $rootScope.prevUserLogged.email) {
					$rootScope.removeAllStorageInfo();

					location.reload();
				}

				transformDate.formatDate(response.data.expires_in);

				authentication.signIn(response.data, () =>
					$('#modalQuickLogin').modal('hide')
				);

				permissions.loadPermissions().then(() => {
					$rootScope.userPermissions = permissions;
				});
			});
		};

		/***/
		$scope.emptyPublicationsDeadline = {};

		/***/
		$scope.openModelCreatePublicationsDeadline = publication => {
			$scope.emptyPublicationsDeadline.publicacaoID = publication.id;

			$scope.emptyPublicationsDeadlineTarget = publication;

			$('#modalCreatePublicationsDeadline').modal('show');
		};

		/***/

		/** INÍCIO DAS FUNÇÕES DE GRUPO */

		/** Verificação de processos na central de busca */
		$scope.currentMessage = '';
		$scope.oldMessage = '';
		$rootScope.hasCampaign = false;

		if ($rootScope.hasCampaign) $rootScope.attentionMsg = true;

		$scope.handleMessagesButtonNext = (direction = 'next') => {
			const _attentionMsg = localStorage.getItem('_attentionMsg');

			if (_attentionMsg === 'false') return;

			const info = {
				seasonCampaign: 'specialCampaign',
				tarja: $scope.currentMessage,
				oab: $scope.statusUserOab,
				oabID: $scope.statusUserOab ? $scope.statusUserOab.id : null,
				proc: $scope.foundProcesses,
				msgNot: $scope.attentionMsgNotCourtesy
			};

			// Na primeira vez que executar, vai definir os banners que podem ser mostrados
			if (!($scope.banners && $scope.banners.length > 0)) {
				$scope.banners = [];

				$scope.showBannerNavigation = false;
			}
			if (
				info.oab &&
				info.oab.diasFaltantes &&
				!$scope.banners.includes('oabJovem')
			) {
				$scope.banners.push('oabJovem');
			}
			if (
				info.oabID &&
				info.oabID != '-16' &&
				info.oab.diasFaltantes &&
				!$scope.banners.includes('oabNotice')
			) {
				$scope.banners.push('oabNotice');
			}
			if (info.proc > 0 && !$scope.banners.includes('process')) {
				$scope.banners.push('process');
			}
			if (
				!info.msgNot &&
				$rootScope.checkIfcontractCourtesy &&
				$rootScope.checkIfcontractCourtesy.cortesia &&
				!$scope.banners.includes('payment')
			) {
				$scope.banners.push('payment');
			}
			if (
				!$scope.banners.includes('specialCampaign') &&
				$rootScope.configCampaign &&
				$rootScope.configCampaign.active
			) {
				$scope.banners.push('specialCampaign');
				$scope.currentMessage = 'specialCampaign';
			}
			if ($scope.quickRegisterOabMessage && direction === 'null') {
				$scope.currentMessage = 'sucessoCadastroAgilOab';

				if (!$scope.banners.includes('sucessoCadastroAgilOab'))
					$scope.banners.push('sucessoCadastroAgilOab');
			}

			$scope.showBannerNavigation = $scope.banners && $scope.banners.length > 1;
			$rootScope.attentionMsg = $scope.banners && $scope.banners.length > 0;

			// Após a primeira execução, ele verifica se vai para o próximo banner, ou anterior.
			let currentIndex = $scope.banners.indexOf($scope.currentMessage);

			if (direction === 'next') {
				currentIndex = (currentIndex + 1) % $scope.banners.length;
			}
			if (direction === 'previous') {
				currentIndex =
					(currentIndex - 1 + $scope.banners.length) % $scope.banners.length;
			}

			if (currentIndex >= 0)
				$scope.currentMessage = $scope.banners[currentIndex];
			else if (
				currentIndex == -1 &&
				!$scope.currentMessage &&
				$scope.banners &&
				$scope.banners.length
			) {
				$scope.currentMessage = $scope.banners[0];
			}

			if ($scope.$$phase !== '$apply' && $scope.$$phase !== '$digest') {
				$scope.$apply();
			}
		};

		$scope.timeTarja = () => {
			const meuBotao = document.getElementById('clickoutCampanhaButton');

			if (!meuBotao) {
				return;
			}

			const alerts = document.getElementById('alerts-container');

			function alternarTarjaAtiva() {
				$scope.handleMessagesButtonNext('next');
				$scope.$apply();
			}

			if ($rootScope.attentionMsg) {
				if ($scope.intervalo) {
					clearInterval($scope.intervalo);
				}

				$scope.intervalo = setInterval(alternarTarjaAtiva, 10000);
			}

			if (alerts) {
				alerts.addEventListener('mouseenter', function() {
					if ($scope.intervalo) {
						clearInterval($scope.intervalo);
					}
				});

				alerts.addEventListener('mouseleave', function() {
					if ($scope.intervalo) {
						clearInterval($scope.intervalo);
					}

					if (!$scope.modalForm && $rootScope.attentionMsg) {
						$scope.intervalo = setInterval(alternarTarjaAtiva, 10000);
					}
				});
			}
		};

		$scope.closeTarja = () => {
			$rootScope.handleCloseAlert();

			setTimeout(() => {
				$scope.timeTarja();
			}, 20000);
		};

		$scope.clearTarja = () => {
			clearInterval($scope.intervalo);
		};

		$scope.recordFoundProcesses = async () => {
			$http({
				...helper.http(API.foundProcesses, 'total'),
				params: {
					IdsSituacaoPesquisa: '-6',
					IdGrupoUsuarios:
						$scope.groupSelected != 'false' &&
						$scope.groupSelected != undefined &&
						$scope.groupData
							? $scope.groupData.idGrupo
							: null
				}
			}).then(({ data }) => {
				const total = data.itens[0].total;

				if (localStorage.getItem('_attentionMsg')) return;

				$rootScope.foundProcesses = (total[0] && total[0].total) || 0;

				if (total[0] && total[0].total > 0) {
					// $scope.currentMessage = 'process';
					$rootScope.attentionMsg = true;

					if (!$scope.banners.includes('process')) {
						$scope.banners.push('process');
					}

					if ($scope.banners.length > 0) {
						$scope.showBannerNavigation = true;

						if (
							$rootScope.$$phase !== '$apply' &&
							$rootScope.$$phase !== '$digest'
						) {
							$rootScope.$apply();
						}

						$scope.handleMessagesButtonNext('null');
					}
				}
			});
		};

		$scope.currentGroupPage = 1;
		$scope.totalGroupPages = 1;
		$scope.totalGroupRegisters = 0;

		$scope.openModalUserGroup = () => {
			$scope.currentGroupPage = 1;
			$scope.totalGroupPages = 1;
			$scope.totalGroupRegisters = 0;

			$scope.recordGroupsUser().then(() => {
				if ($rootScope.haveGroup) $('#modalUserGroup').modal('show');
			});
		};

		$scope.nextGroupPage = () => {
			$scope.blockPaginationGroupSelect = true;
			if ($scope.currentGroupPage < $scope.totalGroupPages) {
				$scope.currentGroupPage++;

				$scope.recordGroupsUser();
			}
		};
		$scope.firstGroupPage = () => {
			$scope.blockPaginationGroupSelect = true;
			$scope.currentGroupPage = 1;

			$scope.recordGroupsUser();
		};

		$scope.prevGroupPage = () => {
			$scope.blockPaginationGroupSelect = true;
			if ($scope.currentGroupPage > 1) $scope.currentGroupPage--;

			$scope.recordGroupsUser();
		};

		$scope.lastGroupPage = () => {
			$scope.blockPaginationGroupSelect = true;
			$scope.currentGroupPage = $scope.totalGroupPages;

			$scope.recordGroupsUser();
		};

		$scope.searchUserGroup = async () => {
			let inputSearch = document.getElementById(
				'inlineFormInputUserGroupSearch'
			);

			if ($scope.nameGroupSearch) {
				if (inputSearch.value.length >= 0 && inputSearch.value.length < 301) {
					$scope.blockPaginationGroupSelect = true;
					await $scope.recordGroupsUser(1);
				}
			} else {
				if (inputSearch.value.length >= 3 && inputSearch.value.length < 301) {
					$scope.blockPaginationGroupSelect = true;
					await $scope.recordGroupsUser(1);
				}
			}
		};

		$scope.validateInput = event => {
			$scope.callValidate = false;
			let inputSearch = document.getElementById(
				'inlineFormInputUserGroupSearch'
			);

			if (
				inputSearch.value.length < 3 &&
				event != 'blur' &&
				inputSearch.value != ''
			) {
				inputSearch.classList.add('search__input-invalid');
			} else if (
				inputSearch.value.length >= 301 &&
				event != 'blur' &&
				inputSearch.value != ''
			) {
				inputSearch.classList.add('search__input-invalid');
			} else {
				event != 'blur' &&
					inputSearch.classList.remove('search__input-invalid');

				$scope.callValidate = true;
			}
		};

		$scope.selectGroupUser = async (idGroup, groupUser = null) => {
			sessionStorage.removeItem('__selected__');

			let rota = '/movimentacoes';
			let count = 0;

			['recordPublications', 'createMovements'].forEach((item, index) => {
				if (permissions.has(item) && count == 0) {
					rota += index == 0 ? '/publicacoes' : '/todas-conta';
					count += 1;
				}
			});

			if (!idGroup) {
				localStorage.removeItem('__groupUserData__');
				localStorage.setItem('__groupSelected__', false);
				localStorage.setItem('__hasGroupUserPermission__', true);
				if (location.pathname.indexOf('/movimentacoes') >= 0)
					location.replace(location.origin + rota);
				else location.replace(location.origin + location.pathname);

				localStorage.removeItem('__idGroupUserData__');

				return;
			}

			localStorage.setItem('__groupUserData__', JSON.stringify(groupUser));
			localStorage.setItem('__groupSelected__', true);
			localStorage.setItem(
				'__idGroupUserData__',
				JSON.stringify(groupUser.idGrupo)
			);

			await permissions.userGroupAdm();
			$rootScope.deleteItemLocal();

			if (location.pathname.indexOf('/movimentacoes') >= 0)
				location.replace(location.origin + rota);
			else location.replace(location.origin + location.pathname);
		};

		$scope.recordGroupsUser = async page => {
			if (!$rootScope.haveGroup) return;

			$http({
				...helper.http(API.customers, 'GET'),
				params: {
					...helper.httpFields(['possuiGrupo']),
					IDs: authentication.getUserData('idCliente')
				}
			})
				.then(response => {
					$rootScope.haveGroup = response.data.itens[0].possuiGrupo;

					localStorage.setItem(
						'__hasGroup__',
						response.data.itens[0].possuiGrupo
					);

					if (!response.data.itens[0].possuiGrupo) return;

					$scope.userGroups.setLoading(true).setReady(false);

					if (page) {
						$scope.currentGroupPage = page;
					}

					let params = {
						paginaAtual: $scope.currentGroupPage,
						registrosPorPagina: 10,
						IdsSituacaoGrupoUsuario: [-1],
						campos:
							'NomeGrupo, IdGrupo, ListaUsuariosGrupo.IdUsuarioXGrupo, ListaUsuariosGrupo.IdUsuarioCliente, ListaUsuariosGrupo.Ativo'
					};

					if ($scope.searchUserGroupQuery && page)
						params.nomeGrupo = $scope.searchUserGroupQuery;

					$http({
						...helper.http(API.groupUsers, 'GET'),
						params: params
					})
						.then(response => {
							const groups = response.data.itens || [];

							if ($scope.searchUserGroupQuery) {
								$scope.nameGroupSearch = $scope.searchUserGroupQuery;
							} else {
								$scope.nameGroupSearch = null;
							}

							let idUserClient = JSON.parse(
								localStorage.getItem('__authenticationUserData__')
							).idUsuarioCliente;

							let groupList = [];

							groups.map(group => {
								const isGroupUser = (group.listaUsuariosGrupo || []).some(
									user =>
										user.idUsuarioCliente == idUserClient && user.ativo === true
								);

								if (isGroupUser) groupList.push(group);
							});

							$scope.userGroups.setItems(groupList);

							$scope.totalGroupPages = response.data.paginacao.paginaTotal;

							$scope.totalGroupRegisters =
								response.data.paginacao.registrosTotal;

							$scope.blockPaginationGroupSelect = false;
						})
						.finally(() => {
							$scope.blockPaginationGroupSelect = false;
							$scope.userGroups.setNotLoading().setReady(true);
						})
						.catch(() => {
							$scope.blockPaginationGroupSelect = false;
						});

					// if ($scope.userGroups.items.length < 10 && $scope.currentGroupPage > 1)
					// 	$scope.currentGroupPage--;
				})
				.catch(() => {
					$scope.blockPaginationGroupSelect = false;
				});
		};

		$scope.modalRegisterOABAction = action => {
			if (action == 'close' || action == 'confirm-close') {
				if (
					($scope.modalRegisterOABStep == 'oab-sucesso' ||
						$scope.modalRegisterOABStep == 'oab-sucesso-multiplos' ||
						$scope.modalRegisterOABStep == 'oab-busca' ||
						$scope.modalRegisterOABStep == 'oab-nao-encontrado' ||
						$scope.modalRegisterOABStep == 'oab-nao-validado') &&
					action == 'close'
				) {
					$scope.setSubModalData('oab-sucesso-sair');

					return;
				}

				const userParamsSession = sessionStorage.getItem('parametros-usuarios');

				let dataParameterUsers = null;

				if (
					userParamsSession &&
					userParamsSession != undefined &&
					userParamsSession != 'undefined'
				) {
					dataParameterUsers = JSON.parse(userParamsSession);
				}

				if (dataParameterUsers) {
					var method = 'PUT';
					var params = {
						id: dataParameterUsers.idParamUsuarioProdAdv,
						exibirCadastroAgil: false
					};
				} else {
					var method = 'POST';
					var params = {
						exibirCadastroAgil: false
					};
				}

				$http({
					...helper.http(API.parametersUsers, method),
					data: {
						itens: [params]
					},
					messageOverride: {
						success() {}
					}
				}).then(response => {
					if (
						method == 'POST' &&
						response &&
						response.data &&
						response.data.itens
					) {
						sessionStorage.setItem(
							'parametros-usuarios',
							JSON.stringify(response.data.itens[0])
						);
					}
				});

				$rootScope.exibirCadastroAgil = false;

				$('#modalRegisterOAB').modal('hide');

				$scope.modalRegisterOABStep = 'oab-busca';
				$scope.registerOab = {
					numeroOab: '',
					ufOab: ''
				};
				$scope.registerOabLoading = false;

				return;
			}

			switch ($scope.modalRegisterOABStep) {
				case 'oab-busca':
					if (action == 'next') {
						$scope.registerOabLoading = true;

						$scope.checkOabCna();
					}
					break;
				case 'oab-sucesso':
					if (action == 'next') {
						$scope.registerOabLoading = true;

						$scope.confirmRegisterOab();
					}

					if (action == 'return') {
						$scope.setSubModalData('oab-sucesso-retornar');
					}

					break;
				case 'oab-sucesso-multiplos':
					if (action == 'next') {
						$scope.registerOabLoading = true;

						$scope.confirmRegisterOab();
					}

					if (action == 'return') {
						$scope.setSubModalData('oab-sucesso-retornar');
					}

					break;
				case 'oab-nao-encontrado':
					if (action == 'next') {
						$scope.registerOabLoading = true;

						$scope.confirmRegisterOab();
					}

					if (action == 'return') {
						$scope.registerOab = {
							numeroOab: '',
							ufOab: ''
						};
						$scope.registerOabLoading = false;
						$scope.modalRegisterOABStep = 'oab-busca';
					}
					break;
				case 'oab-nao-validado':
					if (action == 'next') {
						$scope.registerOabLoading = true;

						$scope.confirmRegisterOab();
					}

					if (action == 'return') {
						$scope.registerOab = {
							numeroOab: '',
							ufOab: ''
						};
						$scope.registerOabLoading = false;
						$scope.modalRegisterOABStep = 'oab-busca';
					}

					if (action == 'retry') {
						$scope.registerOabLoading = true;

						$scope.checkOabCna();
					}

					break;
				case 'oab-limite-de-consulta':
					if (action == 'next') {
						$scope.openRequestConsultantFormModal();
					}
					break;
				case 'oab-buscando-processos':
					break;
				case 'oab-falha-ao-concluir':
					if (action == 'retry') {
						$scope.registerOabLoading = true;

						$scope.confirmRegisterOab();
					}
			}

			setTimeout(() => {
				if (
					$rootScope.$$phase !== '$apply' &&
					$rootScope.$$phase !== '$digest'
				) {
					$rootScope.$apply();
				}
			}, 250);
		};

		$scope.setSubModalData = submodal => {
			if (submodal == 'oab-nao-validado-continuar') {
				$scope.modalRegisterOABSubStepData = {
					title: 'Tem certeza que deseja continuar?',
					description:
						'Antes de prosseguir, recomendamos certificar-se de que o Nº de inscrição da OAB foi digitado corretamente.',
					confirmButtonText: 'Sim, quero continuar',
					cancelButtonText: 'Voltar',
					confirmButtonClass:
						'btn btn-success cursor-pointer min-h-40 min-w-169 font-size-085rem',
					cancelButtonClass:
						'btn btn-outline-primary cursor-pointer min-h-40 min-w-91 font-size-085rem',
					confirmFunction: () => {
						$('#modalSubStepOab').modal('hide');
						$('#modalRegisterOAB').modal('show');
						$scope.modalRegisterOABAction('next');
					},
					cancelFunction: () => {
						$('#modalSubStepOab').modal('hide');
						$('#modalRegisterOAB').modal('show');
					}
				};
			} else if (submodal == 'oab-sucesso-sair') {
				$scope.modalRegisterOABSubStepData = {
					title: 'Tem certeza que deseja sair?',
					description:
						'Se você sair agora, a importação dos processos não será realizada. Mas não se preocupe, você poderá acessar novamente esse recurso através do menu Cadastrar Processos.',
					confirmButtonText: 'Sim, quero sair',
					cancelButtonText: 'Voltar',
					confirmButtonClass:
						'btn-danger cursor-pointer min-h-40 min-w-130 font-size-085rem',
					cancelButtonClass:
						'btn btn-outline-primary cursor-pointer min-h-40 min-w-91 font-size-085rem',
					confirmFunction: () => {
						$('#modalSubStepOab').modal('hide');
						$('#modalRegisterOAB').modal('hide');

						$scope.modalRegisterOABStep = 'oab-busca';
						$scope.registerOab = {
							numeroOab: '',
							ufOab: ''
						};
						$scope.registerOabLoading = false;
						$scope.closeModalRegisterOab();
					},
					cancelFunction: () => {
						$('#modalSubStepOab').modal('hide');
						$('#modalRegisterOAB').modal('show');
					}
				};
			} else if (submodal == 'oab-sucesso-retornar') {
				$scope.modalRegisterOABSubStepData = {
					title: 'Tem certeza que deseja sair?',
					description:
						'Se você sair agora, a importação dos processos não será realizada. Mas não se preocupe, você poderá acessar novamente esse recurso através do menu Cadastrar Processos.',
					confirmButtonText: 'Sim, quero sair',
					cancelButtonText: 'Voltar',
					confirmButtonClass:
						'btn-danger cursor-pointer min-h-40 min-w-130 font-size-085rem',
					cancelButtonClass:
						'btn btn-outline-primary cursor-pointer min-h-40 min-w-91 font-size-085rem',
					confirmFunction: () => {
						$('#modalSubStepOab').modal('hide');
						$('#modalRegisterOAB').modal('show');

						$scope.modalRegisterOABStep = 'oab-busca';
						$scope.registerOabLoading = false;
					},
					cancelFunction: () => {
						$('#modalSubStepOab').modal('hide');
						$('#modalRegisterOAB').modal('show');
					}
				};
			}

			$('#modalRegisterOAB').modal('hide');
			$('#modalSubStepOab').modal('show');
		};

		$scope.checkOabCna = () => {
			if (!$scope.registerOab.numeroOab) {
				return;
			}

			$scope.registerOabLoading = true;

			if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
				$rootScope.$apply();
			}

			if ($scope.registerOab.numeroOab && $scope.registerOab.ufOab) {
				for (let i = 0; i < $scope.ufOab.length; i++) {
					if ($scope.ufOab[i].value == $scope.registerOab.ufOab) {
						$scope.registerOab.idUfOab = $scope.ufOab[i].id;
					}
				}

				$http({
					...helper.http(API.cadastroAgil, 'GET'),
					params: {
						NumeroOAB: $scope.registerOab.numeroOab,
						UFOAB: $scope.registerOab.ufOab
					}
				})
					.then(response => {
						if (response.status == 200) {
							if (
								response.data &&
								response.data.itens &&
								response.data.itens.length > 0
							) {
								if (response.data.itens[0].length > 1) {
									$scope.consultaOabCnaData = {};

									$scope.consultaOabCnaDataItens = response.data.itens[0];

									let uniqueData = [];

									for (let j = 0; j < response.data.itens[0].length; j++) {
										$scope.consultaOabCnaDataItens[j].selecionado = false;
										$scope.consultaOabCnaDataItens[
											j
										].tipoInscricao = $scope.consultaOabCnaDataItens[
											j
										].tipoInscricao.toLowerCase();

										for (let i = 0; i < $scope.ufOab.length; i++) {
											if (
												$scope.ufOab[i].value ==
												$scope.consultaOabCnaDataItens[j].uf
											) {
												$scope.consultaOabCnaDataItens[j].ufName =
													$scope.ufOab[i].label;
											}
										}

										let isUnique = true;

										for (let i = 0; i < uniqueData.length; i++) {
											if (
												uniqueData[i].nome ==
													$scope.consultaOabCnaDataItens[j].nome &&
												uniqueData[i].oab ==
													$scope.consultaOabCnaDataItens[j].oab &&
												uniqueData[i].ufName ==
													$scope.consultaOabCnaDataItens[j].ufName &&
												uniqueData[i].nome ==
													$scope.consultaOabCnaDataItens[j].nome
											) {
												isUnique = false;
											}
										}

										if (isUnique) {
											uniqueData.push($scope.consultaOabCnaDataItens[j]);
										}
									}

									$scope.consultaOabCnaDataItens = uniqueData;

									if ($scope.consultaOabCnaDataItens.length > 1) {
										$scope.modalRegisterOABStep = 'oab-sucesso-multiplos';
									} else {
										$scope.consultaOabCnaData =
											$scope.consultaOabCnaDataItens[0];
										$scope.modalRegisterOABStep = 'oab-sucesso';
									}
								} else {
									$scope.consultaOabCnaData = response.data.itens[0][0];
									$scope.consultaOabCnaData.tipoInscricao = response.data.itens[0][0].tipoInscricao.toLowerCase();

									for (let i = 0; i < $scope.ufOab.length; i++) {
										if ($scope.ufOab[i].value == $scope.consultaOabCnaData.uf) {
											$scope.consultaOabCnaData.ufName = $scope.ufOab[i].label;
										}
									}
									$scope.modalRegisterOABStep = 'oab-sucesso';
								}
							}
						} else if (response.status == 400) {
							$scope.modalRegisterOABStep = 'oab-nao-validado';
						} else if (response.status == 503) {
							$scope.modalRegisterOABStep = 'oab-nao-validado';
						} else if (response.status == 404) {
							$scope.modalRegisterOABStep = 'oab-nao-encontrado';
						}
					})
					.catch(() => {
						$scope.modalRegisterOABStep = 'oab-nao-validado';
					})
					.finally(() => {
						$scope.registerOabLoading = false;
					});
			}
		};

		$scope.setCheckedOabCna = checkedOab => {
			for (let i = 0; i < $scope.consultaOabCnaDataItens.length; i++) {
				if (
					$scope.consultaOabCnaDataItens[i].oab == checkedOab.oab &&
					$scope.consultaOabCnaDataItens[i].nome == checkedOab.nome
				) {
					$scope.consultaOabCnaDataItens[i].selecionado = true;

					$scope.consultaOabCnaData = $scope.consultaOabCnaDataItens[i];
				} else {
					$scope.consultaOabCnaDataItens[i].selecionado = false;
				}
			}
		};

		$scope.confirmRegisterOab = () => {
			if (!$scope.registerOab.numeroOab) {
				return;
			}

			const data = {
				idUfOAB: $scope.registerOab.idUfOab,
				numeroOAB: $scope.registerOab.numeroOab
			};

			$http({
				...helper.http(API.cadastroAgil, 'POST'),
				data: {
					...data
				}
			})
				.then(response => {
					if (response.status == 200 || response.status == 201) {
						$scope.modalRegisterOABStep = 'oab-buscando-processos';

						$scope.registerOabTopBarInfo = {
							numeroOab: $scope.registerOab.numeroOab,
							ufOab: $scope.registerOab.ufOab
						};

						$http({
							...helper.http(API.cadastroAgil, 'fetchNotifications'),
							params: {
								listaSitPesqProcOABXParamUsCliente: '-1,-2,-7'
							},
							method: 'GET'
						})
							.then(response => {
								if (
									response &&
									response.data &&
									response.data.itens &&
									response.data.itens[0] &&
									response.data.itens[0].oabs
								) {
									let oabs = response.data.itens[0].oabs;
									let oabsUnicas = [];
									let oabsMap = {};

									for (let oab of oabs) {
										let key = `${oab.numeroOab}/${oab.siglaUfOab}`;

										if (!oabsMap[key]) {
											oabsMap[key] = true;
											oabsUnicas.push(oab);
										}
									}

									let message = '';
									let firstOab = true;

									for (let oabMessage of oabsUnicas) {
										let { numeroOab, siglaUfOab } = oabMessage;

										if (!firstOab) {
											message += ', ';
										}
										message += `${numeroOab}/${siglaUfOab}`;
										firstOab = false;
									}

									if (message.contains(',')) {
										message = 'OABs ' + message;
									} else {
										message = 'OAB ' + message;
									}

									$rootScope.quickRegisterOabMessage = message;

									if (!firstOab) {
										if ($scope.banners && $scope.banners.length) {
											$scope.banners.splice(1, 0, 'sucessoCadastroAgilOab');
										}

										$scope.showBannerNavigation = Boolean(
											$scope.banners && $scope.banners.length > 1
										);

										$scope.handleMessagesButtonNext('null');
									}
								}
							})
							.finally(() => {
								$scope.clearTarja();
								$scope.currentMessage = 'sucessoCadastroAgilOab';
							});
					} else if (
						response.status == 400 ||
						response.status == 401 ||
						response.status == 404
					) {
						$scope.modalRegisterOABStep = 'oab-falha-ao-concluir';
					}
				})
				.catch(() => {
					$scope.modalRegisterOABStep = 'oab-falha-ao-concluir';
				})
				.finally(() => {
					$scope.registerOabLoading = false;
				});
		};

		$scope.closeModalRegisterOab = (hasConcluded = false) => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined' &&
				userParamsSession != '{}' &&
				userParamsSession != {}
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			var params = {};
			var method = 'PUT';

			if (dataParameterUsers) {
				if (dataParameterUsers.idParamUsuarioProdAdv) {
					method = 'PUT';
					params = {
						id: dataParameterUsers.idParamUsuarioProdAdv,
						exibirCadastroAgil: false
					};
				} else {
					method = 'POST';
					params = {
						...dataParameterUsers,
						exibirCadastroAgil: false
					};
				}
			} else {
				method = 'POST';
				params = {
					exibirCadastroAgil: false
				};
			}

			$http({
				...helper.http(API.parametersUsers, method),
				data: {
					itens: [params]
				},
				messageOverride: {
					success() {}
				}
			}).then(response => {
				if (
					method == 'POST' &&
					response &&
					response.data &&
					response.data.itens
				) {
					sessionStorage.setItem(
						'parametros-usuarios',
						JSON.stringify(response.data.itens[0])
					);
				}
			});

			$('#modalSubStepOab').modal('hide');
			$('#modalRegisterOAB').modal('hide');

			$scope.modalRegisterOABStep = 'oab-busca';
			$scope.registerOab = {
				numeroOab: '',
				ufOab: ''
			};
			$scope.registerOabLoading = false;

			$rootScope.exibirCadastroAgil = false;

			if (hasConcluded) {
				setTimeout(() => {
					$scope.handleMessagesButtonNext('next');
					$scope.currentMessage = 'sucessoCadastroAgilOab';
				}, 200);
			}

			if ($location.$$url.contains('cadastrar-processos')) {
				$state.go('root.default.movements.processList');
			}
		};

		$scope.fetchOabRequirements = () => {
			$http({
				...helper.http(API.federativeUnits, 'GET'),
				params: {
					...helper.httpFields(['id', 'sigla', 'nome']),
					ativo: true,
					registrosPorPagina: -1,
					ordem: '+sigla'
				}
			})
				.then(response => {
					if (
						response &&
						response.data &&
						response.data.itens &&
						response.data.itens.length > 0
					) {
						let ufList = [];

						for (let i = 0; i < response.data.itens.length; i++) {
							ufList.push({
								value: response.data.itens[i].sigla,
								label: response.data.itens[i].sigla,
								name: response.data.itens[i].nome,
								id: response.data.itens[i].id
							});
						}

						$scope.ufOab = ufList;
					}
				})
				.finally(() => {
					$http({
						...helper.http(API.usersCustomers, 'GET'),
						params: {
							...helper.httpFields([
								'id',
								'idPessoa',
								'dadosOAB.id',
								'dadosOAB.ativo',
								'dadosOAB.numero',
								'dadosOAB.idUF',
								'dadosOAB.nomeUF',
								'dadosOAB.idTipoOAB',
								'dadosOAB.nomeTipoOAB'
							]),
							IDs: authentication.getUserData('idUsuarioCliente'),
							expansao: 'pessoa,dadosOAB'
						}
					})
						.then(response => {
							if (
								response &&
								response.data &&
								response.data.itens &&
								response.data.itens.length > 0
							) {
								const dadosOab = response.data.itens[0].dadosOAB;
								let dadoOabNomeUF = '';

								if (dadosOab && dadosOab.length > 0) {
									for (let dadoOab of dadosOab) {
										if (dadoOab.ativo) {
											$scope.oabUserData.numeroOab = dadoOab.numero.replace(
												/\D/g,
												''
											);

											dadoOabNomeUF = dadoOab.nomeUF;
											break;
										}
									}
									if (dadoOabNomeUF) {
										for (let i = 0; i < $scope.ufOab.length; i++) {
											if ($scope.ufOab[i].name == dadoOabNomeUF) {
												$scope.oabUserData.ufOab = $scope.ufOab[i].value;

												let selector = document.getElementById(
													'select2-uf-selector-modal-oab-container'
												);

												if (selector && selector.innerHTML) {
													selector.innerHTML = $scope.ufOab[i].value;
												}
											}
										}
									}

									if (!$scope.$$phase && !$rootScope.$$phase) {
										$scope.$apply();
									}
								}
							}
						})
						.finally(() => ($scope.userLoading = false));
				});
		};

		$rootScope.setModalRegisterOabData = () => {
			$scope.modalRegisterOABStep = 'oab-busca';

			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			if (
				dataParameterUsers &&
				dataParameterUsers.permiteCadastroAgil == false
			) {
				$scope.modalRegisterOABStep = 'oab-limite-de-consulta';
			}

			if (
				$scope.oabUserData &&
				$scope.oabUserData.numeroOab != '' &&
				$scope.oabUserData.ufOab != ''
			) {
				$scope.registerOab = $scope.oabUserData;

				let selector = document.getElementById(
					'select2-uf-selector-modal-oab-container'
				);

				if (selector && selector.innerHTML) {
					selector.innerHTML = $scope.oabUserData.ufOab;
				}
			} else {
				$scope.registerOab = {
					numeroOab: '',
					ufOab: null
				};
			}

			$scope.registerOabLoading = false;
		};

		$scope.createPublicationsDeadline = (publicationsDeadlines, target) => {
			if (!Array.isArray(publicationsDeadlines))
				publicationsDeadlines = [publicationsDeadlines];

			$http({
				...helper.http(API.publicationsDeadlines, 'POST'),
				data: {
					itens: publicationsDeadlines
				}
			}).then(response => {
				target.prazo = response.data.itens[0];

				$scope.emptyPublicationsDeadline = {};

				$('#modalCreatePublicationsDeadline').modal('hide');
			});
		};

		/***/
		$scope.openModelUpdatePublicationsDeadline = publication => {
			$scope.editablePublicationsDeadline = publication.prazo;

			$scope.editablePublicationsDeadlineTarget = publication;

			$('#modalUpdatePublicationsDeadline').modal('show');
		};

		/***/
		$scope.updatePublicationsDeadline = (publicationsDeadlines, target) => {
			if (!Array.isArray(publicationsDeadlines))
				publicationsDeadlines = [publicationsDeadlines];

			$http({
				...helper.http(API.publicationsDeadlines, 'PUT'),
				data: {
					itens: publicationsDeadlines
				}
			}).then(response => {
				target.prazo = response.data.itens[0];

				$scope.emptyPublicationsDeadline = {};

				$('#modalUpdatePublicationsDeadline').modal('hide');
			});
		};

		/**********************************************************************/

		/**
		 * Recupera tipos de prazo.
		 */
		$scope.deadlineTypes = helper.responseStore();

		$scope.recordDeadlineTypes = responseStore => {
			return false;

			$http({
				...helper.http(API.deadlineTypes, 'GET'),
				params: {
					...helper.httpFields(['id', 'nome']),
					registrosPorPagina: -1
				}
			})
				.then(response => responseStore.setItems(response.data.itens))

				.finally(() => responseStore.setReady(true));
		};

		// $scope.recordDeadlineTypes($scope.deadlineTypes);

		/**
		 * Recupera opções de lembrete.
		 */
		$scope.reminderOptions = helper.responseStore();

		$scope.recordReminderOptions = responseStore => {
			return false;

			$http({
				...helper.http(API.reminderOptions, 'GET'),
				params: {
					...helper.httpFields(['id', 'nome']),
					registrosPorPagina: -1
				}
			})
				.then(response => responseStore.setItems(response.data.itens))

				.finally(() => responseStore.setReady(true));
		};

		// $scope.recordReminderOptions($scope.reminderOptions);

		/**
		 * Recupera tipos de recorrência.
		 */
		$scope.recurrenceTypes = helper.responseStore();

		$scope.recordRecurrenceTypes = responseStore => {
			return false;

			$http({
				...helper.http(API.recurrenceTypes, 'GET'),
				params: {
					...helper.httpFields(['id', 'nome']),
					registrosPorPagina: -1
				}
			})
				.then(response => responseStore.setItems(response.data.itens))

				.finally(() => responseStore.setReady(true));
		};

		$rootScope.getTerms = () => {
			$http({
				...helper.http(API.termsUse, 'GET')
			}).then(({ data }) => {
				const iframe = document.getElementById('iframeContent');

				$scope.loadingTerms = true;

				iframe.innerHTML = data.itens[0].textoTermo;

				$scope.termsUse = data.itens[0];

				$scope.termsUse = data.itens[0];

				const element = document.getElementById('dateUpdate');

				$scope.date = moment(
					new Date($scope.termsUse.dataHoraPublicacaoTermo)
				).format('DD/MM/YYYY');

				element.innerHTML = `Data de publicação: ${$scope.date}`;
			});
		};

		// if ($rootScope.aceitaTermosUso) $rootScope.openModalUpdatePhone();

		$rootScope.openOabQuickRegister = () => {
			$http({
				...helper.http(API.parametersUsers, 'GET'),
				params: {
					...helper.httpFields(['*'])
				}
			}).then(({ data: { itens } }) => {
				if (itens && itens.length > 0) {
					sessionStorage.setItem(
						'parametros-usuarios',
						JSON.stringify(itens[0])
					);

					$rootScope.exibirCadastroAgil = itens[0].exibirCadastroAgil;

					$scope.oabQuickRegisterTimeout = setTimeout(() => {
						if (
							$rootScope.aceitaTermosUso &&
							permissions.has('createProcess') &&
							permissions.has('oabQuickRegister')
						) {
							if (
								typeof $rootScope.exibirCadastroAgil === 'undefined' ||
								!!$rootScope.exibirCadastroAgil
							) {
								$rootScope.setModalRegisterOabData();

								const modal = document.querySelector('#modalPermissions');

								if (
									!(
										modal &&
										modal.classList &&
										modal.classList.contains('show')
									)
								) {
									$('#modalRegisterOAB').modal('show');
								} else {
									setTimeout(() => {
										$rootScope.openOabQuickRegister();
									}, 5000);
								}
							}
						}
					}, 5000);
				} else {
					$scope.oabQuickRegisterTimeout = setTimeout(() => {
						if (
							$rootScope.aceitaTermosUso &&
							permissions.has('createProcess') &&
							permissions.has('oabQuickRegister')
						) {
							if (
								typeof $rootScope.exibirCadastroAgil === 'undefined' ||
								!!$rootScope.exibirCadastroAgil
							) {
								$rootScope.setModalRegisterOabData();

								const modal = document.querySelector('#modalPermissions');

								if (
									!(
										modal &&
										modal.classList &&
										modal.classList.contains('show')
									)
								) {
									$('#modalRegisterOAB').modal('show');
								} else {
									setTimeout(() => {
										$rootScope.openOabQuickRegister();
									}, 5000);
								}
							}
						} else if ($rootScope.aceitaTermosUso) {
							$rootScope.exibirCadastroAgil = false;
						}
					}, 5000);
				}
			});
		};

		$scope.openRequestConsultantFormModal = async () => {
			$scope.modalForm = true;

			$('#modalVideo').modal('hide');
			$('.iframeParent').html('');

			if (!Object.keys($scope.formHubEl).length > 0) {
				await $scope.getCustomerData();
			}

			$scope.clearTarja();

			setTimeout(() => {
				$('#modalRegisterOAB').modal('hide');
				$('body').addClass('consultant-form-modal-open');

				$('#modalHubFormOab')
					.off('hidden.bs.modal.consultantForm')
					.on('hidden.bs.modal.consultantForm', () => {
						$('body').removeClass('consultant-form-modal-open');
						$scope.modalForm = false;
						$scope.timeTarja();
					})
					.modal('show');
			}, 300);
		};

		$scope.pagante = null;
		$scope.semPagador = null;
		$scope.bloqueado = null;

		$scope.endCourtesyMsg = contract => {
			let activeCourtesy = [];

			if (contract)
				activeCourtesy = contract.filter(
					item => item.idSituacaoContrato == -1 && item.cortesia
				);

			if (activeCourtesy.length) $rootScope.attentionMsg = true;

			$rootScope.attentionMsgNotCourtesy = !activeCourtesy.length
				? true
				: false;
		};

		$scope.verifyContractPay = contractId => {
			$http({
				...helper.http(API.centerPay, 'GET'),
				params: {
					...helper.httpFields(['*']),
					idContrato: contractId,
					registrosPorPagina: -1
				}
			}).then(response => {
				const dataPay = response.data.itens;

				dataPay.forEach(portionPay => {
					portionPay.forEach(portion => {
						portion.parcelas.forEach(element => {
							if (element.idSituacaoParcela === -1) {
								$rootScope.attentionMsg = true;
								$rootScope.msgEndValid = true;
							} else {
								$rootScope.attentionMsg = false;
								$rootScope.msgEndValid = false;
							}
						});
					});
				});
			});
		};

		$rootScope.msgEndValid = false;
		// $scope.newContract = false;

		$scope.validPayContracts = contract => {
			const today = moment(new Date());

			contract.forEach(element => {
				if (!element.pagamentoContrato) return false;

				const datePay = moment(element.pagamentoContrato.proximoVencimento);

				const interval = moment.duration(today.diff(datePay)).asDays();

				if (
					(interval >= 2 && element.idSituacaoContrato === -1) ||
					element.idSituacaoContrato === -6 ||
					element.idSituacaoContrato === -3
				)
					if (!element.pagamentoContrato.idPessoaPagador) {
						$rootScope.attentionMsg = true;
						$rootScope.msgEndValid = true;
					}
					//if (element.idSituacaoContrato === -6) {
					// $scope.newContract = true;
					// $scope.msgEndValid = true;
					//}
					else {
						$scope.verifyContractPay(element.id);
					}
			});
		};

		$scope.daysEndValid = 0;

		$scope.countValidCourtesy = contract => {
			const courtesy = contract
				.filter(item => item.cortesia && item.idSituacaoContrato == -1)
				.sort((a, b) => (a.dataFimVigencia > b.dataFimVigencia ? -1 : 1));

			const today = moment(new Date());

			let endValid = '',
				duration = '',
				interval = '';

			courtesy[0] ? (endValid = moment(courtesy[0].dataFimVigencia)) : '';

			endValid ? (duration = moment.duration(endValid.diff(today))) : '';

			duration ? (interval = duration.asDays()) : '';

			interval
				? ($scope.daysEndValid = Math.floor(
						interval >= 0 ? interval + 1 : interval
				  ))
				: '';

			return $scope.daysEndValid;
		};

		$scope.constractsCourtesy = async () => {
			$scope.contractCourtesy = JSON.parse(
				localStorage.getItem('_contractsCourtesy_')
			);

			$scope.contratcsIDs = JSON.parse(
				localStorage.getItem('_contratctIDsSituation_')
			);

			let data = $scope.contractCourtesy || [];

			if (!Array.isArray(data) || !data.length) return;

			data.forEach(item => {
				if (![-3, -6].includes(item.idSituacaoContrato)) {
					$scope.endCourtesyMsg(data);
					$scope.countValidCourtesy(data);
					$scope.validPayContracts(data);
				}
			});

			let courtesy = data.filter(
					item => item.idSituacaoContrato == -1 && item.cortesia
				),
				firstCourtesy = courtesy && courtesy.shift();

			$rootScope.checkIfcontractCourtesy = firstCourtesy;

			let conditionShowModal =
				firstCourtesy &&
				firstCourtesy.dataFimVigencia &&
				moment(firstCourtesy.dataFimVigencia).diff(
					moment().format('YYYY-MM-DD'),
					'days'
				) == 0;

			/** Recuperar variável de controle da modal de cortesia */
			let showUserCourtesyModal = localStorage.getItem(
				'__showUserCourtesyModal__'
			);

			if (localStorage.getItem('_attentionMsg') == 'false') {
				$rootScope.attentionMsg = false;
			}

			/** Abrir modal indicando final da cortesia */
			if (
				conditionShowModal &&
				(showUserCourtesyModal === null || showUserCourtesyModal === 'true')
			) {
				let modal = $('#modalCourtesy');

				setTimeout(() => {
					modal.modal('show');

					modal

						.off('hidden.bs.modal')

						.on('hidden.bs.modal', () =>
							localStorage.setItem('__showUserCourtesyModal__', false)
						);
				}, 1000);
			}
		};

		if (!$scope.contractCourtesy || !$scope.contratcsIDs)
			$scope.constractsCourtesy();

		$scope.formHubEl = {};

		$scope.sendFormHub = () => {
			if ($scope.formHubSubmitted) return;

			$scope.formHubSubmitted = true;

			setTimeout(() => {
				$('#modalHubForm').modal('hide');
				notification.success(
					'Seus dados foram enviados! Aguarde o contato de nossos consultores.'
				);

				if ($scope.nameFormHub) {
					$scope.nameFormHub.$setPristine();
					$scope.nameFormHub.$setUntouched();
				}

				// Remove classes visuais do Bootstrap/Angular nos inputs
				setTimeout(() => {
					$('#formHub input').removeClass(
						'is-valid is-invalid ng-touched ng-dirty ng-not-empty'
					);
				}, 50);

				$scope.formHubSubmitted = false;
				$scope.$applyAsync();
			}, 500);
		};

		$scope.quickRegisterConsultant = () => {
			if (
				$scope.formHubEl &&
				$scope.formHubEl.name &&
				$scope.formHubEl.email &&
				$scope.formHubEl.phone
			) {
				/*eslint-disable */
				const data = {
					nome: $scope.formHubEl.name,
					email: $scope.formHubEl.email,
					celular: $scope.formHubEl.phone,
					identificador: 'formcadastroagil',
					token_rdstation: 'd7ad0e96fa3a180769d57afa87b7ce3f',
					form_url: window.location.href
				};
				$http
					.post('https://www.rdstation.com.br/api/1.3/form-integrations', data)
					.finally(() => {
						$('#modalHubFormOab').modal('hide');
					});
			}

			$('#modalHubFormOab').modal('hide');
		};

		$scope.closeModalCredits = () => {
			if (
				$scope.formHubEl &&
				$scope.formHubEl.name &&
				$scope.formHubEl.email &&
				$scope.formHubEl.phone
			) {
				/*eslint-disable */
				const data = {
					nome: $scope.formHubEl.name,
					email: $scope.formHubEl.email,
					celular: $scope.formHubEl.phone,
					identificador: 'formPecasIA',
					token_rdstation: 'd7ad0e96fa3a180769d57afa87b7ce3f',
					form_url: window.location.href
				};
				$http
					.post('https://www.rdstation.com.br/api/1.3/form-integrations', data)
					.finally(() => {
						$('#modalHubFormLabelCreditos').modal('hide');
					});
			} else {
				$('#modalHubFormLabelCreditos').modal('hide');
			}
		};

		$scope.getCustomerData = async () => {
			await $http({
				...helper.http(API.customers, 'GET'),
				params: {
					...helper.httpFields([
						'id',
						'pessoaCliente.id',
						'pessoaCliente.nome',
						'pessoaCliente.email',
						'pessoaCliente.fone1',
						'pessoaCliente.fone2',
						'pessoaCliente.celular1',
						'pessoaCliente.celular2'
					]),
					IDs: authentication.getUserData('idCliente')
				}
			}).then(response => {
				const { itens } = response.data;

				if (!itens[0]) {
					return;
				}

				const {
					pessoaCliente: { nome, email, fone1, fone2, celular1, celular2 }
				} = itens[0];

				$scope.formHubEl.name = nome;
				$scope.formHubEl.email = email;
				$scope.formHubEl.phone = fone1 || celular1 || fone2 || celular2;
			});
		};

		$scope.openFormModal = async () => {
			$scope.modalForm = true;

			$('#modalVideo').modal('hide');
			$('.iframeParent').html('');

			if (!Object.keys($scope.formHubEl).length > 0) {
				await $scope.getCustomerData();
			}

			$scope.clearTarja();

			setTimeout(() => {
				$('body').addClass('consultant-form-modal-open');

				$('#modalHubForm')
					.off('hidden.bs.modal.consultantForm')
					.on('hidden.bs.modal.consultantForm', () => {
						$('body').removeClass('consultant-form-modal-open');
						$scope.modalForm = false;
						$scope.timeTarja();
					})
					.modal('show');
			}, 300);
		};

		//aqui google agenda
		$scope.recordIntegration = async () => {
			//Recupera dados de sincronização
			let dataSync = integracaoGoogleCalendar.recoverInfos();

			//aqui google agenda
			if (!dataSync) await integracaoGoogleCalendar.permissionIntegracao();

			//Recupera os dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();

			$rootScope.sincronizacaoError = dataSync.error == true ? true : false;

			if ($rootScope.sincronizacaoError) {
				$timeout(() => {
					$('#modalDisabledGoogleCalendarError').modal('show');
				}, 1000);
			}
		};

		$scope.openRecoverPastDeadlinesComponent = async (
			modal,
			showCreateDeadline = false
		) => {
			$scope.showCreate = showCreateDeadline;
			$scope.recoverPastDeadlinesClosingFromChoice = false;
			await $scope.recordIntegration();

			if (modal == 'modalSync') {
				$rootScope.formCreatePrazo.modalOpen = 'modalSync';
				$('#modalSyncAgenda').modal('hide');
			} else if (modal == 'modalCreate') {
				$rootScope.formCreatePrazo.modalOpen = 'modalCreate';
				$('#modalCreateAgendaEventComponent').modal('hide');
			} else if (modal == 'modalEdit') {
				$rootScope.formCreatePrazo.modalOpen = 'modalEdit';
				$scope.onRecoverPastDeadlines = true;
				$('#modalSyncAgenda').modal('hide');
				$('#modalEditAgendaEventComponent').modal('hide');
			}

			if (!$scope.sync) {
				$scope.onRecoverPastDeadlines = false;
				$('#modalSyncAgenda').modal('hide');
				$('#modalUpdateSyncAgenda').modal('hide');
				$('#modalRecoverPastDeadlinesOneComponent').modal('show');
			} else {
				$('#modalDisabledGoogleCalendar').modal('show');
			}
		};

		$scope.disconnectSyncModal = () => {
			$('#disconnectSync').modal('show');
		};

		$scope.disconnectSyncClose = () => {
			$('#disconnectSync').modal('hide');
			$('#modalUpdateSyncAgenda').modal({
				backdrop: 'static',
				keyboard: false
			});
		};

		$scope.disconnectSync = async () => {
			const dataSync = integracaoGoogleCalendar.recoverInfos();
			$scope.loadingDisconnect = true;

			await integracaoGoogleCalendar
				.disconnectSync(dataSync.idAgendaGoogleCalendar)
				.then(() => {
					$scope.loadingDisconnect = false;
				});

			$rootScope.noSync = true;

			$('#disconnectSync').modal('hide');

			$('#modalSyncAgenda').modal('show');
		};

		$timeout(() => {
			$('#modalRecoverPastDeadlinesOneComponent').on(
				'hidden.bs.modal',
				function() {
					if (!$scope.recoverPastDeadlinesClosingFromChoice) {
						$scope.noRecoverPastDeadlines(true);
					}
				}
			);
		}, 1000);

		$scope.runAfterRecoverPastDeadlinesModalCloses = callback => {
			const modal = $('#modalRecoverPastDeadlinesOneComponent');
			const modalIsOpen =
				modal.hasClass('show') || modal.hasClass('in') || modal.is(':visible');

			$scope.recoverPastDeadlinesClosingFromChoice = true;
			$rootScope.recoverPastDeadlinesClosingFromChoice = true;

			if (!modalIsOpen) {
				callback();
				$scope.recoverPastDeadlinesClosingFromChoice = false;
				$rootScope.recoverPastDeadlinesClosingFromChoice = false;

				return;
			}

			modal.one('hidden.bs.modal', () => {
				$timeout(() => {
					callback();
					$rootScope.recoverPastDeadlinesClosingFromChoice = false;
				}, 100);
				$scope.recoverPastDeadlinesClosingFromChoice = false;
			});
			modal.modal('hide');
		};

		$scope.openRecoverPastDeadlinesFollowUp = showCreateModal => {
			$timeout(() => {
				if (typeof $rootScope.formCreatePrazo.afterGoogleSync === 'function') {
					$rootScope.formCreatePrazo.afterGoogleSync();
					$rootScope.formCreatePrazo.afterGoogleSync = null;

					$scope.ensureCreateAgendaEventModalVisible();

					return;
				}

				if ($rootScope.formCreatePrazo.modalOpen == 'modalSync') {
					if (showCreateModal) {
						$('#modalCreateAgendaEventComponent').modal('show');
					}
				} else if ($rootScope.formCreatePrazo.modalOpen == 'modalCreate') {
					$('#modalCreateAgendaEventComponent').modal('show');
				} else if ($rootScope.formCreatePrazo.modalOpen == 'modalEdit') {
					$('#modalEditAgendaEventComponent').modal('show');
				}

				if ($('#modalCreateAgendaEventComponent').is(':visible')) {
					$scope.ensureCreateAgendaEventModalVisible();
				}
			}, 300);
		};

		$scope.ensureCreateAgendaEventModalVisible = () => {
			const modal = $('#modalCreateAgendaEventComponent');

			if (!modal.is(':visible')) {
				return;
			}

			modal.addClass('show in').css('display', 'block');
			$('body').addClass('modal-open');

			if (!$('.modal-backdrop').length) {
				$('<div class="modal-backdrop fade show"></div>').appendTo(
					document.body
				);
			}
		};

		$scope.recoverPastDeadlines = async showCreateModal => {
			$rootScope.syncSuccess = true;
			$rootScope.clicked = true;

			$scope.runAfterRecoverPastDeadlinesModalCloses(async () => {
				try {
					await $rootScope.syncGoogleEventsSchedule().catch(() => {});
				} finally {
					$scope.openRecoverPastDeadlinesFollowUp(showCreateModal);
				}
			});
		};

		$scope.showPassword = () => {
			$scope.inputType1 =
				$scope.inputType1 === 'password' ? 'text' : 'password';
		};

		$scope.closeModalComponentAcess = () => {
			$('#modalCreateCatch').modal('hide');

			$scope.sourceQty = [];
			if ($scope.cathSuccess) location.reload();
		};

		$scope.closeModalComponennt = id => {
			$(`#${id}`).modal('hide');
			if (id == 'modalEditAgendaEventComponent') {
				$('#modalDetailsSchedule').modal('show');
			}
		};

		$scope.noRecoverPastDeadlines = async modalAlreadyClosed => {
			$rootScope.syncSuccess = false;
			$rootScope.clicked = true;

			const continueSync = () => {
				$rootScope
					.syncGoogleEventsSchedule()
					.catch(() => {})
					.finally(() => $scope.openRecoverPastDeadlinesFollowUp(true));
			};

			$('#modalRecoverPastDeadlines').modal('hide');

			if (modalAlreadyClosed) {
				continueSync();

				return;
			}

			$scope.runAfterRecoverPastDeadlinesModalCloses(continueSync);
		};

		//aqui google agenda nova
		/**************** CHAMADA PARA SINCRONIZAÇÂO *******************/
		$rootScope.syncGoogleEventsSchedule = edit => {
			return integracaoGoogleCalendar.initCodeClient(edit);
		};
		/****************************** FIM ****************************/

		/********* METODO PARA NÃO MOSTRAR MENSAGEM DE SINCRONIZAÇÃO **********/
		$rootScope.toggleShowAgain = show => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			if (dataParameterUsers.idParamUsuarioProdAdv) {
				var method = 'PUT';
				var params = {
					id: dataParameterUsers.idParamUsuarioProdAdv,
					sincGoogleAgenda: show
				};
			} else {
				var method = 'POST';
				var params = {
					sincGoogleAgenda: show
				};
			}

			$http({
				...helper.http(API.parametersUsers, method),
				data: {
					itens: [params]
				},
				messageOverride: {
					success() {}
				}
			}).then(({ data }) => {
				const params = data.itens[0];
				sessionStorage.setItem(
					'parametros-usuarios',
					JSON.stringify({ ...dataParameterUsers, ...params })
				);
			});
		};

		/******************************** FIM ********************************/

		$scope.redirecionarCampanha = (e, params) => {
			if ($(e.target).hasClass('clickoutCampanha')) return;

			let campanha = '';

			if (
				params == 'indicatorRegistration' &&
				$scope.currentMessage === 'specialCampaign'
			) {
				params = 'pesquisaSorteio';
			}

			switch (params) {
				case 'notifyEmail':
					campanha =
						'https://materiais.advise.com.br/aviso-importante-envio-de-e-mails-pela-advise';
					break;
				case 'indicatorRegistration':
					campanha = 'https://materiais.advise.com.br/cadastro-do-indicador';
					break;
				case 'defaultPopUp':
					campanha =
						'https://materiais.advise.com.br/live-domicilio-judicial-eletronico?utm_source=referral&utm_medium=popup&utm_campaign=live';
					break;
				case 'apiWhatsapp':
					campanha =
						'https://api.whatsapp.com/send?phone=554391579471&text=Olá. Sou cliente da Advise. Vi no software sobre a Black November 2024 e tenho interesse.';
				case 'pesquisaSorteio':
					campanha = 'https://pesquisa-advise.typeform.com/advise';
				default:
					break;
			}

			campanha &&
				$('<a>')
					.attr({
						target: '_blank',
						href: campanha
					})[0]
					.click();
		};

		$scope.redirectSeasonCampaign = e => {
			if (!!e && $(e.target).hasClass('clickoutCampanha')) return;

			let campanha = 'https://wa.me/5543999522101';

			campanha &&
				$('<a>')
					.attr({
						target: '_blank',
						href: campanha
					})[0]
					.click();

			$scope.exitSeasonCampaign();
		};

		$scope.closePopOver = () => {
			if ($('#popOverId').attr('aria-describedby') && !$scope.popOpen) {
				$scope.popOpen = true;

				let id = $('#popOverId').attr('aria-describedby');

				$(`#${id}`).css('visibility', 'hidden');
			} else if ($scope.popOpen) {
				$scope.popOpen = false;

				let id2 = $('#popOverId').attr('aria-describedby');

				$(`#${id2}`).css('visibility', 'visible');
			}
		};

		// todos PopUps devem ser gerenciado por aqui
		$rootScope.popUps = () => {
			function defaultPopUp() {
				let today = moment().format('YYYY-MM-DD');
				let endDate = moment('2023-02-23 23:59').format('YYYY-MM-DD');

				var cookies = document.cookie.split('; ');

				for (var i = 0; i < cookies.length; i++) {
					var cookie = cookies[i];
					var eqPos = cookie.indexOf('=');
					var chave = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

					if (chave === '__standardPopUp__') {
						var notifiEmail = cookie.substr(eqPos + 1);
					}
				}

				return today <= endDate && notifiEmail == null;
			}

			if (defaultPopUp()) {
				$scope.notifyPopUp();
			}
		};

		$scope.notifyPopUp = () => {
			document.cookie = '__standardPopUp__=true';

			$('#modalViewPopUp').modal('show');
		};

		$('#modalViewPopUp').on('hidden.bs.modal', () => $scope.seasonCampaign());

		$scope.seasonCampaign = () => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			let record = dataParameterUsers;
			let endDateCampaing = moment('2024/02/09', 'YYYY/MM/DD').format(
				'YYYY/MM/DD'
			);

			if (record.exibirPromoQi == false) return;

			const dateToCheck = moment().format('YYYY/MM/DD');

			if (dateToCheck <= endDateCampaing) {
				$('#modalViewSeasonCampaign').modal('show');
			}
		};

		$('#modalViewSeasonCampaign').on('hidden.bs.modal', () =>
			$scope.exitSeasonCampaign()
		);

		$scope.exitSeasonCampaign = () => {
			localStorage.setItem('_viewedCampaign_', true);

			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			let record = dataParameterUsers;

			let method = record.exibirPromoQi ? 'PUT' : 'POST';
			let data;

			data = {
				itens: [
					{
						exibirPromoQi: false
					}
				]
			};

			if (method == 'PUT') {
				data.itens[0].id = record.idParamUsuarioProdAdv;
			}

			$http({
				...helper.http(API.parametersUsers, method),
				data,
				messageOverride: {
					success() {}
				}
			}).finally(() => {
				$('#modalViewSeasonCampaign').modal('hide');
			});
		};

		$scope.getScopedInputValue = scopedInput =>
			scopedInput && scopedInput.$viewValue;

		$scope.recordAgendas = async () => {
			const idUsuarioCliente =
				parseInt(authentication.getUserData('idUsuarioCliente'), 10) ||
				undefined;

			await $http({
				...helper.http(API.agendas, 'GET'),
				params: {
					...helper.httpFields(['*']),
					idUsuarioCliente: idUsuarioCliente
				}
			})
				.then(response => {
					$rootScope.idAgenda = response.data.itens[0].id;
				})
				.catch(() => {
					$rootScope.creationEventLoading = false;
				});
		};

		const validationHours = (sDate, eDate, form) => {
			const startDate = moment(sDate);
			const endDate = moment(eDate);

			if (!startDate.isValid() || !endDate.isValid()) {
				notification.danger('Informe horários válidos para o compromisso.');

				$rootScope.creationEventLoading = false;

				return false;
			}

			if (endDate.isSameOrBefore(startDate)) {
				notification.danger(
					'Hora final cadastrada no compromisso não pode ser menor ou igual à hora inicial!'
				);

				$rootScope.creationEventLoading = false;

				return false;
			}

			const diffInMinutes = endDate.diff(startDate, 'minutes');

			if (diffInMinutes < 15) {
				notification.danger(
					'O intervalo mínimo entre o horário de início e fim é de 15 minutos.'
				);

				$rootScope.creationEventLoading = false;

				return false;
			}

			return true;
		};

		$scope.selectType = typeId => {
			const normalizedTypeId = Number(typeId);

			if (normalizedTypeId === -1 && $rootScope.formCreatePrazo) {
				$rootScope.formCreatePrazo.taskToEdit.remoto = false;
				$rootScope.formCreatePrazo.taskToEdit.presencial = false;
			}

			if (normalizedTypeId !== -3 && $rootScope.formCreatePrazo) {
				$rootScope.formCreatePrazo.taskToEdit.idCategoriaEventoAgenda = undefined;
				$scope.eventCategoriesOpen = false;
				$scope.categoryPendingDeletionId = null;
			}
		};

		$scope.recordEventCategories = (
			forceRefresh = false,
			categoryNameToSelect
		) => {
			if ($scope.eventCategoriesLoading) return;

			if (forceRefresh) {
				sessionStorage.removeItem('__EVENT_CATEGORIES__');
				$scope.eventCategoriesLoaded = false;
			}

			const cachedCategories = sessionStorage.getItem('__EVENT_CATEGORIES__');

			if (cachedCategories) {
				const categories = JSON.parse(cachedCategories);

				$scope.eventCategories.setItems(categories);
				$scope.eventCategories.setReady(true);
				$scope.eventCategoriesLoaded = true;
				$scope.eventCategoriesLoadFailed = false;
				$scope.filterEventCategories();
				$rootScope.formCreatePrazo.eventCategories = $scope.eventCategories;

				if (categoryNameToSelect) {
					$scope.selectCreatedEventCategory(categories, categoryNameToSelect);
				}

				return;
			}

			$scope.eventCategoriesLoading = true;
			$scope.eventCategoriesLoadFailed = false;

			const idCliente =
				parseInt(authentication.getUserData('idCliente'), 10) || undefined;

			return $http({
				...helper.http(API.eventCategories, 'GET'),
				params: {
					...helper.httpFields(['*']),
					idCliente,
					ativo: true,
					paginaAtual: 1,
					registrosPorPagina: 200
				}
			})
				.then(({ data }) => {
					const categories = data.itens || [];

					$scope.eventCategories.setItems(categories);
					$scope.eventCategories.setReady(true);
					$scope.eventCategoriesLoaded = true;
					$scope.filterEventCategories();
					$rootScope.formCreatePrazo.eventCategories = $scope.eventCategories;

					if (categoryNameToSelect) {
						$scope.selectCreatedEventCategory(categories, categoryNameToSelect);
					}

					sessionStorage.setItem(
						'__EVENT_CATEGORIES__',
						JSON.stringify(categories)
					);
				})
				.catch(() => {
					$scope.eventCategoriesLoadFailed = true;
					$scope.eventCategoriesLoaded = false;
					$scope.eventCategories.setItems([]);
					$scope.filterEventCategories();
				})
				.finally(() => ($scope.eventCategoriesLoading = false));
		};

		$scope.selectCreatedEventCategory = (categories, categoryName) => {
			const normalizedName = categoryName.trim().toLocaleLowerCase('pt-BR');
			const createdCategory = categories.find(
				category =>
					category.nome.trim().toLocaleLowerCase('pt-BR') === normalizedName
			);
			const target = $scope.getEventCategoryTarget();

			if (createdCategory && target) {
				target.idCategoriaEventoAgenda = createdCategory.id;
				target.nomeCategoriaEventoAgenda = createdCategory.nome;
			}
		};

		$scope.getEventCategoryTarget = (target = $scope.eventCategoryTarget) =>
			target === 'edit'
				? $rootScope.formCreatePrazo.editingAgendaEvent
				: $rootScope.formCreatePrazo.taskToEdit;

		$scope.toggleEventCategories = (event, target = 'create') => {
			if (event) {
				event.preventDefault();
				event.stopPropagation();
			}

			$scope.eventCategoryTarget = target;
			$scope.eventCategoriesOpen = !$scope.eventCategoriesOpen;
			$scope.categoryPendingDeletionId = null;
			$scope.eventCategorySearch.term = '';
			$scope.filterEventCategories();

			if ($scope.eventCategoriesOpen && !$scope.eventCategoriesLoaded) {
				$scope.recordEventCategories();
			}
		};

		const closeEventCategoriesOnClickOutside = event => {
			if (!$scope.eventCategoriesOpen) return;
			if ($(event.target).closest('.agenda-category-select-wrapper').length)
				return;

			$scope.$applyAsync(() => {
				$scope.eventCategoriesOpen = false;
				$scope.categoryPendingDeletionId = null;
				$scope.eventCategorySearch.term = '';
			});
		};

		$(document).on(
			'click.agendaCategorySelect',
			closeEventCategoriesOnClickOutside
		);

		$scope.$on('$destroy', () => {
			$(document).off(
				'click.agendaCategorySelect',
				closeEventCategoriesOnClickOutside
			);
		});

		$scope.filterEventCategories = () => {
			const searchTerm = ($scope.eventCategorySearch.term || '')
				.trim()
				.toLocaleLowerCase('pt-BR');

			$scope.filteredEventCategories = $scope.eventCategories
				.getItems()
				.filter(category =>
					String(category.nome || '')
						.toLocaleLowerCase('pt-BR')
						.includes(searchTerm)
				);
		};

		$scope.getFilteredEventCategories = () => $scope.filteredEventCategories;

		$scope.restoreEventCategoriesFromCache = () => {
			if ($scope.eventCategories.getItems().length) return;

			try {
				const cachedCategories = sessionStorage.getItem('__EVENT_CATEGORIES__');

				if (!cachedCategories) return;

				const categories = JSON.parse(cachedCategories);

				if (Array.isArray(categories)) {
					$scope.eventCategories.setItems(categories);
					$scope.eventCategories.setReady(true);
					$scope.eventCategoriesLoaded = true;
					$scope.filterEventCategories();
				}
			} catch (error) {
				// Mantém o carregamento normal pelo dropdown caso o cache esteja inválido.
			}
		};

		$scope.getSelectedEventCategoryName = target => {
			const eventTarget = $scope.getEventCategoryTarget(target || 'create');

			if (!eventTarget) return '';

			$scope.restoreEventCategoriesFromCache();

			const selectedCategoryId = Number(
				eventTarget && eventTarget.idCategoriaEventoAgenda
			);
			const category = $scope.eventCategories
				.getItems()
				.find(item => Number(item.id) === selectedCategoryId);

			if (category) return category.nome;

			const categoryName = eventTarget.nomeCategoriaEventoAgenda || '';

			if (categoryName) {
				const matchedCategory = $scope.eventCategories.getItems().find(
					item =>
						String(item.nome || '')
							.trim()
							.toLocaleLowerCase('pt-BR') ===
						String(categoryName)
							.trim()
							.toLocaleLowerCase('pt-BR')
				);

				if (matchedCategory)
					eventTarget.idCategoriaEventoAgenda = matchedCategory.id;
			}

			return categoryName;
		};

		$scope.selectEventCategory = category => {
			const target = $scope.getEventCategoryTarget();

			if (target) {
				target.idCategoriaEventoAgenda = category.id;
				target.nomeCategoriaEventoAgenda = category.nome;
			}
			$scope.eventCategoriesOpen = false;
			$scope.eventCategorySearch.term = '';
			$scope.categoryPendingDeletionId = null;
		};

		$scope.isEventCategoryEditable = category =>
			category.editavel === undefined
				? Number(category.id) > 0
				: category.editavel;

		$scope.requestEventCategoryDeletion = (event, category) => {
			event.preventDefault();
			event.stopPropagation();

			if (!$scope.isEventCategoryEditable(category)) return;

			$scope.categoryPendingDeletionId = category.id;
		};

		$scope.cancelEventCategoryDeletion = event => {
			event.preventDefault();
			event.stopPropagation();
			$scope.categoryPendingDeletionId = null;
		};

		$scope.deleteEventCategory = async (event, category) => {
			event.preventDefault();
			event.stopPropagation();

			if (
				!$scope.isEventCategoryEditable(category) ||
				$scope.deletingEventCategoryId !== null
			)
				return;

			$scope.deletingEventCategoryId = category.id;

			try {
				await $http({
					...helper.http(API.eventCategories, 'inativar', { id: category.id }),
					method: 'PUT',
					data: {},
					messageOverride: {
						success: () => {},
						error: () => {}
					}
				});

				const categories = $scope.eventCategories
					.getItems()
					.filter(item => item.id !== category.id);

				$scope.eventCategories.setItems(categories);
				$scope.filterEventCategories();
				sessionStorage.setItem(
					'__EVENT_CATEGORIES__',
					JSON.stringify(categories)
				);

				[
					$rootScope.formCreatePrazo.taskToEdit,
					$rootScope.formCreatePrazo.editingAgendaEvent
				]
					.filter(Boolean)
					.forEach(target => {
						if (
							Number(target.idCategoriaEventoAgenda) === Number(category.id)
						) {
							target.idCategoriaEventoAgenda = undefined;
							target.nomeCategoriaEventoAgenda = undefined;
						}
					});

				$scope.categoryPendingDeletionId = null;
				notification.success('Categoria excluída com sucesso.');
			} catch (error) {
				notification.danger(
					$scope.getEventCategoryErrorMessage(error) ||
						'Não foi possível excluir a categoria. Verifique se existem eventos vinculados a ela.'
				);
			} finally {
				$scope.deletingEventCategoryId = null;
			}
		};

		$scope.getEventCategoryErrorMessage = error => {
			const response = (error && error.data) || {};
			const status = response.status || {};
			const errors =
				status.erros ||
				status.errors ||
				response.erros ||
				response.errors ||
				[];
			const detailedError = errors.find(item => item.mensagem || item.message);

			return (
				(detailedError && (detailedError.mensagem || detailedError.message)) ||
				status.mensagem ||
				status.message ||
				response.mensagem ||
				response.message ||
				''
			);
		};

		$scope.openCreateEventCategoryModal = (event, target = 'create') => {
			if (event) {
				event.preventDefault();
				event.stopPropagation();
			}

			$scope.eventCategoryTarget = target;
			$scope.eventCategoriesOpen = false;
			$scope.categoryPendingDeletionId = null;
			$scope.newEventCategory = {
				nome: '',
				corCategoria: '#2d2d2d'
			};
			$scope.eventCategoryNameDuplicated = false;
			$scope.eventCategoryColorPickerOpen = false;

			$('#modalCreateEventCategoryComponent')
				.one('hidden.bs.modal', () => {
					if (
						$('#modalCreateAgendaEventComponent').hasClass('show') ||
						$('#modalEditAgendaEventComponent').hasClass('show')
					) {
						$('body').addClass('modal-open');
					}
				})
				.modal('show');
		};

		$scope.createEventCategory = async form => {
			const name = ($scope.newEventCategory.nome || '').trim();

			$scope.newEventCategory.nome = name;

			if (!form.$valid || $scope.eventCategoryCreationLoading) return;

			const normalizedName = name.toLocaleLowerCase('pt-BR');
			const duplicatedCategory = $scope.eventCategories
				.getItems()
				.some(
					category =>
						category.nome.trim().toLocaleLowerCase('pt-BR') === normalizedName
				);

			if (duplicatedCategory) {
				$scope.eventCategoryNameDuplicated = true;
				notification.danger(
					'Erro ao cadastrar categoria. Já existe uma categoria com este nome.'
				);
				return;
			}

			$scope.eventCategoryCreationLoading = true;

			const category = {
				nome: name,
				corCategoria: $scope.newEventCategory.corCategoria,
				ativo: true,
				idPadraoCategoriaEvAgenda: null
			};

			try {
				await $http({
					...helper.http(API.eventCategories, 'POST'),
					data: category,
					messageOverride: {
						success(response, notify) {
							notify.success('Categoria cadastrada com sucesso.');
						},
						error() {}
					}
				});

				await $scope.recordEventCategories(true, name);
				$rootScope.$broadcast('eventCategoriesUpdated');
				$('#modalCreateEventCategoryComponent').modal('hide');
			} catch (error) {
				const message = $scope.getEventCategoryErrorMessage(error);

				$scope.eventCategoryNameDuplicated = /já existe uma categoria/i.test(
					message
				);
				$scope.eventCategoryNameDuplicated =
					$scope.eventCategoryNameDuplicated ||
					/existe uma categoria/i.test(message);
				notification.danger(
					message || 'Não foi possível cadastrar a categoria.'
				);
			} finally {
				$scope.eventCategoryCreationLoading = false;
			}
		};

		$scope.toggleEventCategoryColorPicker = event => {
			event.preventDefault();
			event.stopPropagation();
			$scope.eventCategoryColorPickerOpen = !$scope.eventCategoryColorPickerOpen;
		};

		$scope.selectEventCategoryColor = (event, color) => {
			event.preventDefault();
			event.stopPropagation();
			$scope.newEventCategory.corCategoria = color;
			$scope.eventCategoryColorPickerOpen = false;
		};

		$scope.createAgendaEvent = async form => {
			$rootScope.creationEventLoading = true;
			const isQuickCreate = [-3, -2, -1].includes(
				Number($rootScope.formCreatePrazo.quickCreateEventTypeId)
			);

			//Recupera dados de sincronização
			let dataSync = integracaoGoogleCalendar.recoverInfos();

			$scope.googleSync = dataSync.sincronizado;

			if ($rootScope.idAgenda === undefined) {
				await $scope.recordAgendas();
			}

			const fields = [
				'titulo',
				'dataHora',
				'dataHoraInicio',
				'diaInteiro',
				'idOpcaoLembreteAgenda',
				'idRepetEventoAgenda',
				'localizacao',
				'idTipoCompromisso',
				'idMovProcessoCliente',
				'idProcesso',
				'eventoGoogleId',
				'sincronizado',
				'idPessoaCliente',
				'idTipoEventoAgenda',
				'processoFixado'
			];

			const fieldValues = fields.reduce((result, input) => {
				result[input] = form[input]
					? $scope.getScopedInputValue(form[input])
					: undefined;

				return result;
			}, {});

			let {
				titulo,
				dataHora,
				dataHoraInicio,
				diaInteiro,
				idOpcaoLembreteAgenda,
				idRepetEventoAgenda,
				localizacao,
				idTipoCompromisso,
				idMovProcessoCliente,
				idProcesso,
				eventoGoogleId,
				sincronizado,
				idPessoaCliente,
				idTipoEventoAgenda,
				processoFixado
			} = fieldValues;

			if (form['localizacao']) {
				localizacao = $scope.getScopedInputValue(form['localizacao']);
			}

			// if (!idProcesso && !!processoFixado) {
			// 	idProcesso = processoFixado;
			// }

			if (
				$rootScope.formCreatePrazo &&
				$rootScope.formCreatePrazo.taskToEdit &&
				$rootScope.formCreatePrazo.taskToEdit.processo
			) {
				idProcesso =
					$rootScope.formCreatePrazo.taskToEdit.processo.idProcesso || null;
			}

			const endHour = $scope.getScopedInputValue(form.dataHoraFim);

			let importante, remoto, presencial;

			if (form && form['importante']) {
				importante =
					form['importante'].$viewValue || form['importante'].$modelValue;
			}

			if (form && form['presencial']) {
				presencial =
					form['presencial'].$viewValue || form['presencial'].$modelValue;
			}

			if (form && form['remoto']) {
				remoto = form['remoto'].$viewValue || form['remoto'].$modelValue;
			}

			const eventDate = `${dataHoraInicio.substr(3, 2)}-${dataHoraInicio.substr(
				0,
				2
			)}-${dataHoraInicio.substr(6)}`;

			let fixDate = eventDate.replace('-', '/').replace('-', '/');

			const initialDate = new Date(`${fixDate} ${dataHora}`);

			if (diaInteiro == true || dataHora == '') {
				dataHora = '23:59:59';
			}

			const finalDate = new Date(`${fixDate} ${dataHora}`);

			const HoraAtual = new Date();

			HoraAtual.setHours(HoraAtual.getHours());

			const hour = parseInt(dataHora.substr(0, 2), 10);

			if (hour >= 23) finalDate.setHours(23, 59);
			else if (diaInteiro) {
				finalDate.setHours(23, 59);
			} else {
				finalDate.setHours(endHour.substr(0, 2), endHour.substr(3, 2));
			}

			if (!validationHours(initialDate, finalDate, form)) return;

			const checkbox = document.querySelector(
				'#modalCreateAgendaEvent #sincronizado'
			);

			if (checkbox) {
				//O valor do 'edit-Sincronizado' sempre representa o inverso do que está no checkbox
				sincronizado = checkbox.checked;
			}

			const event = {
				titulo,
				dataHoraInicio: moment(initialDate).format('YYYY-MM-DDTHH:mm:ss'),
				dataHoraFim: moment(finalDate).format('YYYY-MM-DDTHH:mm:ss'),
				idAgenda: $rootScope.idAgenda,
				diaInteiro,
				idOpcaoLembreteAgenda,
				idRepetEventoAgenda,
				importante,
				localizacao,
				idProcesso,
				observacao: $rootScope.formCreatePrazo.taskToEdit.observacao,
				idTipoEventoAgenda: idTipoEventoAgenda
					? idTipoEventoAgenda
					: idTipoCompromisso,
				idCategoriaEventoAgenda:
					Number(idTipoCompromisso) === -3
						? $rootScope.formCreatePrazo.taskToEdit.idCategoriaEventoAgenda
						: undefined,
				eventoGoogleId,
				sincronizado: $scope.googleSync ? !sincronizado : false,
				remoto,
				presencial,
				idPessoaCliente
			};

			const linkedMovements =
				$rootScope.formCreatePrazo.idsMovProcessosVinculados || [];
			const firstLinkedMovement = linkedMovements[0];

			if (firstLinkedMovement && firstLinkedMovement.idMovProcessoCliente) {
				event.idsMovProcessosVinculados = linkedMovements;
			}

			event.observacao = $rootScope.configQuill.value;

			if (event.sincronizado) {
				await integracaoGoogleCalendar
					.insertGoogleEvent(event, fields, form, 'deadLines')
					.then(async () => {
						setTimeout(() => {
							$('#modalCreateAgendaEvent').modal('hide');
							$('#modalDetailsSchedule').modal('show');

							$('#modalCreateAgendaEventComponent').modal('hide');
						}, 1200);
					})
					.finally(async () => {
						setTimeout(() => {
							if (!isQuickCreate)
								$rootScope.formCreatePrazo.getEventComponent(event);

							refreshSidebarIndicators(
								event.dataHoraInicio || event.dataEventoAgenda
							);
						}, 1200);
					});
			} else {
				await $scope.sendEvent(event, fields, form, isQuickCreate);
			}

			/*eslint-enable */
		};

		$scope.updateIntimationsList = () => {
			const msg = { type: 'UPDATE_LIST_INTIMATIONS' };

			// iframe
			const iframe = document.querySelector('#module-intimation');

			if (!iframe) return;

			// envie para a janela do iframe
			iframe.contentWindow.postMessage(msg, '*');
		};

		$scope.updateMovementList = () => {
			const msg = { type: 'UPDATE_LIST_MOVEMENTS' };

			// iframe
			const iframe = document.querySelector('#module-movements');

			if (!iframe) return;

			// envie para a janela do iframe
			iframe.contentWindow.postMessage(msg, '*');
		};

		const refreshSidebarIndicators = eventDate => {
			const dateToRefresh = eventDate ? new Date(eventDate) : new Date();

			if (typeof $rootScope.recordDaysEvents === 'function') {
				$rootScope.recordDaysEvents(dateToRefresh);
			}

			if (typeof $rootScope.getImportants === 'function') {
				$rootScope.getImportants(dateToRefresh);
			}
		};

		$scope.sendEvent = (event, fields, form, isQuickCreate = false) => {
			$http({
				...helper.http(API.deadlineEvents, 'POST'),
				data: { itens: [event] },
				messageOverride: {
					success(response, notify) {
						let idTipoEventoAgenda = -3;

						if (
							response &&
							response.data &&
							response.data.itens &&
							response.data.itens[0] &&
							response.data.itens[0].idTipoEventoAgenda
						) {
							idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
						}

						let nameType =
							idTipoEventoAgenda == -3
								? 'Compromisso'
								: idTipoEventoAgenda == -1
								? 'Tarefa'
								: 'Prazo';

						notify.success(
							`${nameType} cadastrad${
								idTipoEventoAgenda == -1 ? 'a' : 'o'
							} com sucesso.`
						);
					}
				}
			})
				.then(async response => {
					$scope.googleSync = localStorage.getItem('gapi') == 'false';
					await $scope.updateIntimationsList();
					await $scope.updateMovementList();

					const createdEventDate =
						(response.data.itens &&
							response.data.itens[0] &&
							(response.data.itens[0].dataHoraInicio ||
								response.data.itens[0].dataEventoAgenda)) ||
						event.dataHoraInicio ||
						event.dataEventoAgenda;

					refreshSidebarIndicators(createdEventDate);

					fields.forEach(inputKey =>
						helper.defer(() => {
							const $control = form[inputKey];

							if ($control) {
								switch (inputKey) {
									case 'idRepetEventoAgenda':
									case 'idOpcaoLembreteAgenda':
										$control.$setViewValue(-1);
										break;
									case 'idTipoCompromisso':
										$control.$setViewValue('');
										$control.$$ngModelSet('');
										$control.$$setModelValue('');
										helper.defer(() => ($scope.quickToggle = false));
										helper.defer(() => ($scope.quickToggle = true));
										break;
									case 'diaInteiro':
										$control.$setViewValue(false);
										$control.$$ngModelSet(false);
										$control.$$setModelValue(false);
										break;
									case 'dataHoraInicio':
										$control.$setViewValue(moment().format('DD/MM/YYYY'));
										break;
									case 'idTipoEventoAgenda':
									case 'idMovProcessoCliente':
									case 'importante':
										break;
									default:
										$control.$setViewValue('');
										break;
								}

								$control.$render();
							}
						})
					);

					setTimeout(() => {
						$scope.$resetFormValidation('editAgendaEvent')();
						$scope.$resetFormValidation('createEvent')();
						$rootScope.formCreatePrazo.taskToEdit.processo = {};

						$('#modalCreateAgendaEventComponent').modal('hide');

						$('#modalDetailsSchedule').modal('show');

						if (!isQuickCreate) {
							setTimeout(() => {
								$rootScope.formCreatePrazo.getEventComponent(
									response.data.itens[0]
								);
							}, 500);
						}
					}, 100);
				})
				.finally(() => {
					$rootScope.creationEventLoading = false;
				});
		};

		// Função para gerar a mensagem de erro
		function getErrorMessage(limit) {
			return `O limite de ${limit} caracteres foi excedido.`;
		}

		const limit = 800; // substitua por seu limite desejado

		$rootScope.updateErrorQuill = (quilInUse, old) => {
			// Extrair apenas o texto, ignorando as tags HTML
			let textContent = quilInUse.root.innerText;

			if (textContent.length >= limit) {
				quilInUse.setContents(old, 'silent');
				quilInUse.update();

				// Verifique se a div de erro já existe
				let $errorMessage = $('#error-message');

				if ($errorMessage.length) {
					$('#error-message').remove();
				}

				// Se a div de erro não existir, crie-a e insira-a após o editor Quill
				$errorMessage = $(
					'<div id="error-message" style="color: #d32f2f"></div>'
				);
				$(quilInUse.container).after($errorMessage);

				$errorMessage.text(getErrorMessage(limit, textContent.length));

				// Altere a cor da borda do editor e da barra de ferramentas para vermelho
				$(quilInUse.container).css('border-color', '#d32f2f');
				quilInUse.getModule('toolbar').container.style.borderColor = '#d32f2f';
			} else {
				// Remova a div de erro se o conteúdo estiver dentro do limite
				$('#error-message').remove();

				// Altere a cor da borda do editor e da barra de ferramentas para a cor original
				$(quilInUse.container).css('border-color', '');
				quilInUse.getModule('toolbar').container.style.borderColor = '';
			}
		};

		var quillExpandedNew = {};

		// quando clickar fora do modal
		$scope.handleClickOutsideQuillNew = event => {
			event.preventDefault();

			let modal = document.getElementById('modalExpandNew');

			if ($(event.target).hasClass('clickoutCampanha')) return;

			if (!modal.contains(event.target) || $(event.target).hasClass('goback')) {
				$scope.modalquillExpanded = false;

				let htmlContentE = quillExpandedNew.root.innerHTML;

				if ($scope.modalquillExpandName == 'new')
					$rootScope.setQuillNew(htmlContentE);
				else $rootScope.setQuillEdit(htmlContentE);

				$rootScope.configQuill.value = $scope.quillExpandedHtml;
				$scope.activeModal = undefined;

				let delta = '';

				quillExpandedNew.setContents(delta, 'silent');

				// Remova a div de erro se o conteúdo estiver dentro do limite
				$('#error-message').remove();

				$(quillExpandedNew.container).css('border-color', '');
				quillExpandedNew.getModule('toolbar').container.style.borderColor = '';

				$('#modalExpandNew').modal('hide');

				document.removeEventListener(
					'click',
					$scope.handleClickOutsideQuillNew,
					false
				);
			}
		};

		// abrir modal de expanção
		$scope.openModalOverlayQuillNew = (e, quillInUse, limit) => {
			e.preventDefault();
			$scope.modalquillExpanded = true;
			$scope.modalquillExpandName = quillInUse;

			$('#modalExpandNew').modal('show');

			setTimeout(() => {
				quillExpandedNew = new Quill('#editor-quill-expanded-new', {
					modules: {
						toolbar: '#toolbar-container-quill-ex-new'
					},
					placeholder: 'Digite o texto',
					theme: 'snow'
				});

				// chama quando alterar texto Expanção
				quillExpandedNew.on('text-change', (delta, old) => {
					if (limit !== 'none')
						$rootScope.updateErrorQuill(quillExpandedNew, old);

					let htmlContent = quillExpandedNew.root.innerHTML;

					$scope.quillExpandedHtml = htmlContent;
				});

				quillExpandedNew.clipboard.addMatcher('img', () => {
					notification.danger(
						'Não é possível adicionar imagens ao campo selecionado.'
					);

					// Retorna um novo Delta vazio, ignorando a imagem
					return new Delta();
				});

				let htmlContent = $rootScope.configQuill.value;

				const delta = quillExpandedNew.clipboard.convert(htmlContent);

				quillExpandedNew.setContents(delta, 'silent');

				$scope.quillExpandedHtml = $rootScope.configQuill.value;
			}, 100);

			setTimeout(() => {
				document.addEventListener(
					'click',
					$scope.handleClickOutsideQuillNew,
					false
				);
			}, 200);
		};

		// botoes de formatação
		$scope.formatQuillExpanded = (attribute, value, event, expanded) => {
			event.preventDefault();

			if (!expanded) return;

			let currentQuill = quillExpandedNew;

			$scope.activeAlign = value;

			currentQuill.format(attribute, value);
		};

		$scope.loadPerson = (forceRefresh = false) => {
			let peoples = [];

			try {
				let local = localStorage.getItem('_MAIN_STORAGE_');

				if (local) {
					let storage = JSON.parse(local);

					if (storage && Array.isArray(storage.peoples)) {
						peoples = storage.peoples;
					}
				}
			} catch (error) {
				// eslint-disable-next-line
				console.error('Erro ao recuperar peoples do localStorage:', error);
			}

			// Já possui no cache
			if (peoples.length > 0 && !forceRefresh) {
				$scope.eventsPeoples.setItems(peoples);
				$scope.eventsPeoples.setReady(true);

				$rootScope.formCreatePrazo.eventsPeoples = $scope.eventsPeoples;

				return;
			}

			$scope.eventsPeoples.setLoading(true);
			$scope.eventsPeoples.setReady(false);

			let params = {
				campos: 'nomePessoaCliente, idPessoaCliente, contato.Ativo',
				registrosPorPagina: 100,
				paginaAtual: 1
			};

			$http({
				...helper.http(API.personContact, 'GET'),
				params: params
			})
				.then(response => {
					let firstItems =
						response && response.data && Array.isArray(response.data.itens)
							? response.data.itens
							: [];

					let paginacao =
						response && response.data ? response.data.paginacao : null;

					let pageSize =
						paginacao && paginacao.registrosPorPagina
							? paginacao.registrosPorPagina
							: firstItems.length || 100;

					let total =
						paginacao && paginacao.registrosTotal != null
							? paginacao.registrosTotal
							: firstItems.length;

					let totalPages =
						paginacao && paginacao.paginaTotal
							? paginacao.paginaTotal
							: Math.ceil(total / pageSize);

					if (totalPages <= 1) {
						return firstItems;
					}

					let requests = [];

					for (let page = 2; page <= totalPages; page++) {
						requests.push(
							$http({
								...helper.http(API.personContact, 'GET'),
								params: {
									campos: params.campos,
									registrosPorPagina: params.registrosPorPagina,
									paginaAtual: page
								}
							})
						);
					}

					return Promise.all(requests).then(responses => {
						let allItems = firstItems.slice();

						responses.forEach(item => {
							if (item && item.data && Array.isArray(item.data.itens)) {
								allItems = allItems.concat(item.data.itens);
							}
						});

						return allItems;
					});
				})
				.then(items => {
					items = Array.isArray(items) ? items : [];

					let peoples = items.filter(item => {
						return (
							item &&
							Array.isArray(item.contato) &&
							item.contato.length > 0 &&
							item.contato[0] &&
							item.contato[0].ativo === true
						);
					});

					let peoplesInactive = items.filter(item => {
						return !(
							item &&
							Array.isArray(item.contato) &&
							item.contato.length > 0 &&
							item.contato[0] &&
							item.contato[0].ativo === true
						);
					});

					$scope.eventsPeoples.setItems(peoples);

					try {
						let local = localStorage.getItem('_MAIN_STORAGE_');
						let storage = {};

						if (local) {
							storage = JSON.parse(local) || {};
						}

						storage.peoples = peoples;
						storage.peoplesInactive = peoplesInactive;

						localStorage.setItem('_MAIN_STORAGE_', JSON.stringify(storage));
					} catch (error) {
						// eslint-disable-next-line
						console.error('Erro ao gravar peoples no localStorage:', error);
					}

					var idPessoaCliente =
						$rootScope.formCreatePrazo.editingAgendaEvent.idPessoaCliente;

					var person =
						(peoplesInactive &&
							peoplesInactive.find(function(p) {
								return p.idPessoaCliente == idPessoaCliente;
							})) ||
						(peoples &&
							peoples.find(function(p) {
								return p.idPessoaCliente == idPessoaCliente;
							}));

					if (person && person.idPessoaCliente) {
						$rootScope.formCreatePrazo.editingAgendaEvent.contatoAtivo =
							person.contato[0].ativo;
					}

					if (
						$rootScope.formCreatePrazo &&
						$('#modalEditAgendaEventComponent').hasClass('show')
					) {
						if (
							$rootScope.formCreatePrazo.editingAgendaEvent &&
							!$rootScope.formCreatePrazo.editingAgendaEvent.contatoAtivo &&
							$rootScope.formCreatePrazo.editingAgendaEvent.idPessoaCliente
						) {
							$rootScope.formCreatePrazo.editingAgendaEvent.idPessoaCliente = -1;
						}
					}

					$rootScope.formCreatePrazo.eventsPeoples = $scope.eventsPeoples;
				})
				.catch(error => {
					// eslint-disable-next-line
					console.error('Erro ao carregar peoples:', error);

					$scope.eventsPeoples.setItems([]);
				})
				.finally(() => {
					$scope.eventsPeoples.setNotLoading();
					$scope.eventsPeoples.setReady(true);
				});
		};

		setTimeout(() => {
			$('#modalCreateAgendaEventComponent').on('hidden.bs.modal', () => {
				$rootScope.formCreatePrazo.taskToEdit.processo = {};
				$rootScope.formCreatePrazo.idPessoaCliente = '';

				$('#createEventSelectTaskPerson')
					.val('')
					.trigger('change.select2');

				$scope.$resetFormValidation('editAgendaEvent')();
				$scope.$resetFormValidation('createEvent')();

				if (!$rootScope.$$phase) {
					$rootScope.$apply();
				}
			});

			$('#modalCreateAgendaEventComponent').on('shown.bs.modal', () => {
				if (!$rootScope.formCreatePrazo.quickCreateEventTypeId) {
					$rootScope.formCreatePrazo.taskToEdit.idTipoCompromisso =
						$rootScope.formCreatePrazo.idTipoCompromisso || void 0;
				}

				$rootScope.formCreatePrazo.idNotificacaoCompromisso = -1;

				$scope.$resetFormValidation('createEvent')();

				$('#createEventInputTaskDate')
					.data('datepicker')
					.clear();

				let getEvents = sessionStorage.getItem('__EVENTS_TYPES__');
				let getEventsNotifications = sessionStorage.getItem(
					'__EVENTS_NOTIFICATIONS__'
				);

				if (getEvents) {
					$scope.eventsTypes.setItems(JSON.parse(getEvents));
					$scope.eventsTypes.setReady(true);
				}
				if (getEventsNotifications) {
					$scope.eventsNotifications.setItems(
						JSON.parse(getEventsNotifications)
					);
					$scope.eventsNotifications.setReady(true);
				}

				$rootScope.formCreatePrazo.eventsTypes = $scope.eventsTypes;
				$rootScope.formCreatePrazo.eventsNotifications =
					$scope.eventsNotifications;

				$rootScope.formCreatePrazo.idPessoaCliente = '';

				if ($scope.hasPersonPermissions) $scope.loadPerson(true);

				if (!$rootScope.$$phase) {
					$rootScope.$apply();
				}

				$rootScope.initQuillNew();

				$timeout(() => {
					const tipo = $rootScope.formCreatePrazo.taskToEdit.idTipoCompromisso;

					const tipoEstaVazio =
						tipo === undefined || tipo === null || tipo === '';

					const campoId = tipoEstaVazio
						? 'createEventSelectTaskTypeComponent'
						: 'createEventInputTaskTitle';

					const campo = document.getElementById(campoId);

					if (campo) {
						campo.focus();
					}
				}, 0);
			});

			$('#modalEditAgendaEventComponent').on('hidden.bs.modal', () => {
				$rootScope.formCreatePrazo.editingAgendaEvent.idPessoaCliente = '';

				$('#editEventSelectTaskPerson')
					.val('')
					.trigger('change.select2');

				$scope.$resetFormValidation('editAgendaEvent')();

				if (!$rootScope.$$phase) {
					$rootScope.$apply();
				}
			});

			$('#modalEditAgendaEventComponent').on('shown.bs.modal', () => {
				$scope.eventCategoryTarget = 'edit';
				$scope.eventCategoriesOpen = false;
				$scope.eventCategorySearch.term = '';
				$scope.categoryPendingDeletionId = null;
				$scope.filterEventCategories();

				let getEvents = sessionStorage.getItem('__EVENTS_TYPES__');

				if (getEvents) {
					$scope.eventsTypes.setItems(JSON.parse(getEvents));
					$scope.eventsTypes.setReady(true);
				}

				$rootScope.formCreatePrazo.eventsTypes = $scope.eventsTypes;

				$rootScope.formCreatePrazo.editingAgendaEvent.idTipoCompromisso =
					$rootScope.formCreatePrazo.idTipoCompromisso || void 0;

				if (
					$rootScope.formCreatePrazo.editingAgendaEvent &&
					$rootScope.formCreatePrazo.editingAgendaEvent.idProcesso
				) {
					$rootScope.formCreatePrazo.editingAgendaEvent.processo = {
						...$rootScope.formCreatePrazo.editingAgendaEvent.processo,
						id: $rootScope.formCreatePrazo.editingAgendaEvent.idProcesso
					};
				}

				if (
					$rootScope.formCreatePrazo.editingAgendaEvent &&
					$rootScope.formCreatePrazo.editingAgendaEvent.idPessoaCliente
				) {
					$('#editEventSelectTaskPerson')
						.val($rootScope.formCreatePrazo.editingAgendaEvent.idPessoaCliente)
						.trigger('change.select2');
				}

				let getEventsNotifications = sessionStorage.getItem(
					'__EVENTS_NOTIFICATIONS__'
				);

				if (getEventsNotifications) {
					$scope.eventsNotifications.setItems(
						JSON.parse(getEventsNotifications)
					);
					$scope.eventsNotifications.setReady(true);
				}

				$rootScope.formCreatePrazo.eventsNotifications =
					$scope.eventsNotifications;

				if ($scope.hasPersonPermissions) $scope.loadPerson(true);

				if (!$rootScope.$$phase) {
					$rootScope.$apply();
				}
			});
		}, 1000);

		$scope.getAgendaEventTypeLabel = agendaEvent =>
			String(
				agendaEvent.tipoEventoAgenda ||
					agendaEvent.tipoEvento ||
					agendaEvent.nomeTipoEventoAgenda ||
					'evento'
			).toLocaleLowerCase('pt-BR');

		$scope.getAgendaEventCompletedMessage = (agendaEvent, completed) => {
			const normalizedType = $scope.getAgendaEventTypeLabel(agendaEvent);
			const type =
				normalizedType.charAt(0).toLocaleUpperCase('pt-BR') +
				normalizedType.slice(1);
			const isTask = type === 'tarefa';
			const marked = isTask ? 'marcada' : 'marcado';
			const completedText = completed
				? isTask
					? 'concluída'
					: 'concluído'
				: isTask
				? 'não concluída'
				: 'não concluído';

			return `${type} ${marked} como ${completedText}`;
		};

		$scope.clearEditedPerson = evento => {
			if (!evento) {
				return;
			}

			evento.idPessoaCliente = '';

			$('#editEventSelectTaskPerson')
				.val('')
				.trigger('change.select2');
		};

		$scope.clearCreatedPerson = () => {
			if ($scope.createEvent && $scope.createEvent.idPessoaCliente) {
				$scope.createEvent.idPessoaCliente.$setViewValue('');
				$scope.createEvent.idPessoaCliente.$render();
			}

			$rootScope.formCreatePrazo.idPessoaCliente = '';

			$('#createEventSelectTaskPerson')
				.val('')
				.trigger('change.select2');
		};

		$scope.updateAgendaEvent = (agendaEvent, type) => {
			if (agendaEvent.idPessoaCliente == -1) {
				notification.danger(
					'A pessoa vinculada a este evento não existe mais. Você pode selecionar outra pessoa ou salvar sem vínculo.'
				);

				return;
			}

			if (type == 'done') {
				agendaEvent.concluido = !agendaEvent.concluido;
			}

			$scope.printing = true;
			$scope.updatingAgendaEvent = true;

			if (agendaEvent._hora === '' || !agendaEvent._hora) {
				agendaEvent._hora = '00:00';
			}

			const getHourMinute = value => {
				if (!value || typeof value !== 'string' || !value.includes(':')) {
					return null;
				}

				const [hour, minute] = value.split(':').map(Number);

				if (Number.isNaN(hour) || Number.isNaN(minute)) {
					return null;
				}

				return { hour, minute };
			};

			const { _dia, _hora, _horaFim, ...event } = agendaEvent;

			delete event.nomeCategoriaEventoAgenda;

			if (_dia && _hora) {
				const initialDay = parseInt(_dia.substr(0, 2), 10);
				const initialMonth = parseInt(_dia.substr(3, 2), 10) - 1;
				const initialYear = parseInt(_dia.substr(6), 10);

				const startTime = getHourMinute(_hora);
				const endTime = getHourMinute(_horaFim);

				if (!startTime || (!event.diaInteiro && !endTime)) {
					notification.danger('Informe horários válidos para o compromisso.');

					$scope.printing = false;
					$scope.updatingAgendaEvent = false;

					return;
				}

				const initialDate = new Date(
					initialYear,
					initialMonth,
					initialDay,
					startTime.hour,
					startTime.minute,
					0,
					0
				);

				let finalDate;

				if (event.diaInteiro) {
					initialDate.setHours(0, 0, 0, 0);
					finalDate = new Date(
						initialYear,
						initialMonth,
						initialDay,
						23,
						59,
						0,
						0
					);
				} else {
					finalDate = new Date(
						initialYear,
						initialMonth,
						initialDay,
						endTime.hour,
						endTime.minute,
						0,
						0
					);
				}

				event.dataHoraInicio = moment(initialDate).format(
					'YYYY-MM-DDTHH:mm:ss'
				);
				event.dataHoraFim = moment(finalDate).format('YYYY-MM-DDTHH:mm:ss');
			}

			if (!validationHours(event.dataHoraInicio, event.dataHoraFim)) {
				$scope.printing = false;
				$scope.updatingAgendaEvent = false;

				return;
			}

			if (event.processo && event.processo.idProcesso) {
				event.idProcesso = event.processo.idProcesso || null;
				event.numeroProcesso = event.processo.numeroProcesso;
				delete event.processo;
			}

			const checkbox = document.querySelector(
				'#modalEditAgendaEventComponent #edit-sincronizado'
			);

			if (checkbox) {
				//O valor do 'edit-Sincronizado' sempre representa o inverso do que está no checkbox
				event.sincronizado = !document.querySelector(
					'#modalEditAgendaEventComponent #edit-sincronizado'
				).checked;
			}

			if ($scope.googleSync && checkbox) {
				event.sincronizado = !checkbox.checked;
			}

			// Se esta vencido
			let vanquished = moment(
				agendaEvent.dataHoraInicio,
				'YYYY-MM-DDTHH:mm:ss'
			).isBefore(moment());

			event.observacao = $rootScope.configQuill.value;

			$scope.request = () => {
				// Sim poderia verificar apenas se era agenda :)
				const anotherRouters = [
					'root.default.movements.list1.movementsDetails',
					'root.default.module-intimations',
					'root.default.movements.list4.movementsDetails',
					'root.default.movements.inssDetails',
					'root.default.movements.list3.movementsDetails',
					'root.default.movements.list2.movementsDetails'
				];

				$http({
					...helper.http(API.deadlineEvents, 'PUT'),
					data: {
						itens: [
							{
								...event,
								concluido: event.concluido
							}
						]
					},
					messageOverride: {
						success(response, notify) {
							let idTipoEventoAgenda = -3;

							if (
								response &&
								response.data &&
								response.data.itens &&
								response.data.itens[0] &&
								response.data.itens[0].idTipoEventoAgenda
							) {
								idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
							}

							let nameType =
								idTipoEventoAgenda == -3
									? 'Compromisso'
									: idTipoEventoAgenda == -1
									? 'Tarefa'
									: 'Prazo';

							if (type === 'edit') {
								notify.success(
									`${nameType} editad${
										idTipoEventoAgenda == -1 ? 'a' : 'o'
									} com sucesso.`
								);
							} else if (type === 'done' && agendaEvent.concluido === false) {
								notify.success(
									$scope.getAgendaEventCompletedMessage(agendaEvent, false)
								);
							} else if (type === 'done' && agendaEvent.concluido === true) {
								notify.success(
									$scope.getAgendaEventCompletedMessage(agendaEvent, true)
								);
							} else if (type != 'edit' && type != 'done') {
								notify.success(type);
							}

							$timeout(() => {
								$scope.printing = false;
								$scope.updatingAgendaEvent = false;
							}, 1000);
						},
						error(response, notify) {
							let idTipoEventoAgenda = -3;

							if (
								response &&
								response.data &&
								response.data.itens &&
								response.data.itens[0] &&
								response.data.itens[0].idTipoEventoAgenda
							) {
								idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
							}

							let nameType =
								idTipoEventoAgenda == -3
									? 'Compromisso'
									: idTipoEventoAgenda == -1
									? 'Tarefa'
									: 'Prazo';

							notify.success(
								`${nameType} não ${
									type === 'done'
										? `concluíd${idTipoEventoAgenda == -1 ? 'a' : 'o'}`
										: `editad${idTipoEventoAgenda == -1 ? 'a' : 'o'}`
								}!`
							);

							$scope.updatingAgendaEvent = false;
							$timeout(() => {
								$scope.printing = false;
								$scope.updatingAgendaEvent = false;
							}, 1000);
						}
					}
				}).then(response => {
					$('#modalEditAgendaEventComponent').modal('hide');

					const [event] = response.data.itens;

					event.idsMovimentosProcesso = agendaEvent.idsMovimentosProcesso;

					$scope.event = event;

					if (
						$scope.$parent &&
						$scope.$parent.events &&
						$scope.$parent.events.items
					) {
						const itemIndexFromParentScope = $scope.$parent.events.items.findIndex(
							x => x.id === $scope.event.id
						);

						if (itemIndexFromParentScope >= 0)
							helper.defer(
								() =>
									($scope.$parent.events.items[
										itemIndexFromParentScope
									] = event)
							);
					}

					const { eventId, filtro, paginaAtual } = $state.params;

					const _eventId = eventId;
					const _filtro = filtro || 'vencendo';
					const _paginaAtual = paginaAtual || 1;

					if (!anotherRouters.includes($state.current.name)) {
						$state.go(
							$state.current,
							{
								eventId: _eventId,
								filtro: _filtro,
								paginaAtual: _paginaAtual
							},
							{ reload: true, inherit: false, notify: true }
						);
					}

					$scope.updateIntimationsList();
					$scope.updateMovementList();

					if (!anotherRouters.includes($state.current.name))
						$rootScope.getImportants();

					$('#modalDetailsSchedule').modal('hide');

					if ($state.current.name != 'root.default.module-intimations')
						location.reload();
				});
			};

			if (event.sincronizado && !$rootScope.noSync) {
				if (agendaEvent.eventoGoogleId === 'true')
					delete agendaEvent.eventoGoogleId;

				let isInsert = Boolean(agendaEvent.eventoGoogleId);

				if (!isInsert && event.sincronizado) {
					//criar um evento na agenda
					integracaoGoogleCalendar.insertGoogleEvent(
						event,
						null,
						null,
						type,
						$scope.request
					);

					$timeout(() => {
						$scope.printing = false;
					}, 2000);
				} else if (vanquished && event.eventoGoogleId) {
					//Excluir se for vencido
					integracaoGoogleCalendar.deleteGoogleEvent(event);

					setTimeout(() => {
						delete event.eventoGoogleId;

						integracaoGoogleCalendar.insertGoogleEvent(
							event,
							null,
							null,
							type,
							$scope.request
						);

						$timeout(() => {
							$scope.printing = false;
						}, 2000);
					});
				} else {
					//atualizar evento ja existente
					integracaoGoogleCalendar.updateGoogleEvent(event, $scope.request);

					$timeout(() => {
						$scope.printing = false;
					}, 2000);
				}

				setTimeout(() => {
					$scope.closeModal('modalEditAgendaEventComponent');
					$scope.$resetFormValidation('editAgendaEvent')();
				}, 1000);
			} else {
				//atualizar apenas no sistema advise
				event.sincronizado = false;

				$scope.request();
			}
		};

		$scope.recordTribunalSystemCode = function(id) {
			var font = $scope.listaFontes.find(function(f) {
				return f.idFonteXTipoPesquisa == id;
			});

			if (!font) {
				$scope.stageCertificate = 1;
				$scope.sourceQty = 0;
				$scope.sourceItems = [];
				$scope.tipoAcessoFonte = [];
				$scope.cleanCertificadoRequired();

				return;
			}

			$scope.stageCertificate = 1;

			if (
				font.fonteTipoPesquisaIntimacoes &&
				font.fonteTipoPesquisaIntimacoes.length
			) {
				$scope.sourceQty = font.fonteTipoPesquisaIntimacoes.length;
				$scope.sourceItems = font.fonteTipoPesquisaIntimacoes;

				if (font.fonteTipoPesquisaIntimacoes.length > 1) {
					$scope.tipoAcessoFonte = [];
				} else {
					var intimacao = font.fonteTipoPesquisaIntimacoes[0];

					$scope.tipoAcessoFonte =
						intimacao && intimacao.idTipoAcessoFontePesq
							? intimacao.idTipoAcessoFontePesq
							: 0;
				}
			} else {
				$scope.sourceQty = 0;
				$scope.sourceItems = [];
				$scope.tipoAcessoFonte = [];
			}

			$scope.cleanCertificadoRequired();
		};

		$scope.AccessType = function(selectedValueAccess) {
			let selectedItem = $scope.sourceItems.find(
				item => item.idTipoAcessoFontePesq === selectedValueAccess
			);

			if (selectedItem.idTipoAcessoFontePesq == -1) {
				$scope.tipoAcessoFonte = [];
				$scope.tipoAcessoFonte.push(-1);

				$timeout(function() {
					var userLogin = document.getElementById('createCatchLogin');

					if (userLogin) {
						userLogin.focus();
					}
				});
			} else if (selectedItem.idTipoAcessoFontePesq == -2) {
				$scope.tipoAcessoFonte = [];
				$scope.tipoAcessoFonte.push(-1);
				$scope.tipoAcessoFonte.push(-2);

				$timeout(function() {
					var userLogin = document.getElementById('createCatchLogin');

					if (userLogin) {
						userLogin.focus();
					}
				});
			} else if (selectedItem.idTipoAcessoFontePesq == -5) {
				$scope.tipoAcessoFonte = [];
				$scope.tipoAcessoFonte.push(-1);
				$scope.tipoAcessoFonte.push(-2);
				$scope.tipoAcessoFonte.push(-3);
				$scope.tipoAcessoFonte.push(-5);
				$timeout(function() {
					var userLogin = document.getElementById('createCatchLogin');

					if (userLogin) {
						userLogin.focus();
					}
				});
			} else {
				$scope.tipoAcessoFonte = [];
				$scope.tipoAcessoFonte.push(-3);
			}
		};

		$scope.customSearchPrazo = text => {
			return String(text == null ? '' : text).replace(/[.,\/\\_-]/g, '');
		};

		$scope.syncPrazoProcess = () => {
			const form = $scope.formCreatePrazo;

			if (!form || !form.taskToEdit) {
				return;
			}

			const processo = form.taskToEdit.processo;

			const hasProcess =
				processo &&
				processo.id != null &&
				processo.id !== '' &&
				processo.nome != null &&
				processo.nome !== '';

			form.processSelectedValue = hasProcess ? String(processo.nome) : '';

			form.processSelectedOptions = hasProcess ? [processo] : [];
		};

		$scope.onPrazoProcessSelected = (item, selection) => {
			const form = $scope.formCreatePrazo;

			if (!form || !form.taskToEdit) {
				return;
			}

			const task = form.taskToEdit;

			if (
				$scope.creationEventLoading ||
				(task.processo && task.processo.fixado)
			) {
				return;
			}

			const processo =
				item ||
				(form.processSelectedOptions || []).find(option => {
					return selection && String(option.nome) === String(selection.id);
				});

			if (
				!processo ||
				processo.id == null ||
				processo.id === '' ||
				processo.nome == null ||
				processo.nome === ''
			) {
				$scope.syncPrazoProcess();

				return;
			}

			task.processo = {
				...processo,
				fixado: false
			};

			$scope.syncPrazoProcess();
		};

		$scope.clearPrazoProcess = () => {
			const form = $scope.formCreatePrazo;

			if (!form || !form.taskToEdit) {
				return;
			}

			const task = form.taskToEdit;

			if (
				$scope.creationEventLoading ||
				(task.processo && task.processo.fixado)
			) {
				return;
			}

			task.processo = null;

			$scope.syncPrazoProcess();
		};

		$scope.$watchGroup(
			[
				'formCreatePrazo',
				'formCreatePrazo.taskToEdit',
				'formCreatePrazo.taskToEdit.processo',
				'formCreatePrazo.taskToEdit.processo.id',
				'formCreatePrazo.taskToEdit.processo.nome',
				'formCreatePrazo.taskToEdit.processo.fixado'
			],
			$scope.syncPrazoProcess
		);

		const hasEditProcessValue = value => {
			return value !== undefined && value !== null && value !== '';
		};

		const syncEditAgendaProcess = () => {
			const form = $scope.formCreatePrazo;

			if (!form) {
				return;
			}

			const evento = form.editingAgendaEvent;
			const processo = evento && evento.processo;

			const hasProcess =
				processo &&
				hasEditProcessValue(processo.id) &&
				hasEditProcessValue(processo.nome);

			form.editProcessSelectedOptions = hasProcess ? [processo] : [];

			if (evento) {
				evento.processSelectedValue = hasProcess ? String(processo.nome) : '';
			}
		};

		$scope.changeEditedProcess = (evento, item, selection) => {
			const form = $scope.formCreatePrazo;

			if (!form || !evento || form.editingAgendaEvent !== evento) {
				return;
			}

			if (evento.processo && evento.processo.fixado) {
				syncEditAgendaProcess();

				return;
			}

			const selectedItem = item || (selection && selection.originalItem);

			if (!selectedItem) {
				syncEditAgendaProcess();

				return;
			}

			const idProcesso = selectedItem.idProcesso;
			const idPasta = selectedItem.id;

			const nomeProcesso = hasEditProcessValue(selectedItem.nome)
				? selectedItem.nome
				: selection && selection.text;

			if (
				!hasEditProcessValue(idProcesso) ||
				!hasEditProcessValue(idPasta) ||
				!hasEditProcessValue(nomeProcesso)
			) {
				syncEditAgendaProcess();

				return;
			}

			evento.processo = {
				...selectedItem,
				id: idProcesso,
				pasta: idPasta,
				nome: String(nomeProcesso),
				fixado: false
			};

			syncEditAgendaProcess();
		};

		$scope.clearEditedProcess = evento => {
			const form = $scope.formCreatePrazo;

			if (
				!form ||
				!evento ||
				form.editingAgendaEvent !== evento ||
				(evento.processo && evento.processo.fixado)
			) {
				return;
			}

			evento.numeroProcesso = null;
			evento.idProcesso = null;
			evento.processo = null;

			syncEditAgendaProcess();
		};

		$scope.$watchGroup(
			[
				'formCreatePrazo',
				'formCreatePrazo.editingAgendaEvent',
				'formCreatePrazo.editingAgendaEvent.processo',
				'formCreatePrazo.editingAgendaEvent.processo.id',
				'formCreatePrazo.editingAgendaEvent.processo.pasta',
				'formCreatePrazo.editingAgendaEvent.processo.nome',
				'formCreatePrazo.editingAgendaEvent.processo.fixado'
			],
			syncEditAgendaProcess
		);

		/**
		 * Método que traz Órgãos Judiciais relacionadas ao processo
		 */
		$scope.recordJudicialBranches = (responseStore, more, pesq) => {
			$scope.loadingJudicial = true;

			// const paginaAtual =
			// 	more == 'mais' ? $scope.pageJudicialBranches.paginaAtual + 1 : 1;

			$http({
				...helper.http(API.subpoena, 'consultaOrgao'),
				method: 'GET',
				params: {
					...helper.httpFields(['*']),
					ativo: true,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null,
					idUsuarioCliente: !$scope.groupUserSelected
						? $scope.userData.idUsuarioCliente
						: null,
					paginaAtual: 1,
					registrosPorPagina: 999
				}
			})
				.then(response => {
					// more == 'mais'
					// 	? responseStore.items.push(...response.data.itens)
					responseStore.setItems(response.data.itens);

					if (more != 'modal') {
						// $scope.pageJudicialBranches = response.data.paginacao;

						// if (
						// 	$scope.pageJudicialBranches.paginaTotal > 1 &&
						// 	$scope.pageJudicialBranches.paginaAtual !==
						// 		$scope.pageJudicialBranches.paginaTotal
						// )
						// 	$scope.moreJudicial = true;

						if ($stateParams.orgaoJudicial) {
							const judicial = response.data.itens.filter(
								judi => judi.idOrgaoJudiciario == $stateParams.orgaoJudicial
							);

							if (judicial.length)
								if (judicial[0].siglaOrgao != $scope.titleCourts) {
									$scope.titleCourts = judicial[0].siglaOrgao;
									$scope.cloneFilter.nomeJudicial = judicial[0].siglaOrgao;
								}
						}

						if (pesq && !response.data.itens.length) {
							$scope.notCourts = true;
						} else if (pesq && response.data.itens.length) {
							$scope.notCourts = false;
						}
					}
				})

				.finally(() => {
					$scope.loadingJudicial = false;
					responseStore.setReady(true);
				});
		};

		$scope.changeInput = value => {
			value == 'login'
				? ($scope.changelogin = true)
				: ($scope.changePassword = true);
		};

		$scope.getCourts = () => {
			$scope.recordJudicialBranches($scope.clientUserJudicialOrgansList);
		};

		$scope.modalCaptura = () => {
			$scope.blockQRCode = true;
			$scope.newCatch.nomeResponsavel = $scope.userData.nome;

			if ($scope.judicialOrgansModal.hasNotItems())
				$scope.recordJudicialBranches($scope.judicialOrgansModal, 'modal');

			$('#modalCreateCatch')
				.modal('show')
				.on('hidden.bs.modal', () => {
					$scope.tipoAcessoFonte = [];
					$scope.stageCertificate = 0;
					$scope.oldCertificate = null;
					$scope.invalidCertificate = false;

					$scope.closeModalAcess();
				});
		};

		$scope.cleanCertificadoRequired = () => {
			var formElements = document.getElementsByName('createCatch');

			if (formElements.length > 0) {
				var form = formElements[0];

				var formController = window.angular.element(form).controller('form');

				if (formController) {
					formController.$setPristine();
					formController.$setUntouched();
					formController.$submitted = false;
				}
			}
		};

		$scope.closeModalAcess = () => {
			$('#modalCreateCatch').modal('hide');

			$scope.cleanCertificadoRequired();

			$scope.systemJudicialModal.ready = false;

			$scope.cathSuccess = false;

			$scope.changelogin = false;
			$scope.changePassword = false;

			$scope.newCatch = [];

			$scope.$resetFormValidation('createCatch')();

			$('#createCatchCourt').val('');

			setTimeout(() => {
				$('#createCatchCourt').triggerHandler('change');

				$scope.systemJudicialModal.setItems([]);

				// location.reload();
			}, 300);
		};

		$scope.fileChanged = function(element) {
			$scope.$apply(function() {
				let file = element.files[0];

				if (file) {
					// Verifica se a extensão do arquivo é válida (.p12 ou .pfx)
					let validExtensions = ['p12', 'pfx'];
					let fileExtension = file.name
						.split('.')
						.pop()
						.toLowerCase();

					if (!validExtensions.includes(fileExtension)) {
						notification.danger(
							'Tipo de arquivo inválido! Apenas arquivos .p12 ou .pfx são permitidos.'
						);
						element.value = ''; // Limpa o input

						return;
					}

					// Verifica se o nome do arquivo tem mais de 300 caracteres
					if (file.name.length > 300) {
						notification.danger(
							'O nome do arquivo não pode ter mais de 300 caracteres.'
						);
						element.value = ''; // Limpa o input

						return;
					}

					// Remove o arquivo anterior, se existir
					$scope.newCatch.CDigital = null;

					// Atribui o novo arquivo
					$scope.newCatch.CDigital = file;

					// Atualiza o campo de exibição do nome do arquivo
					document.querySelector('.file-input').value = file.name;
				}
			});
		};

		$scope.getNameButton = () => {
			let nameButton = '';

			nameButton =
				(($scope.tipoAcessoFonte &&
					$scope.tipoAcessoFonte.length &&
					$scope.tipoAcessoFonte.includes(-3)) ||
					($scope.tipoAcessoFonte && $scope.tipoAcessoFonte == -3) ||
					($scope.tipoAcessoFonte &&
						$scope.tipoAcessoFonte.length &&
						$scope.tipoAcessoFonte.includes(-5)) ||
					($scope.tipoAcessoFonte && $scope.tipoAcessoFonte == -5)) &&
				$scope.stageCertificate == 1
					? 'Seguinte'
					: 'Cadastrar';

			if ($scope.loadingCertificate || $scope.loadingNewAccess)
				nameButton = 'Carregando';

			return nameButton;
		};

		function invalidarInput() {
			let input = document.getElementById('senhaCDigital');

			// Adiciona a classe de erro para estilização (opcional)
			input.classList.add('is-invalid');

			// Dispara a validação
			input.reportValidity();
		}

		$scope.changeKey = () => {
			if (
				Boolean(
					$scope.oldCertificate &&
						($scope.oldCertificate.senha != $scope.newCatch.senhaCDigital ||
							$scope.oldCertificate.name != $scope.newCatch.CDigital.name)
				)
			)
				$scope.invalidCertificate = false;
			else $scope.invalidCertificate = true;

			if ($scope.invalidCertificate) invalidarInput();
		};

		$scope.getInvalidCertificate = () => {
			if (
				!(
					(Array.isArray($scope.tipoAcessoFonte) &&
						$scope.tipoAcessoFonte.includes(-3)) ||
					$scope.tipoAcessoFonte == -3
				)
			)
				return;

			let invalid = Boolean(
				$scope.oldCertificate &&
					$scope.oldCertificate.senha == $scope.newCatch.senhaCDigital &&
					$scope.oldCertificate.name == $scope.newCatch.CDigital.name
			);

			$scope.invalidCertificate = true;

			return invalid && $scope.invalidCertificate;
		};

		$scope.analizeError = status => {
			let messageError = status.erros && status.erros[0].mensagem;

			if (messageError.includes('senha')) {
				$scope.invalidCertificate = true;

				$scope.oldCertificate = {
					name: $scope.newCatch.CDigital.name,
					senha: $scope.newCatch.senhaCDigital
				};

				invalidarInput();
			}
		};

		$scope.registerDigitalCertificate = () => {
			$scope.loadingCertificate = true;

			// Criar um objeto FormData
			let formData = new FormData();

			formData.append('NomeArquivo', $scope.newCatch.CDigital.name);
			formData.append('SenhaCertificado', $scope.newCatch.senhaCDigital);
			formData.append('Files', $scope.newCatch.CDigital);

			$http({
				...helper.http(API.subpoena, 'cadastrarCertificado'),
				method: 'POST',
				data: formData,
				headers: { 'Content-Type': undefined }, // Deixe o navegador definir corretamente
				transformRequest: angular.identity, // Para evitar transformação automática do AngularJS
				messageOverride: {
					success(response, notify) {
						notify.success('Certificado cadastrado com sucesso.');
					},
					error(response, notify) {
						if (response.data.status.erros.length) {
							notify.danger(response.data.status.erros[0].mensagem);
							$scope.disableMail = false;
						} else notify.danger('Erro ao cadastrar certificado.');
					}
				}
			})
				.then(({ data }) => {
					let certificate = data.itens[0];

					$scope.stageCertificate = 2;
					$scope.loadingCertificate = false;
					$scope.idCertificadoA1Cliente = certificate.idCertificadoA1Cliente;
					$scope.oldCertificate = null;
				})
				.catch(({ data }) => {
					$scope.loadingCertificate = false;
					$scope.oldCertificate = null;
					$scope.analizeError(data.status);
				})
				.finally(() => {
					$scope.loadingCertificate = false;
				});
		};

		$scope.postNewAccess = () => {
			if (
				(($scope.tipoAcessoFonte.length &&
					$scope.tipoAcessoFonte.includes(-3)) ||
					$scope.tipoAcessoFonte == -3 ||
					($scope.tipoAcessoFonte.length &&
						$scope.tipoAcessoFonte.includes(-5)) ||
					$scope.tipoAcessoFonte == -5) &&
				$scope.stageCertificate == 1
			) {
				$scope.registerDigitalCertificate();

				return false;
			} else if (
				(Array.isArray($scope.tipoAcessoFonte) &&
					($scope.tipoAcessoFonte.includes(-3) ||
						$scope.tipoAcessoFonte.includes(-5))) ||
				$scope.tipoAcessoFonte == -3 ||
				$scope.tipoAcessoFonte == -5
			)
				$scope.stageCertificate = 2;

			$scope.loadingNewAccess = true;

			let dados = {
				...$scope.newCatch,
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null,
				idUsuarioCliente: !$scope.groupUserSelected
					? $scope.userData.idUsuarioCliente
					: null
			};

			if (
				(Array.isArray($scope.tipoAcessoFonte) &&
					($scope.tipoAcessoFonte.includes(-3) ||
						$scope.tipoAcessoFonte.includes(-5))) ||
				$scope.tipoAcessoFonte == -3 ||
				$scope.tipoAcessoFonte == -5
			) {
				dados.senha = $scope.newCatch.senhaCDigital;
				dados.idCertificadoA1Cliente = $scope.idCertificadoA1Cliente;

				delete dados.senhaCDigital;
				delete dados.CDigital;
			}

			if (dados.autenticacao === '') delete dados.autenticacao;

			$http({
				...helper.http(API.subpoena, 'POST'),
				data: dados
			})
				.then(() => {
					$scope.$resetFormValidation('createCatch')();

					$scope.cathSuccess = true;
					$scope.newCatch = [];

					if ($rootScope.hasNotAccessSubpoena) {
						$rootScope.hasNotAccessSubpoena = false;
					}
				})

				.finally(() => {
					$scope.loadingNewAccess = false;
				});
		};

		/**
		 * Método que traz Sistema relacionadas ao processo
		 */
		$scope.recordSystem = (responseStore, id) => {
			if (!id && (!$scope.filter || !$scope.filter.orgaoJudicial)) return false;

			$scope.loadingSystem = true;

			$http({
				...helper.http(API.subpoena, 'consultaFonte'),
				params: {
					...helper.httpFields(['*']),
					idOrgaoJudiciario: !id ? $scope.filter.orgaoJudicial : id,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null,
					idUsuarioCliente: !$scope.groupUserSelected
						? $scope.userData.idUsuarioCliente
						: null,
					paginaAtual: 1,
					registrosPorPagina: 999
				}
			})
				.then(response => {
					responseStore.setItems(response.data.itens);

					$scope.tipoAcessoFonte = [];
					$scope.listaFontes = response.data.itens;

					if (!id)
						if ($stateParams.sistema) {
							const sistema = response.data.itens.filter(
								judi => judi.nomeExibicao == $stateParams.sistema
							);

							if ($scope.titleSystem != sistema[0].nomeExibicao) {
								$scope.titleSystem = sistema[0].nomeExibicao;
							}
						}

					if (!response.data.itens.length) $scope.notSystem = true;
					else if (response.data.itens.length) $scope.notSystem = false;
				})

				.finally(() => {
					$scope.loadingSystem = false;
					//resetar select
					$('#createCatchSystem').removeClass('is-valid');
					$scope.cleanCertificadoRequired();
					responseStore.setReady(true);
				});
		};

		$scope.sanitizeNumbers = function() {
			if ($scope.registerOab.numeroOab) {
				$scope.registerOab.numeroOab = $scope.registerOab.numeroOab.replace(
					/\D/g,
					''
				);
			}
		};

		$scope.expandedSystemFilter = false;
		$scope.titleSystem = 'Sistema';

		/************* METODO PARA PASSAR EVENTO PRA SINCRONIZADO *************/
		$scope.modalAddEvent = () => {
			$rootScope.formCreatePrazo.taskToEdit.sincronizado = $rootScope.noSync;
			$scope.formCreatePrazo.taskToEdit.idTipoCompromisso =
				$scope.formCreatePrazo.idTipoCompromisso;
		};

		/** verifica se esta sincronizado com o google agenda */
		$scope.checkSyncDeadlines = async (fn, movement, typeEvent) => {
			if (
				movement &&
				movement.movimento &&
				movement.movimento.andamentoProcesso &&
				movement.movimento.andamentoProcesso.idProcesso &&
				movement.movimento.andamentoProcesso.numeroProcesso
			) {
				$rootScope.formCreatePrazo.taskToEdit.processo = {
					id: movement.movimento.andamentoProcesso.idProcesso,
					nome: movement.movimento.andamentoProcesso.numeroProcesso,
					fixado: true
				};

				if (
					movement.movimento.pastas &&
					movement.movimento.pastas.length > 0 &&
					movement.movimento.pastas[0].nome
				) {
					$rootScope.formCreatePrazo.taskToEdit.processo.nome =
						movement.movimento.pastas[0].nome;
				}
			}

			//Recupera dados de sincronização
			let dataSync = integracaoGoogleCalendar.recoverInfos();

			//aqui google agenda
			if (!dataSync) await integracaoGoogleCalendar.permissionIntegracao();

			//Recupera os dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();

			$rootScope.sincronizacaoError = dataSync.error == true ? true : false;

			if (!$rootScope.sincronizacaoError) {
				//Variavel que guarda se ta sincronizado ou não
				$scope.googleSync = dataSync.sincronizado;
				//Guarda intimação a ser vinculada com prazo
				$scope.movementInAction = movement;

				$rootScope.formCreatePrazo.idsMovProcessosVinculados = [
					{
						idMovProcessoCliente:
							$scope.movementInAction.idMovProcessoCliente ||
							$scope.movementInAction.id
					}
				];
				//Variavel que guarda se ta sincronizado ou não, de forma geral '$rootScope'
				$rootScope.noSync = !dataSync.sincronizado ? true : false;

				$rootScope.formCreatePrazo.idTipoCompromisso = typeEvent;

				//Verifica se e para mostrar mensagem de sincronização
				const showMessage = !integracaoGoogleCalendar.notAgainSincGoogleAgenda();

				if (!$scope.googleSync && showMessage)
					$('#modalSyncAgenda').modal('show');
				else {
					$scope.modalAddEvent();

					fn(movement);
				}
			} else {
				$('#modalDisabledGoogleCalendarError').modal('show');

				$scope.guardDataPrazos = {
					func: fn,
					mov: movement,
					index: 0
				};
			}
		};

		/** Abre modal de criação de agenda */
		$scope.openCreateAgendaEventModal = movement => {
			if (
				permissions.has('recordSchedule') &&
				$scope.agendas.items.length === 0 &&
				$scope.eventsTypes.items.length === 0
			) {
				!$rootScope.idAgenda && $scope.recordAgendas($scope.agendas);
				$scope.recordEventsTypes($scope.eventsTypes);
			}
			$scope.movementsPrazo = { ...movement };
			$rootScope.formCreatePrazo.idPessoaCliente = '';
			$('#modalCreateAgendaEventComponent').modal('show');
		};

		/** Método para verificar os tipos de eventos na agenda */
		$scope.recordEventsTypes = responseStore => {
			const idCliente =
				parseInt(authentication.getUserData('idCliente'), 10) || undefined;

			$http({
				...helper.http(API.eventsTypes, 'GET'),
				params: {
					...helper.httpFields(['id,nome']),
					idCliente,
					ativo: true
				}
			}).then(({ data }) => {
				responseStore.setItems(data.itens);

				// Converte o array para uma string e armazena no Session Storage
				sessionStorage.setItem(
					'__EVENTS_TYPES__',
					JSON.stringify(responseStore.getItems())
				);

				$rootScope.formCreatePrazo.eventsTypes = responseStore;

				$scope.selectedType = data.itens.find(item => item.nome == 'Prazo');

				if ($rootScope.formCreatePrazo.quickCreateEventTypeId) {
					$rootScope.formCreatePrazo.taskToEdit.idTipoCompromisso =
						$rootScope.formCreatePrazo.quickCreateEventTypeId;
					$scope.$applyAsync();
					setTimeout(() => {
						$('#createEventSelectTaskTypeComponent').trigger('change');
					});
				}
			});
		};

		$rootScope.fetchDeadlineNotificationId = () => {
			$http({
				...helper.http(API.agendaReminderTypes, 'GET'),
				params: {
					...helper.httpFields(['*'])
				}
			})
				.then(({ data: { itens } }) => {
					if (itens && itens.length > 0) {
						$scope.eventsNotifications.setItems(itens);
						sessionStorage.setItem(
							'__EVENTS_NOTIFICATIONS__',
							JSON.stringify(itens)
						);
					} else {
						$scope.eventsNotifications.setItems([
							{
								id: -1,
								descricao: 'Sem notificação'
							}
						]);
					}
				})
				.catch(() => {
					$scope.eventsNotifications.setItems([
						{
							id: -1,
							descricao: 'Sem notificação'
						}
					]);

					setTimeout(() => {
						$rootScope.fetchDeadlineNotificationId();
					}, 30000);
				})
				.finally(() => {
					$scope.eventsNotifications.setReady(true);
				});
		};

		$scope.disconnectSyncError = async () => {
			$scope.loadingDisconnectError = true;

			$scope.dataSync = integracaoGoogleCalendar.recoverInfos();

			await integracaoGoogleCalendar.disconnectSync(
				$scope.dataSync.idAgendaGoogleCalendar
			);

			$('#modalDisabledGoogleCalendarError').modal('hide');
			$scope.unsynClicked = true;

			$scope.loadingDisconnectError = false;
			$rootScope.sincronizacaoError = false;

			$scope.openGooogleCalendarModal();
		};

		$scope.openGooogleCalendarModal = async () => {
			const modalRecoverPastDeadlines = $('#modalRecoverPastDeadlines');
			const modalRecoverPastDeadlinesIsOpen =
				modalRecoverPastDeadlines.hasClass('show') ||
				modalRecoverPastDeadlines.hasClass('in') ||
				modalRecoverPastDeadlines.is(':visible');

			if (modalRecoverPastDeadlinesIsOpen) {
				modalRecoverPastDeadlines.one('hidden.bs.modal', function() {
					$timeout(() => {
						$scope.openGooogleCalendarModal();
					}, 100);
				});
				modalRecoverPastDeadlines.modal('hide');

				return;
			}

			if (!$rootScope.sincronizacaoError) await $scope.recordIntegration();

			$rootScope.sync = $scope.dataSync ? $scope.dataSync.sincronizado : false;

			if (!$rootScope.sync && !$rootScope.sincronizacaoError) {
				integracaoGoogleCalendar.initCodeClient();
				$rootScope.sync = false;
			} else {
				$('#modalDisabledGoogleCalendar').modal('show');
			}
		};

		$scope.editTerm = async contentTerm => {
			let dataSync = {};
			const eventTypeId =
				contentTerm.idTipoCompromisso || contentTerm.idTipoEventoAgenda;

			//Recupera dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();

			//aqui google agenda
			if (!dataSync) await integracaoGoogleCalendar.permissionIntegracao();

			//Recupera os dados de sincronização
			dataSync = integracaoGoogleCalendar.recoverInfos();

			$rootScope.sincronizacaoError = dataSync.error == true ? true : false;

			if (!$rootScope.sincronizacaoError) {
				$scope.eventsTypes.getItems().length === 0 &&
					$scope.recordEventsTypes($scope.eventsTypes);

				$rootScope.formCreatePrazo.idTipoCompromisso = eventTypeId;

				const form = $rootScope.formCreatePrazo;

				const evento = {
					...helper.cloneSimpleObject(contentTerm),
					idTipoCompromisso: eventTypeId,
					_dia: moment(contentTerm.dataHoraInicio).format('DD/MM/YYYY'),
					_hora: moment(contentTerm.dataHoraInicio).format('HH:mm'),
					_horaFim: contentTerm.diaInteiro
						? '00:00'
						: moment(contentTerm.dataHoraFim).format('HH:mm'),
					processSelectedValue: ''
				};

				form.editProcessSelectedOptions = [];

				const processo = evento.processo;

				const hasProcess =
					processo &&
					typeof processo === 'object' &&
					processo.id !== undefined &&
					processo.id !== null &&
					processo.id !== '' &&
					processo.nome !== undefined &&
					processo.nome !== null &&
					processo.nome !== '';

				if (hasProcess) {
					evento.processo = {
						...processo,
						nome: String(processo.nome)
					};

					evento.processSelectedValue = evento.processo.nome;

					form.editProcessSelectedOptions = [evento.processo];
				}

				form.editingAgendaEvent = evento;

				if (
					contentTerm.idProcesso &&
					contentTerm.numeroProcesso &&
					$rootScope.formCreatePrazo &&
					$rootScope.formCreatePrazo.editingAgendaEvent
				) {
					const intimacoes = location.href.includes('intimacoes');

					let eventTypeIdAux = intimacoes ? -3 : eventTypeId;

					$rootScope.formCreatePrazo.editingAgendaEvent.processo = {
						id: contentTerm.idProcesso,
						nome: contentTerm.numeroProcesso,
						fixado: eventTypeIdAux == -4 || eventTypeIdAux == -1 ? true : false
					};
				}

				$rootScope.initQuillEdit(
					$rootScope.formCreatePrazo.editingAgendaEvent.observacao,
					'edit'
				);

				$rootScope.formCreatePrazo.editingAgendaEvent.sincronizado = $rootScope
					.formCreatePrazo.editingAgendaEvent.eventoGoogleId
					? true
					: false;

				$rootScope.formCreatePrazo.editingAgendaEvent.dataCurtaFormatada = moment(
					$rootScope.formCreatePrazo.editingAgendaEvent.dataHoraInicio
				).format('DD/MM/YYYY');

				$rootScope.$applyAsync();

				$('#modalEditAgendaEventComponent').modal('show');
			} else {
				$('#modalDisabledGoogleCalendarError').modal('show');

				contentTerm.sincronizado = false;

				$scope.guardDataPrazos = {
					func: contentTerm,
					modal: 'edit'
				};
			}
		};

		$scope.checkNewModuleWarning = () => {
			const value = localStorage.getItem('__mostrarNovoModuloCalculo__');

			if (value == 'null' || isNull(value)) {
				$scope.mostrarMensagemCalculosNovo = true;

				setTimeout(() => {
					localStorage.setItem(
						'__mostrarNovoModuloCalculo__',
						JSON.stringify(1)
					);

					$scope.checkNewModuleWarning();
				}, 1000);
			} else {
				const numberValue = JSON.parse(value);

				if (numberValue <= 6) {
					$scope.mostrarMensagemCalculosNovo = true;

					setTimeout(() => {
						localStorage.setItem(
							'__mostrarNovoModuloCalculo__',
							JSON.stringify(numberValue + 1)
						);

						$scope.checkNewModuleWarning();
					}, 1000);
				} else {
					$scope.mostrarMensagemCalculosNovo = false;

					if (
						$rootScope.$$phase !== '$apply' &&
						$rootScope.$$phase !== '$digest'
					) {
						$rootScope.$apply();
					}
				}
			}
		};

		$scope.fecharMensagemGeradorIaNovo = () => {
			$scope.ocultarMensagemGeradorIaNestaSessao = true;
			$scope.mostrarMensagemGeradorIaNovo = false;
		};

		$scope.checkNewModuleWarningGeradorIa = () => {
			if ($scope.ocultarMensagemGeradorIaNestaSessao) {
				$scope.mostrarMensagemGeradorIaNovo = false;

				return;
			}

			const value = localStorage.getItem('__mostrarNovoModuloGeradorIa__');

			if (value == 'null' || isNull(value)) {
				$scope.mostrarMensagemGeradorIaNovo = true;

				setTimeout(() => {
					localStorage.setItem(
						'__mostrarNovoModuloGeradorIa__',
						JSON.stringify(1)
					);

					$scope.checkNewModuleWarningGeradorIa();
				}, 1000);
			} else {
				const numberValue = JSON.parse(value);

				if (numberValue <= 10) {
					$scope.mostrarMensagemGeradorIaNovo = true;

					setTimeout(() => {
						localStorage.setItem(
							'__mostrarNovoModuloGeradorIa__',
							JSON.stringify(numberValue + 1)
						);

						$scope.checkNewModuleWarningGeradorIa();
					}, 1000);
				} else {
					$scope.mostrarMensagemGeradorIaNovo = false;

					if (
						$rootScope.$$phase !== '$apply' &&
						$rootScope.$$phase !== '$digest'
					) {
						$rootScope.$apply();
					}
				}
			}
		};

		$scope.ensureEventsTypes = () => {
			const cached = sessionStorage.getItem('__EVENTS_TYPES__');

			if (cached) {
				$scope.eventsTypes.setItems(JSON.parse(cached));
				$scope.eventsTypes.setReady(true);
				$rootScope.formCreatePrazo.eventsTypes = $scope.eventsTypes;

				return;
			}

			if (typeof $scope.recordEventsTypes === 'function') {
				$scope.recordEventsTypes($scope.eventsTypes);
				$rootScope.formCreatePrazo.eventsTypes = $scope.eventsTypes;
			}
		};

		$scope.openModalModalRegisterINSSAccount = modalId => {
			$scope.isChangingGerid = false;
			$scope.isRegisteringGerid = false;
			$scope.showRegisterGeridSuccess = false;

			if (modalId == '#modalRegisterINSSAccountDefault') {
				if ($scope.systemsDropdownItems.length == 0) {
					$scope.fetchSearchSources();
				}

				$scope.modalRegisterINSSAccountSuccess = false;
				$scope.registerINSSAccountData = {};
				$scope.showRegisterFields = {
					login: 'disabled',
					password: 'disabled',
					qrCode: 'hidden'
				};

				$scope.registerLoginErrorMessage = '';
				$scope.registerQrCodeErrorMessage = '';

				$scope.isRegisterPasswordValid = true;
			}

			setTimeout(() => {
				$(modalId).modal('show');
			}, 300);
		};

		$scope.ensureSearchSourcesLoaded = () => {
			if (!$scope.systemsDropdownItems || !$scope.systemsDropdownItems.length) {
				$scope.fetchSearchSources();
			}
		};

		$scope.changeRegisterSystem = system => {
			if ($scope.geridId == system.idFonteXTipoPesquisa) {
				$scope.isChangingGerid = true;
			} else {
				$scope.isChangingGerid = false;
			}

			let newRegisterFields = {
				login: 'disabled',
				password: 'disabled',
				qrCode: 'hidden'
			};

			if (
				system &&
				system.tipoAcessoFontePesquisas &&
				system.tipoAcessoFontePesquisas[0]
			) {
				system.tipoAcessoFontePesquisas.forEach(id => {
					switch (id.idTipoAcessoFontePesq) {
						case -1:
							newRegisterFields = {
								...newRegisterFields,
								login: 'show',
								password: 'show'
							};
							break;
						case -2:
							newRegisterFields = {
								...newRegisterFields,
								qrCode: 'show'
							};
							break;
					}
				});
			}
			$scope.showRegisterFields = newRegisterFields;

			setTimeout(() => {
				if (!$scope.isMobile) {
					const inputElement = document.getElementById('inputLoginText');

					if (inputElement) {
						inputElement.focus();
					}
				} else {
					const inputElement = document.getElementById('inputLoginTextMobile');

					if (inputElement) {
						inputElement.focus();
					}
				}
			}, 100);
		};

		$scope.onPasswordBlur = () => {
			const isPasswordValid =
				$scope.registerINSSAccountData &&
				$scope.registerINSSAccountData.password &&
				$scope.registerINSSAccountData.password.length > 0;

			if (!isPasswordValid) {
				$scope.isRegisterPasswordValid = false;
			}
		};

		$scope.openUrl = url => {
			window.open(url, '_blank');
		};

		$scope.resetQRCodeErrorMessage = () => {
			$scope.registerQrCodeErrorMessage = '';
		};

		$scope.registerINSSAccount = data => {
			let hasError = false;

			if (
				!(
					data.login &&
					data.password &&
					$scope.showRegisterFields.qrCode == 'hidden'
				) &&
				!(data.login && data.password && data.qr_code)
			) {
				hasError = true;
			}

			if (!(data.login && data.login.length > 0)) {
				$scope.registerLoginErrorMessage = 'Campo obrigatório.';
				hasError = true;
			}

			const isCPFValid = helper.validateCPF(data.login);
			const isPasswordValid = data.password.length > 0;

			if (!isCPFValid && data.login.length > 0) {
				hasError = true;
				$scope.registerLoginErrorMessage = 'CPF inválido.';

				setTimeout(() => {
					if (!$scope.isMobile) {
						const inputElement = document.getElementById('inputLoginText');

						if (inputElement) inputElement.focus();
					} else {
						const inputElement = document.getElementById(
							'inputLoginTextMobile'
						);

						if (inputElement) inputElement.focus();
					}
				}, 100);
			}

			if (!isPasswordValid) {
				hasError = true;
				$scope.isRegisterPasswordValid = false;

				setTimeout(() => {
					if (!$scope.isMobile) {
						const inputElement = document.getElementById('inputPassword');

						if (inputElement) inputElement.focus();
					} else {
						const inputElement = document.getElementById('inputPasswordMobile');

						if (inputElement) inputElement.focus();
					}
				}, 100);
			}

			if (hasError) return;

			$scope.disableMail = true;

			const itens = [
				{
					idFonteXTipoPesquisa: data.select.idFonteXTipoPesquisa,
					dadoAcesso: data.login,
					senha: data.password,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				}
			];

			if ($scope.geridId == itens[0].idFonteXTipoPesquisa) {
				$scope.isRegisteringGerid = true;
			} else {
				$scope.isRegisteringGerid = false;
				$scope.showRegisterGeridSuccess = false;
			}

			if (data.qr_code && $scope.showRegisterFields.qrCode != 'hidden') {
				itens[0].autenticacao = data.qr_code;
			}

			$http({
				...helper.http(API.sourceAccessData, 'POST'),
				method: 'POST',
				data: { itens },
				messageOverride: { error() {} }
			})
				.then(() => {
					if ($scope.geridId == itens[0].idFonteXTipoPesquisa) {
						$scope.fetchGeridAccess();
						$scope.showRegisterGeridSuccess = true;
					}

					localStorage.setItem('__registerAccess__', JSON.stringify(true));
					localStorage.setItem('__createAccess__', JSON.stringify(true));
					localStorage.setItem('__accessRecords__', JSON.stringify(true));

					$scope.registerAccess = JSON.parse(
						localStorage.getItem('__registerAccess__') || 'false'
					);
					$scope.createAccess = JSON.parse(
						localStorage.getItem('__createAccess__') || 'false'
					);
					$scope.accessRecords = JSON.parse(
						localStorage.getItem('__accessRecords__') || 'false'
					);

					$scope.modalRegisterINSSAccountSuccess = true;

					setTimeout(() => {
						if ($scope.geridId == itens[0].idFonteXTipoPesquisa) {
							$scope.isRegisteringGerid = true;
						} else {
							$scope.isRegisteringGerid = false;
							$scope.showRegisterGeridSuccess = false;
						}
						$scope.disableMail = false;

						let dontShowSuccessRegisterModalAgain = localStorage.getItem(
							'__dontShowSuccessRegisterModalAgain__'
						);

						if (
							dontShowSuccessRegisterModalAgain == null ||
							dontShowSuccessRegisterModalAgain == undefined ||
							dontShowSuccessRegisterModalAgain == false ||
							dontShowSuccessRegisterModalAgain == 'false' ||
							$scope.geridId == itens[0].idFonteXTipoPesquisa
						) {
							$scope.modalRegisterINSSAccountSuccess = true;
						} else {
							$scope.closeModal('#modalRegisterINSSAccount');
						}

						$scope.fetchProcessFilters();

						if ($scope.$$phase !== '$apply' && $scope.$$phase !== '$digest') {
							$scope.$apply();
						}
					}, 100);
				})
				.catch(error => {
					if (
						error.data &&
						error.data.status &&
						error.data.status.erros &&
						error.data.status.erros[0]
					) {
						let errorMessage = error.data.status.erros[0].mensagem;

						if (errorMessage.contains('Erro ao cadastrar dados de acesso. ')) {
							errorMessage = errorMessage.split(
								'Erro ao cadastrar dados de acesso. '
							)[1];
						}

						$scope.registerQrCodeErrorMessage = errorMessage;
					}
				})
				.finally(() => {
					$scope.disableMail = false;
					$scope.isRegisteringGerid = false;
				});
		};

		$scope.onCpfInputBlur = () => {
			if (
				$scope.registerINSSAccountData &&
				$scope.registerINSSAccountData.login &&
				$scope.registerINSSAccountData.login.length > 0
			) {
				let isCPFValid = helper.validateCPF(
					$scope.registerINSSAccountData.login
				);

				if (!isCPFValid) {
					$scope.registerLoginErrorMessage = 'CPF inválido.';
				}
			} else {
				$scope.registerLoginErrorMessage = 'Campo obrigatório.';
			}
		};

		$scope.onCPFInputChange = () => {
			$scope.registerLoginErrorMessage = '';

			if (
				$scope.registerINSSAccountData &&
				$scope.registerINSSAccountData.login &&
				$scope.registerINSSAccountData.login.length - 3 == 11
			) {
				let isCPFValid = helper.validateCPF(
					$scope.registerINSSAccountData.login
				);

				if (!isCPFValid) {
					$scope.registerLoginErrorMessage = 'CPF inválido.';
				} else {
					const inputElement = document.getElementById('inputPassword');

					if (inputElement) {
						inputElement.focus();
					}
				}
			}
		};

		$scope.changeSelectedProcess = taskToEdit => {
			setTimeout(() => {
				const element = $('#btnSelectProcess').length
					? $('#btnSelectProcess')
					: $('#btnSelectProcessSelected');

				if (!element.length) return;

				const select2Data = element.select2('data');
				const selected =
					select2Data && select2Data.length ? select2Data[0] : null;

				const idProcessoAttr = element.attr('ng-custom-model');
				const idPastaAttr = element.attr('ng-process-value');

				const idProcesso =
					selected && selected.idProcesso
						? selected.idProcesso
						: idProcessoAttr;

				const idPasta = selected && selected.id ? selected.id : idPastaAttr;
				const nomeProcesso = selected && selected.text ? selected.text : '';

				if (!taskToEdit.processo) {
					taskToEdit.processo = {};
				}

				taskToEdit.processo.id =
					idProcesso !== undefined && idProcesso !== null && idProcesso !== ''
						? idProcesso
						: null;
				taskToEdit.processo.pasta =
					idPasta !== undefined && idPasta !== null && idPasta !== ''
						? idPasta
						: null;
				taskToEdit.processo.nome = nomeProcesso || taskToEdit.processo.nome;

				$scope.$applyAsync();
			}, 100);
		};

		$scope.onPasswordInputChange = () => {
			$scope.isRegisterPasswordValid = true;
		};

		$scope.fetchSearchSources = () => {
			$http({
				...helper.http(API.searchFontsProcess, 'GET'),
				method: 'GET',
				params: {
					IdTipoPesquisa: -5
				}
			}).then(response => {
				const data = response && response.data ? response.data : null;
				const isSuccess =
					(data && data.codigo == 200) ||
					(data && data.status && data.status.codigo == 200);

				if (isSuccess && data && data.itens) {
					$scope.systemsDropdownItems = data.itens;
				}

				setTimeout(() => {
					$scope.isMobile =
						window && window.innerWidth && window.innerWidth <= 991
							? true
							: false;

					$scope.isLoadingAccessData = false;
					$scope.$apply();
				}, 500);
			});
		};

		setTimeout(() => {
			$('#modalCreateAgendaEventComponent').on('hidden.bs.modal', () => {
				$scope.showMoreOptions = false;
				if ($rootScope.formCreatePrazo.notOnShow)
					$rootScope.formCreatePrazo.notOnShow = false;

				$rootScope.formCreatePrazo.quickCreateEventTypeId = undefined;
				$rootScope.formCreatePrazo.taskToEdit = {
					_dia: moment().format('DD/MM/YYYY'),
					idTipoCompromisso: void 0
				};

				$rootScope.formCreatePrazo.idTipoCompromisso = void 0;
				$rootScope.formCreatePrazo.idPessoaCliente = '';

				$('#createEventSelectTaskTypeComponent').trigger('change');
				$('#createEventInputTaskDate')
					.data('datepicker')
					.clear();

				$scope.$resetFormValidation('createEvent')();
			});

			$('#modalCreateAgendaEventComponent').on('shown.bs.modal', () => {
				$scope.showMoreOptions = false;
				$rootScope.formCreatePrazo.idPessoaCliente = '';

				if (!$rootScope.formCreatePrazo.notOnShow) {
					$rootScope.formCreatePrazo.taskToEdit._dia = moment().format(
						'DD/MM/YYYY'
					);
				}

				$('#createEventInputTaskDate')
					.val($rootScope.formCreatePrazo.taskToEdit._dia)
					.trigger('change');
			});

			$('#modalCreateCatch').on('hidden.bs.modal', () => {
				$scope.closeModalComponentAcess();
			});

			// Comunicação entre janelas (módulos filhos) usando postMessage
			window.addEventListener('message', function(event) {
				// Define a origem permitida: protocolo + host + porta (se aplicável)
				var ALLOWED_ORIGIN = window.location.origin;

				// Verifica se a mensagem veio de uma origem confiável
				if (
					event.origin !== ALLOWED_ORIGIN &&
					!ALLOWED_ORIGIN.includes('dev-')
				) {
					console.warn(
						'Mensagem bloqueada de origem não autorizada:',
						event.origin
					);

					return false;
				}

				// Extrai o tipo da mensagem
				var type = event.data.type;

				if (type === 'REQUEST_AUTH_TOKEN') {
					var token =
						localStorage.getItem('__authenticationToken__') || 'token-invalido';
					var expiresIn = localStorage.getItem('__expires_in__') || '0';

					if (event.source && typeof event.source.postMessage === 'function') {
						event.source.postMessage(
							{
								type: 'AUTH_TOKEN',
								token: token,
								expiresIn: expiresIn
							},
							event.origin
						);
					}
				} else if (type === 'OPEN_COMPONENT_SEND_EMAIL') {
					$rootScope.configSendEmail = {
						action: event.data.action,
						route: event.data.route,
						title: event.data.title
					};

					var el = $('#modalSendEmailComponent');

					setTimeout(function() {
						if (!$rootScope.$$phase) {
							$rootScope.$apply();
						}
					}, 10);

					if (typeof el.modal === 'function') {
						el.modal('show');
					}
				} else if (type === 'OPEN_COMPONENT_MODAL_HUB_FORM') {
					var formEl = $('#modalHubForm');

					setTimeout(function() {
						if (!$rootScope.$$phase) {
							$rootScope.$apply();
						}
					}, 10);

					if (typeof formEl.modal === 'function') {
						$('body').addClass('consultant-form-modal-open');

						formEl
							.off('hidden.bs.modal.consultantForm')
							.on('hidden.bs.modal.consultantForm', () => {
								$('body').removeClass('consultant-form-modal-open');
							})
							.modal('show');
					}
				} else if (type === 'OPEN_COMPONENT_SUBPOENA_CAPTURE') {
					if (typeof $scope.modalCaptura === 'function') {
						setTimeout(function() {
							if (!$rootScope.$$phase) {
								$rootScope.$apply();
							}
						}, 10);

						$scope.modalCaptura();
					}
				} else if (type === 'OPEN_COMPONENT_COMMITMENT') {
					const mov = event.data.movement;
					const typeEvent = event.data.typeEvent;

					$scope.ensureEventsTypes();

					setTimeout(function() {
						if (!$rootScope.$$phase) {
							$rootScope.$apply();
						}
					}, 10);

					$scope.checkSyncDeadlines(
						$scope.openCreateAgendaEventModal,
						mov,
						typeEvent
					);
				} else if (type === 'OPEN_COMPONENT_GROUP') {
					setTimeout(function() {
						if (!$rootScope.$$phase) {
							$rootScope.$apply();
						}
					}, 10);

					$scope.openModalUserGroup();
				} else if (type === 'OPEN_COMPONENT_EDIT_COMMITMENT') {
					const commitment = event.data.commitment;

					setTimeout(function() {
						if (!$rootScope.$$phase) {
							$rootScope.$apply();
						}
					}, 10);

					$scope.editTerm(commitment);
				} else if (type === 'OPEN_COMPONENT_VIEW_SCHEDULE') {
					$scope.openScheduleEventInNewTab(event.data.appointment);
				} else if (type === 'OPEN_COMPONENT_ADD_KEYWORDS') {
					$rootScope.openZendesk();
				} else if (type === 'OPEN_COMPONENT_REGISTER_INSS_ACCOUNT') {
					$scope.openModalModalRegisterINSSAccount(
						'#modalRegisterINSSAccountDefault'
					);
				} else if (type === 'REDIRECT_REGISTERED_ACCESSES') {
					window.location.href = '/inss/acessos';
				} else if (type == 'REGISTER_TOP_BAR_INFO') {
					const oabData = event.data.data;

					$scope.registerOabTopBarInfo = {
						numeroOab: oabData.numeroOab,
						ufOab: oabData.ufOab
					};
				} else if (type == 'SET_TOP_BAR_INFO_OAB') {
					const oabData = event.data.data;

					$rootScope.quickRegisterOabMessage = oabData.quickRegisterOabMessage;

					if (!oabData.firstOab) {
						if ($scope.banners && $scope.banners.length) {
							$scope.banners.splice(1, 0, 'sucessoCadastroAgilOab');
						}

						$scope.showBannerNavigation = Boolean(
							$scope.banners && $scope.banners.length > 1
						);

						$scope.handleMessagesButtonNext('null');
					}
				} else if (type == 'OPEN_REQUEST_CONSULTANT_FORM_MODAL') {
					$scope.openRequestConsultantFormModal();
				}

				// Tipo não reconhecido
				else {
					// eslint-disable-next-line
					// console.error('Tipo de mensagem não reconhecido:', type);

					return false;
				}
			});

			window.addEventListener('keydown', event => {
				const isEsc =
					event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;

				if (isEsc) {
					$scope.clickOutModal();
				}
			});
		}, 1000);

		$scope.redirectDebit = () => {
			if ($scope.loadingDebit) return;

			$scope.loadingDebit = true;

			const openDebit = () => {
				const _PROD = 'https://app.advisecalculo.com.br/';
				const _HOMOLOG = 'https://app.advisecalculo.com.br/';
				const _DEV = 'https://app.arquivosjuridicos.com/';
				const _SANDBOX = 'https://app.arquivosjuridicos.com/';

				function getApiUrl() {
					let currentUrl = window.location.href;

					let apiUrl =
						currentUrl.includes('dev-') || currentUrl.includes('localhost')
							? _DEV
							: currentUrl.includes('homologacao-')
							? _HOMOLOG
							: currentUrl.includes('sandbox-')
							? _SANDBOX
							: _PROD;

					return apiUrl + 'advise#access_token=';
				}

				const baseDebitUrl = getApiUrl();

				$http({
					...helper.http(API.debit, 'POST')
				})
					.then(({ data }) => {
						const token = data.itens[0].token;

						if (!token) return;

						setTimeout(
							() => window.open(baseDebitUrl + token, '_blank', 'noopener'),
							0
						);

						$scope.loadingDebit = false;
					})

					.finally(() => {
						$scope.loadingDebit = false;
					});
			};

			if ($rootScope.$$phase) {
				$timeout(openDebit, 0, false);
			} else {
				openDebit();
			}
		};

		$scope.getPermissionsAdd = parameter => {
			const proc =
				permissions.has('processesWithAutomaticMovementsSearch') ||
				permissions.has('createProcess');
			const schedule =
				permissions.has('recordSchedule') &&
				permissions.has('createAppointments');
			const peoples = permissions.has('createContactType');

			if (parameter == 'processes') return proc;
			if (parameter == 'schedule') return schedule;
			if (parameter == 'peoples') return peoples;

			return proc || schedule || peoples;
		};

		$scope.allowDeadlineRegister = () => {
			if (!$rootScope.formCreatePrazo.taskToEdit) {
				return false;
			}

			if (!$rootScope.formCreatePrazo.taskToEdit.idTipoCompromisso) {
				return false;
			}

			if (
				Number($rootScope.formCreatePrazo.taskToEdit.idTipoCompromisso) ===
					-3 &&
				!$rootScope.formCreatePrazo.taskToEdit.idCategoriaEventoAgenda
			) {
				return false;
			}

			if (
				!$rootScope.formCreatePrazo.taskToEdit.descricao ||
				($rootScope.formCreatePrazo.taskToEdit.descricao &&
					$rootScope.formCreatePrazo.taskToEdit.descricao.length < 3)
			) {
				return false;
			}

			if (!$rootScope.formCreatePrazo.taskToEdit._dia) {
				return false;
			}

			if (
				(!$rootScope.formCreatePrazo.taskToEdit.diaInteiro &&
					!$rootScope.formCreatePrazo.taskToEdit._horaInicio &&
					!$rootScope.formCreatePrazo.taskToEdit._horaFim) ||
				(!$rootScope.formCreatePrazo.taskToEdit.diaInteiro &&
					$rootScope.formCreatePrazo.taskToEdit._horaInicio &&
					$rootScope.formCreatePrazo.taskToEdit._horaFim &&
					$rootScope.formCreatePrazo.taskToEdit._horaInicio.length < 5 &&
					$rootScope.formCreatePrazo.taskToEdit._horaFim.length < 5)
			) {
				return false;
			}

			const selectedEvent = $rootScope.formCreatePrazo.idNotificacaoCompromisso;

			let eventValidation = false;

			switch (selectedEvent) {
				case -1: // Sem notificações
					eventValidation = true;
					break;
				case -2: // 1 hora antes - 1 hora
					eventValidation = $scope.calculateDiffHours(2);
					break;
				case -3: // 1 dia antes - 24 horas
					eventValidation = $scope.calculateDiffHours(25);
					break;
				case -4: // 3 dias antes - 72 horas
					eventValidation = $scope.calculateDiffHours(73);
					break;
				case -5: // 1 semana antes - 168 horas
					eventValidation = $scope.calculateDiffHours(169);
					break;
			}

			if (!eventValidation) {
				return false;
			}

			return true;
		};

		$scope.calculateDiffHours = minDiffTime => {
			if (
				!$rootScope.formCreatePrazo ||
				!$rootScope.formCreatePrazo.taskToEdit ||
				!(
					$rootScope.formCreatePrazo.taskToEdit._horaInicio ||
					$rootScope.formCreatePrazo.taskToEdit.diaInteiro
				) ||
				!$rootScope.formCreatePrazo.taskToEdit._dia
			) {
				return false;
			}

			const slicedDay = $rootScope.formCreatePrazo.taskToEdit._dia.split('/');
			let startHour = [];

			if ($rootScope.formCreatePrazo.taskToEdit.diaInteiro) {
				startHour = ['00', '01'];
			} else {
				startHour = $rootScope.formCreatePrazo.taskToEdit._horaInicio.split(
					':'
				);
			}

			if (slicedDay.length > 1 && startHour.length > 1) {
				const now = new Date(Date.now());

				const limitDate = new Date(
					slicedDay[2],
					slicedDay[1] - 1,
					slicedDay[0],
					startHour[0],
					startHour[1]
				);

				if (limitDate.getTime() < now.getTime()) {
					return false;
				}

				const diffMs = limitDate.getTime() - now.getTime();

				const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

				return diffHours >= minDiffTime;
			}

			return false;
		};

		$scope.calculateDiffHoursEdit = minDiffTime => {
			if (
				!$rootScope.formCreatePrazo ||
				!$rootScope.formCreatePrazo.editingAgendaEvent ||
				!(
					$rootScope.formCreatePrazo.editingAgendaEvent._hora ||
					$rootScope.formCreatePrazo.editingAgendaEvent.diaInteiro
				) ||
				!$rootScope.formCreatePrazo.editingAgendaEvent._dia
			) {
				return false;
			}

			const slicedDay = $rootScope.formCreatePrazo.editingAgendaEvent._dia.split(
				'/'
			);
			let startHour = [];

			if ($rootScope.formCreatePrazo.editingAgendaEvent.diaInteiro) {
				startHour = ['00', '01'];
			} else {
				startHour = $rootScope.formCreatePrazo.editingAgendaEvent._hora.split(
					':'
				);
			}

			if (slicedDay.length > 1 && startHour.length > 1) {
				const now = new Date(Date.now());

				const limitDate = new Date(
					slicedDay[2],
					slicedDay[1] - 1,
					slicedDay[0],
					startHour[0],
					startHour[1]
				);

				if (limitDate.getTime() < now.getTime()) {
					return false;
				}

				const diffMs = limitDate.getTime() - now.getTime();

				const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

				return diffHours >= minDiffTime;
			}

			return false;
		};

		$scope.onTaskDateChange = () => {
			if (
				!$rootScope.formCreatePrazo ||
				!$rootScope.formCreatePrazo.taskToEdit ||
				!(
					$rootScope.formCreatePrazo.taskToEdit._horaInicio ||
					$rootScope.formCreatePrazo.taskToEdit.diaInteiro
				) ||
				!$rootScope.formCreatePrazo.taskToEdit._dia
			) {
				$rootScope.formCreatePrazo.idNotificacaoCompromisso = -1;

				return false;
			}

			const slicedDay = $rootScope.formCreatePrazo.taskToEdit._dia.split('/');
			let startHour = [];

			if ($rootScope.formCreatePrazo.taskToEdit.diaInteiro) {
				startHour = ['00', '01'];
			} else {
				startHour = $rootScope.formCreatePrazo.taskToEdit._horaInicio.split(
					':'
				);
			}

			if (slicedDay.length > 1 && startHour.length > 1) {
				const now = new Date(Date.now());

				const limitDate = new Date(
					slicedDay[2],
					slicedDay[1] - 1,
					slicedDay[0],
					startHour[0],
					startHour[1]
				);

				if (limitDate.getTime() < now.getTime()) {
					$rootScope.formCreatePrazo.idNotificacaoCompromisso = -1;
				}

				const diffMs = limitDate.getTime() - now.getTime();

				const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

				switch ($rootScope.formCreatePrazo.idNotificacaoCompromisso) {
					case -1:
						break;
					case -2:
						if (diffHours < 2)
							$rootScope.formCreatePrazo.idNotificacaoCompromisso = -1;
						break;
					case -3:
						if (diffHours < 25)
							$rootScope.formCreatePrazo.idNotificacaoCompromisso = -2;
						if (diffHours < 2)
							$rootScope.formCreatePrazo.idNotificacaoCompromisso = -1;

						break;
					case -4:
						if (diffHours < 73)
							$rootScope.formCreatePrazo.idNotificacaoCompromisso = -3;
						if (diffHours < 25)
							$rootScope.formCreatePrazo.idNotificacaoCompromisso = -2;
						if (diffHours < 2)
							$rootScope.formCreatePrazo.idNotificacaoCompromisso = -1;

						break;
					case -5:
						if (diffHours < 169)
							$rootScope.formCreatePrazo.idNotificacaoCompromisso = -4;
						if (diffHours < 73)
							$rootScope.formCreatePrazo.idNotificacaoCompromisso = -3;
						if (diffHours < 25)
							$rootScope.formCreatePrazo.idNotificacaoCompromisso = -2;
						if (diffHours < 2)
							$rootScope.formCreatePrazo.idNotificacaoCompromisso = -1;

						break;
				}
			}
		};

		$scope.toggleMoreOptions = () => {
			$scope.showMoreOptions = !$scope.showMoreOptions;
		};

		$scope.onTaskDateChangeEdit = () => {
			if (
				!$rootScope.formCreatePrazo ||
				!$rootScope.formCreatePrazo.editingAgendaEvent ||
				!(
					$rootScope.formCreatePrazo.editingAgendaEvent._hora ||
					$rootScope.formCreatePrazo.editingAgendaEvent.diaInteiro
				) ||
				!$rootScope.formCreatePrazo.editingAgendaEvent._dia
			) {
				$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda = -1;

				return false;
			}

			const slicedDay = $rootScope.formCreatePrazo.editingAgendaEvent._dia.split(
				'/'
			);
			let startHour = [];

			if ($rootScope.formCreatePrazo.editingAgendaEvent.diaInteiro) {
				startHour = ['00', '01'];
			} else {
				startHour = $rootScope.formCreatePrazo.editingAgendaEvent._hora.split(
					':'
				);
			}

			if (slicedDay.length > 1 && startHour.length > 1) {
				const now = new Date(Date.now());

				const limitDate = new Date(
					slicedDay[2],
					slicedDay[1] - 1,
					slicedDay[0],
					startHour[0],
					startHour[1]
				);

				if (limitDate.getTime() < now.getTime()) {
					$rootScope.formCreatePrazo.idNotificacaoCompromisso = -1;
				}

				const diffMs = limitDate.getTime() - now.getTime();

				const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

				switch (
					$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda
				) {
					case -1:
						break;
					case -2:
						if (diffHours < 2)
							$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda = -1;
						break;
					case -3:
						if (diffHours < 25)
							$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda = -2;
						if (diffHours < 2)
							$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda = -1;

						break;
					case -4:
						if (diffHours < 73)
							$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda = -3;
						if (diffHours < 25)
							$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda = -2;
						if (diffHours < 2)
							$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda = -1;

						break;
					case -5:
						if (diffHours < 169)
							$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda = -4;
						if (diffHours < 73)
							$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda = -3;
						if (diffHours < 25)
							$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda = -2;
						if (diffHours < 2)
							$rootScope.formCreatePrazo.editingAgendaEvent.idOpcaoLembreteAgenda = -1;

						break;
				}
			}
		};

		$scope.allowDeadlineEdit = () => {
			if (!$rootScope.formCreatePrazo.editingAgendaEvent) {
				return false;
			}

			if (
				!$rootScope.formCreatePrazo.editingAgendaEvent.titulo ||
				($rootScope.formCreatePrazo.editingAgendaEvent.titulo &&
					$rootScope.formCreatePrazo.editingAgendaEvent.titulo.length < 3)
			) {
				return false;
			}

			if (
				Number(
					$rootScope.formCreatePrazo.editingAgendaEvent.idTipoCompromisso
				) === -3 &&
				!$rootScope.formCreatePrazo.editingAgendaEvent.idCategoriaEventoAgenda
			) {
				return false;
			}

			if (!$rootScope.formCreatePrazo.editingAgendaEvent._dia) {
				return false;
			}

			if (
				(!$rootScope.formCreatePrazo.editingAgendaEvent.diaInteiro &&
					!$rootScope.formCreatePrazo.editingAgendaEvent._hora) ||
				(!$rootScope.formCreatePrazo.editingAgendaEvent.diaInteiro &&
					$rootScope.formCreatePrazo.editingAgendaEvent._hora &&
					$rootScope.formCreatePrazo.editingAgendaEvent._hora.length < 5)
			) {
				return false;
			}

			return true;
		};

		$scope.openModalAddButtons = () => {
			$scope.openMenuAdd = !$scope.openMenuAdd;

			if ($scope.openMenuAdd) {
				$rootScope.exitSubMenuNotification = false;
				$rootScope.tooltipSubMenuNotification = true;
				$('#modal-notification').removeClass('custom-fade');

				if (
					$rootScope.$$phase !== '$apply' &&
					$rootScope.$$phase !== '$digest'
				) {
					$rootScope.$apply();
				}
			}
		};

		$scope.clickOutModal = () => {
			$scope.openMenuAdd = false;
			$scope.$applyAsync();
		};

		$scope.openModalCreatePeople = selector => {
			const iframe = document.querySelector(selector);

			if (!(iframe instanceof HTMLIFrameElement) || !iframe.contentWindow)
				return 'error';

			const msg = { type: 'OPEN_CREATE_PEOPLE' };

			iframe.contentWindow.postMessage(msg, '*');

			return 'ok';
		};

		$scope.openModalCreateSchedule = (selector, eventTypeId) => {
			const iframe = document.querySelector(selector);

			if (!(iframe instanceof HTMLIFrameElement) || !iframe.contentWindow)
				return 'error';

			const msg = { type: 'OPEN_CREATE_SCHEDULE', eventTypeId };

			iframe.contentWindow.postMessage(msg, '*');

			return 'ok';
		};

		$scope.openQuickCreateAgendaEvent = eventTypeId => {
			if (!$scope.getPermissionsAdd('schedule')) return;

			$scope.openMenuAdd = false;
			sessionStorage.setItem(
				'_FAST_CREATE_AGENDA_EVENT_TYPE_',
				String(eventTypeId)
			);

			if (window.location.pathname !== '/agenda') {
				window.location.href = window.location.origin + '/agenda';

				return;
			}

			sessionStorage.removeItem('_FAST_CREATE_AGENDA_EVENT_TYPE_');
			$scope.openModalCreateSchedule('#module-schedule', eventTypeId);
		};

		$scope.openCreates = screen => {
			let openCreate = [];

			openCreate.push(screen);

			sessionStorage.setItem('_FAST_CREATE_', openCreate);

			openCreate.map(_fc => {
				const url = new URL(window.location.href);
				const isSameUrl = window.location.href;
				let keyUrl;
				let sameLocal;
				let redirect;

				if (_fc === 'processes') {
					keyUrl = '/cadastrar-processos';
					sameLocal = new URL(isSameUrl).pathname === keyUrl;

					redirect = keyUrl;

					if (!sameLocal) window.location.href = url.origin + redirect;
				} else if (_fc === 'schedule') {
					keyUrl = '/agenda';
					sameLocal = isSameUrl.includes(keyUrl);

					redirect = keyUrl;

					if (!sameLocal) window.location.href = url.origin + redirect;
					else {
						sessionStorage.setItem('_FAST_CREATE_', '');

						$scope.openModalCreateSchedule('#module-schedule');
					}
				} else if (_fc === 'peoples') {
					keyUrl = '/pessoas';
					sameLocal = isSameUrl.includes(keyUrl);

					redirect = keyUrl;

					if (!sameLocal) window.location.href = url.origin + redirect;
					else {
						sessionStorage.setItem('_FAST_CREATE_', '');

						$scope.openModalCreatePeople('#module-people');
					}
				}
			});

			$scope.openMenuAdd = false;
		};

		$rootScope.openContactPhoneModal = () => {
			if (hasContactPhoneCookie()) return;

			const mainStorage =
				JSON.parse(localStorage.getItem('_MAIN_STORAGE_')) || {};

			const contracts = mainStorage && mainStorage.contracts[0];

			// se tiver contrato aderidos continua com a visualização do modal
			if (!contracts || !contracts.exibirModalCadastroFone) return;

			$scope.contactPhone = '';

			$http({
				...helper.http(API.usersCustomers, 'GET'),
				params: {
					...helper.httpFields([
						'emailUsuario',
						'pessoa.id',
						'pessoa.nome',
						'pessoa.cpfcnpj',
						'pessoa.email'
					]),
					IDs: authentication.getUserData('idUsuarioCliente')
				}
			}).then(async ({ data }) => {
				$scope.dadosUserClient = data.itens[0];

				if (data.itens[0]) {
					mainStorage.dadosUserClient = data.itens[0];

					localStorage.setItem('_MAIN_STORAGE_', JSON.stringify(mainStorage));

					$('#modalContactPhoneUpdate').modal('show');

					$('#modalContactPhoneUpdate').on('shown.bs.modal', function() {
						$('#contactPhoneInput').focus();
					});
				}
			});
		};

		let contactPhoneSavedSuccessfully = false;

		$scope.closeContactPhoneModal = (saved = false) => {
			contactPhoneSavedSuccessfully = saved;

			$('#modalContactPhoneUpdate').modal('hide');
		};

		$('#modalContactPhoneUpdate')
			.off('hidden.bs.modal.contactPhone')
			.on('hidden.bs.modal.contactPhone', () => {
				if (!contactPhoneSavedSuccessfully) {
					setContactPhoneCookie();
				}

				contactPhoneSavedSuccessfully = false;
			});

		$scope.$on('$destroy', () => {
			$('#modalContactPhoneUpdate').off('.contactPhone');
		});

		$scope.formatContactPhone = () => {
			if (!$scope.contactPhone) {
				return;
			}

			let phone = $scope.contactPhone.replace(/\D/g, '');

			if (phone.length > 11) {
				phone = phone.substring(0, 11);
			}

			if (phone.length <= 10) {
				phone = phone.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
			} else {
				phone = phone.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3');
			}

			$scope.contactPhone = phone;
		};

		$scope.saveContactPhone = () => {
			$scope.contactPhoneTouched = true;

			if (!$scope.validateContactPhone() || $scope.contactPhoneSaving) {
				return;
			}

			$scope.contactPhoneSaving = true;

			const phone = $scope.contactPhone
				.replace(/[()-]/g, '')
				.replace(/\s+/g, ' ')
				.trim();

			$http({
				...helper.http(API.usersCustomers, 'PUT'),
				data: {
					itens: [
						{
							id: authentication.getUserData('idUsuarioCliente'),
							pessoa: {
								id: authentication.getUserData('idPessoa'),
								fone1: phone,
								email: $scope.dadosUserClient.pessoa.email,
								nome: $scope.dadosUserClient.pessoa.nome,
								cpfcnpj: $scope.dadosUserClient.pessoa.cpfcnpj
							}
						}
					]
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Seus dados foram salvos com sucesso.');
					}
				}
			})
				.then(() => {
					$scope.closeContactPhoneModal(true);
				})
				.catch(() => {
					notification.danger('Erro ao salvar dados. Tente novamente!');
				})
				.finally(() => {
					$scope.contactPhoneSaving = false;
				});
		};

		const COOKIE_NAME = '__contactPhoneModalDismissed__';
		const COOKIE_EXPIRATION = 7 * 24 * 60 * 60; // 7 dias em segundos

		const getContactPhoneCookieName = () => {
			const userId = authentication.getUserData('idUsuarioCliente');

			return `${COOKIE_NAME}${userId}`;
		};

		const setContactPhoneCookie = () => {
			document.cookie =
				`${getContactPhoneCookieName()}=true; ` +
				`max-age=${COOKIE_EXPIRATION}; ` +
				'path=/; SameSite=Lax';
		};

		const hasContactPhoneCookie = () => {
			const cookieName = getContactPhoneCookieName() + '=';

			return document.cookie
				.split('; ')
				.some(cookie => cookie.startsWith(cookieName));
		};

		$scope.contactPhone = '';
		$scope.contactPhoneTouched = false;
		$scope.contactPhoneValid = false;

		$scope.maskContactPhone = () => {
			let digits = ($scope.contactPhone || '').replace(/\D/g, '');

			// Remove o código do país para evitar duplicação
			if (digits.startsWith('55')) {
				digits = digits.substring(2);
			}

			// Limita a DDD + telefone
			digits = digits.substring(0, 11);

			let formatted = '+55';

			if (digits.length > 0) {
				formatted += ' (';

				if (digits.length <= 2) {
					formatted += digits;
				} else {
					const ddd = digits.substring(0, 2);
					const number = digits.substring(2);
					const prefixLength = digits.length > 10 ? 5 : 4;

					formatted += `${ddd}) `;

					if (number.length > prefixLength) {
						formatted +=
							number.substring(0, prefixLength) +
							'-' +
							number.substring(prefixLength);
					} else {
						formatted += number;
					}
				}
			}

			$scope.contactPhone = formatted;
			$scope.contactPhoneTouched = true;

			$scope.validateContactPhone();
		};

		$scope.validateContactPhone = () => {
			let phone = ($scope.contactPhone || '').replace(/\D/g, '');

			if (phone.startsWith('55')) {
				phone = phone.substring(2);
			}

			$scope.contactPhoneValid = phone.length === 10 || phone.length === 11;

			return $scope.contactPhoneValid;
		};

		$scope.onInit();

		$scope.popupSize = window.innerWidth <= 520 ? window.innerWidth - 20 : 500;
		$scope.registerOabTopbarInfoWidth = window.innerWidth - 160;

		$(window).resize(() => {
			let previousPopupSize = $scope.popupSize;
			let previousRegisterOabTopbarInfoWidth =
				$scope.registerOabTopbarInfoWidth;

			$scope.popupSize =
				window.innerWidth <= 520 ? window.innerWidth - 20 : 500;
			$scope.registerOabTopbarInfoWidth = window.innerWidth - 160;

			if (
				previousPopupSize !== $scope.popupSize ||
				previousRegisterOabTopbarInfoWidth !== $scope.registerOabTopbarInfoWidth
			) {
				$scope.$applyAsync();
			}
		});
	}
]);

export default controller;
